import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { createPortal } from "react-dom";
import * as bootstrap from "bootstrap";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import "../css/sidebar.css";
import "../css/setTargetModal.css";
import iconPie from "../images/iconPie.svg";
import iconGraph from "../images/iconGraph.svg";
import iconLineChart from "../images/iconLineChart.svg";
import iconWalet from "../images/iconWalet.svg";
import { NavLink } from "react-router-dom";
import { Tooltip, Whisper } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import MarketDepthIcon from "../component/MarketDepthIcon";
import SetTargetModal from "../component/SetTargetModal";
import TablePageSizeSelect from "../component/TablePageSizeSelect";
import ChartCard from "../component/ChartCard";
import { TbTarget } from "react-icons/tb";


import LogoApple from "../images/company-logos/apple.svg";
import LogoIgne from "../images/company-logos/igne.svg";
import LogoTesla from "../images/company-logos/tesla.svg";
import LogoJNJ from "../images/company-logos/jnj.svg";
import { Chart } from "primereact/chart";
import { Placeholder } from "rsuite";
import GaugeChart from "react-gauge-chart";

import { SelectPicker, Message } from "rsuite";
import { motion, AnimatePresence } from "framer-motion";
import ArrowTrendUp from "../images/arrow-trend-up.svg";
import ArrowTrendDown from "../images/arrow-trend-down.svg";
import { toast } from "react-toastify";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { EllipsisVertical } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getCurrentLanguage, t, translateColumnLabel } from "../i18n";
import fivePaisaWebSocketService from "../services/fivePaisaWebSocketService";
import angelOneWebSocketService, {
  buildAngelInstrumentFields,
  getAngelExchangeTypeFromHolding,
} from "../services/angelOneWebSocketService";
import fivePaisaMarketDepthStore from "../services/fivePaisaMarketDepthStore";
import growwLivePriceService from "../services/growwLivePriceService";
import angelOneMarketDepthService, {
  normalizeAngelMarketDepth,
} from "../services/angelOneMarketDepthService";


import {
  placeOrderViaPms,
  normalizePlaceOrderResponse,
  isFivePaisaBroker,
  runPlaceOrderAcceptedFlow,
} from "../services/placeOrderService";
import {
  selectActiveBrokerStats,
  useBrokerStatisticsStore,
} from "../stores/brokerStatisticsStore";
import {
  LuTrophy,
  LuFlag,
  LuBriefcase,
  LuTrendingUp,
  LuZap,
  LuBell,
  LuSearch,
  LuHourglass,
  LuChartBar,
  LuThumbsUp,
  LuWrench,
  LuTriangleAlert,
  LuRefreshCcw,
  LuOctagonAlert,
  LuAlarmSmoke,
  LuOctagonX,
} from "react-icons/lu";
import StockCandleModal from "../component/StockCandleModal";
import MarketDepthPopover from "../component/MarketDepthPopover";


const GROW_POLL_SOURCE = "dashboard";

const toPmsBrokerFlag = (brokerType) => {
  const normalized = String(brokerType || "").trim().toLowerCase();
  if (normalized === "grow" || normalized === "5paisa" || normalized === "angelone") {
    return normalized;
  }
  return "5paisa";
};

const CANDLE_CHART_BROKERS = new Set(["5paisa", "angelone"]);

const supportsCandleChart = (brokerType) =>
  CANDLE_CHART_BROKERS.has(String(brokerType || "").trim().toLowerCase());

function Dashboard(props) {
  return <DashboardContent {...props} />;
}

function DashboardContent(props) {
  // All initialization and Declaration
  const pmsApiBaseUrl =
    process.env.REACT_APP_PMS_API_BASE_URL || "https://pmsapi.infomanav.in";
  const value = props.value;
  const rotation = (value / 100) * 180 - 90;


  // LINE CHART
  const [tabName, setTabName] = useState("Dashboard");
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);

  const searchInputRef1 = useRef(null);
  const searchInputRef2 = useRef(null);

  // Inside your component
  const navigate = useNavigate();
  const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());
  const tr = useCallback((key) => t(key, currentLanguage), [currentLanguage]);
  const getItemsRangeText = useCallback(
    (from, to, total) =>
      `${from} ${tr("to")} ${to} ${tr("of")} ${total} ${tr("items")}`,
    [tr],
  );
  const [progress, setProgress] = useState(0);

  const [holdings, setHoldings] = useState([]);
  const [watchlistHoldings, setWatchlistHoldings] = useState([]);
  const [portfolioData, setPortfolioData] = useState([]);
  const [positionData, setPositionData] = useState([]);
  const dashboardStats = useBrokerStatisticsStore(selectActiveBrokerStats);
  const dashboardStatsReady = useBrokerStatisticsStore(
    (state) => state.activeBrokerReady,
  );

  const [subscribedStocks, setSubscribedStocks] = useState([]);
  const [liveUpdateTrigger, setLiveUpdateTrigger] = useState(0);
  const [connected, setConnected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [updateWatchlistTrigger, setUpdateWatchlistTrigger] = useState(0);
  const [updatePortfolioTrigger, setUpdatePortfolioTrigger] = useState(0);
  const [userWatchlists, setUserWatchlists] = useState([]);

  const [hoveredWatchlist, setHoveredWatchlist] = useState(null);

  // Market depth state (stores the latest order book for subscribed stock)
  const [marketDepth, setMarketDepth] = useState([]);
  const [currentMDModal, setcurrentMDModal] = useState(null);
  const [showLoading, setShowLoading] = useState(true);
  const sharedData = JSON.parse(localStorage.getItem("sharedData") || "null");

  const broker_type = String(
    localStorage.getItem("broker_type") || sharedData?.broker_type || "",
  ).toLowerCase();


  // Add this state where you have other states
  const [showMarketDepth, setShowMarketDepth] = useState(false);
  const [marketDepthPosition, setMarketDepthPosition] = useState({
    top: 0,
    left: 0,
  });
  const marketDepthButtonRef = useRef(null);
  const marketDepthPopoverRef = useRef(null);

  const [state, setState] = useState({
    value: 1,
    min: 0,
    max: 100,
  });

  const OrderType = [
    { value: "Market Order", label: tr("marketOrder") },
    { value: "Limit Order", label: tr("limitOrder") },
  ];

  const [orderType, setOrderType] = useState("Market Order");
  // const [qty, setQty] = useState(1);
  const [isPreview, setIsPreview] = useState(false);

  const isGrowBroker =
    String(sharedData?.broker_type || localStorage.getItem("broker_type") || "")
      .toLowerCase() === "grow";
  const isAngelOneBroker =
    String(sharedData?.broker_type || localStorage.getItem("broker_type") || "")
      .toLowerCase() === "angelone";
  const [targetPercentCalculationFlag] = useState("newCalculation");
  // const [targetPercentCalculationFlag] = useState("oldCalculation");
  useEffect(() => {
    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language || getCurrentLanguage());
    };
    const handleStorage = (event) => {
      if (event.key === "appLanguage") {
        setCurrentLanguage(getCurrentLanguage());
      }
    };
    window.addEventListener("app-language-change", handleLanguageChange);
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("app-language-change", handleLanguageChange);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  // Refs for caching live data and WS listeners
  const wsStatusUnsubRef = useRef(null);
  const wsPriceUnsubRef = useRef(null);
  const wsErrorUnsubRef = useRef(null);
  const angelWsPriceUnsubRef = useRef(null);
  const angelWsErrorUnsubRef = useRef(null);
  const angelMdServiceUnsubRef = useRef(null);
  /** Latest feeds to replay after WebSocket reconnect (portfolio + positions + dashboard table). */
  const dashboardSubsRef = useRef({
    portfolio: null,
    positions: null,
    dashboard: null,
    clientCode: null,
  });

  const livePriceCache = useRef({});
  const liveHighCache = useRef({});
  const liveLowCache = useRef({});
  const livePCloseCache = useRef({});
  const liveDiffCache = useRef({});
  const liveChangePercentageCache = useRef({});
  const liveVolumeCache = useRef({});
  const livePLCache = useRef({});
  const currentMDModalRef = useRef(null);
  const holdingsRequestIdRef = useRef(0);
  const watchlistRequestIdRef = useRef(0);

  const [columns, setColumns] = useState([
    "Name",
    "Current Price",
    "Net Change",
    "TodaysHigh",
    "TodaysLow",
    "Initial Price",
    "Target Price",
    "Target %",
    "Notification",
    "Days",
    "DaysLeft",
    "Actions",
  ]);

  // const [columns, setColumns] = useState([
  //   { key: "Name", label: "Name" },
  //   { key: "CurrentPrice", label: "Current Price" },
  //   { key: "PnL", label: "Net Change" },
  //   { key: "initialPrice", label: "Initial Price" },
  //   { key: "TargetPrice", label: "Target Price" },
  //   { key: "Target %", label: "Target %" },
  //   { key: "Notification", label: "Notification" },
  //   { key: "Days", label: "Days" },
  //   { key: "DaysLeft", label: "DaysLeft" },
  //   { key: "Actions", label: "" },
  // ]);

  const [columns2, setColumns2] = useState([
    "Name",
    "Watchlist",
    "Current Price",
    "Net Change",
    "TodaysHigh",
    "TodaysLow",
    "Initial Price",
    "Target Price",
    "Target %",
    "Notification",
    "Days",
    "DaysLeft",
    "Actions",
  ]);

  // const [columns2, setColumns2] = useState([
  //   { key: "Name", label: "Name" },
  //   { key: "CurrentPrice", label: "Current Price" },
  //   { key: "NetChange", label: "Net Change" },
  //   { key: "initialPrice", label: "Initial Price" },
  //   { key: "TargetPrice", label: "Target Price" },
  //   { key: "Target %", label: "Target %" },
  //   { key: "Notification", label: "Notification" },
  //   { key: "Days", label: "Days" },
  //   { key: "DaysLeft", label: "DaysLeft" },
  //   { key: "Actions", label: "" },
  // ]);

  const [buySellModalDetails, setBuySellModalDetails] = useState({
    FullName: "",
    Symbol: "",
    Type: "Buy", // hardcoded for buy function, will create separate for sell
    OrderQty: 1, // default 1
    LimitPrice: 0, // default 0
    order: null, // complete order object for future use
  });

  const formatNumber = (num) => {
    if (num === null || num === undefined) return "-";
    const number = parseFloat(num);
    if (isNaN(number)) return "-";

    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Drag-N-Drop
  // Add these in your component
  const [draggedColumn1, setDraggedColumn1] = useState(null);
  const [columnOrder1, setColumnOrder1] = useState(columns);
  // start with columns prop or state
  const [draggedColumn2, setDraggedColumn2] = useState(null);
  const [columnOrder2, setColumnOrder2] = useState(columns2); // start with columns prop or state

  const [targetDetails, setTargetDetails] = useState();
  const [targetReasonModalData, setTargetReasonModalData] = useState({
    stockName: "",
    reason: "",
    details: "",
  });

  // table search
  const [searchQuery1, setSearchQuery1] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [activeHeaderMenu, setActiveHeaderMenu] = useState(null);
  const [sortConfig1, setSortConfig1] = useState({
    column: null,
    direction: null,
  });
  const [sortConfig2, setSortConfig2] = useState({
    column: null,
    direction: null,
  });

  const [currentPage1, setCurrentPage1] = useState(1);
  const [pageSize1, setPageSize1] = useState(10);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [pageSize2, setPageSize2] = useState(10);
  const [selectedStock, setSelectedStock] = useState(null);

  const getTableColumnAlignment = (col) => {
    const centerAlignedColumns = [
      "Actions",
      "Current Price",
      "Days",
      "DaysLeft",
      "Initial Price",
      "Live Price",
      "Net Change",
      "Notification Time",
      "Profit %",
      "Profit/Loss",
      "ProfitPct",
      "Quantity",
      "Target Price",
      "TodaysHigh",
      "TodaysLow",
      "Trade Price",
      "Volume",
      "52WeekHigh",
      "52WeekLow",
    ];

    return centerAlignedColumns.includes(col) ? "center" : "left";
  };


  const handleRowClick = (holding) => {
    setSelectedStock(holding);
  };


  //----------------------------// useEffects //----------------------------//

  useEffect(() => {
    let cancelled = false;

    const loadDashboard = async () => {
      // if (!sharedData?.ClientCode) {
      //   setPortfolioData([]);
      //   setPositionData([]);
      //   return;
      // }

      dashboardSubsRef.current = {
        portfolio: null,
        positions: null,
        dashboard: null,
        clientCode: null,
      };
      if (!isGrowBroker && !isAngelOneBroker) {
        fivePaisaWebSocketService.connect();
      }

      if (!isGrowBroker && !isAngelOneBroker) {
        if (!sharedData?.accessToken) {
          setPortfolioData([]);
          setPositionData([]);
          return;
        }

        // await Promise.allSettled([
        //   // fetchPortfolioData(
        //   //   sharedData.accessToken,
        //   //   sharedData.ClientCode,
        //   //   sharedData.api_key,
        //   //   [],
        //   // ),
        //   fetchPositionsData(
        //     sharedData.accessToken,
        //     sharedData.ClientCode,
        //     sharedData.api_key,
        //   ),
        // ]);
      } else {
        setPortfolioData([]);
        setPositionData([]);
      }

      if (!cancelled) {
        try {
          await fetchPortfolioHoldings(sharedData.ClientCode);
        } catch (e) {
          console.error("fetchPortfolioHoldings failed:", e);
        }
      }
    };

    loadDashboard();
    return () => {
      cancelled = true;
    };
  }, [updatePortfolioTrigger]);

  useEffect(() => {
    fetchWatchlistHoldings(sharedData.ClientCode);
  }, [updateWatchlistTrigger]);

  useEffect(() => {
    const userId = Number(sharedData?.ID || localStorage.getItem("id") || 0);
    const userEmail =
      sharedData?.Email_ID ||
      sharedData?.email ||
      localStorage.getItem("email") ||
      "";
    if (!userId && !String(userEmail).trim()) return;

    const timeoutId = setTimeout(() => {
      fetchWatchlistHoldings(sharedData.ClientCode, {
        search: searchQuery2,
      });
      setCurrentPage2(1);
    }, 350);

    return () => clearTimeout(timeoutId);
  }, [searchQuery2]);

  useEffect(() => {
    const userId = Number(sharedData?.ID || localStorage.getItem("id") || 0);
    const userEmail =
      sharedData?.Email_ID ||
      sharedData?.email ||
      localStorage.getItem("email") ||
      "";
    if (!userId && !String(userEmail).trim()) return;

    const timeoutId = setTimeout(() => {
      console.log("aaaaa1 search debounce trigger", {
        value: searchQuery1,
        clientCode: sharedData?.ClientCode,
      });
      fetchPortfolioHoldings(sharedData.ClientCode, {
        search: searchQuery1,
      });
      setCurrentPage1(1);
    }, 350);

    return () => clearTimeout(timeoutId);
  }, [searchQuery1]);

  useEffect(() => {
    const data = {
      labels: [
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
      ],
      datasets: [
        {
          label: "Portfolio",
          data: [20, 100, 80, 300, 200, 150, 250, 450, 350, 320, 280, 50],
          borderColor: "#1FB16E",
          tension: 0.4,
          fill: false,
          pointRadius: 5,
          pointHoverRadius: 6,
          pointBackgroundColor: "#fff",
          pointBorderColor: "#1FB16E",
          pointBorderWidth: 2,
        },
      ],
    };

    const options = {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          external: function (context) {
            let tooltipEl = document.getElementById("chartjs-tooltip");

            if (!tooltipEl) {
              tooltipEl = document.createElement("div");
              tooltipEl.id = "chartjs-tooltip";
              tooltipEl.style.position = "absolute";
              tooltipEl.style.background = "#fff";
              tooltipEl.style.border = "0px solid rgba(0,0,0,0.1)";
              tooltipEl.style.borderRadius = "6px";
              tooltipEl.style.boxShadow = "0px 4px 20px rgba(0,0,0,0.1)";
              tooltipEl.style.pointerEvents = "none";
              tooltipEl.style.padding = "8px 12px";
              tooltipEl.style.transition = "all .1s ease";
              tooltipEl.style.color = "#000";

              const table = document.createElement("div");
              tooltipEl.appendChild(table);
              document.body.appendChild(tooltipEl);
            }

            const tooltipModel = context.tooltip;

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return; // ye likhna zaroori hai
            }

            // Set content
            if (tooltipModel.body) {
              const title = tooltipModel.title[0];
              const value = tooltipModel.body[0].lines[0];

              tooltipEl.querySelector("div").innerHTML = `
              <div style="font-size:13px; color:#666;">${title}</div>
              <div style="font-weight:500; font-size:16px;color:#1A1A1A;">${value}</div>
                      `;
            }

            // Positioning
            const { left, top } = context.chart.canvas.getBoundingClientRect();
            const tooltipWidth = tooltipEl.offsetWidth;
            const tooltipHeight = tooltipEl.offsetHeight;

            tooltipEl.style.opacity = 1;
            tooltipEl.style.left =
              left +
              window.pageXOffset +
              tooltipModel.caretX -
              tooltipWidth / 2 +
              "px";
            tooltipEl.style.top =
              top +
              window.pageYOffset +
              tooltipModel.caretY -
              tooltipHeight -
              10 +
              "px"; // -10 for gap
          },
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            color: "#6B7280",
          },
        },
        y: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            color: "#6B7280",
            callback: function (value) {
              return "$" + value;
            },
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  useEffect(() => {
    if (isGrowBroker || isAngelOneBroker) {
      return undefined;
    }

    wsStatusUnsubRef.current = fivePaisaWebSocketService.onStatus((status) => {
      setConnected(status?.type === "connected");
    });
    wsPriceUnsubRef.current = fivePaisaWebSocketService.onPrice((tick) => {
      handleLivePriceUpdate(tick);
    });
    wsErrorUnsubRef.current = fivePaisaWebSocketService.onError((error) => {
      console.error("❌ WebSocket error:", error);
    });

    fivePaisaWebSocketService.connect();
    return () => {
      wsStatusUnsubRef.current?.();
      wsPriceUnsubRef.current?.();
      wsErrorUnsubRef.current?.();
      wsStatusUnsubRef.current = null;
      wsPriceUnsubRef.current = null;
      wsErrorUnsubRef.current = null;
      fivePaisaWebSocketService.disconnect({ manual: false });
    };
  }, [isGrowBroker, isAngelOneBroker]);

  useEffect(() => {
    if (!isAngelOneBroker) {
      return undefined;
    }

    angelWsPriceUnsubRef.current = angelOneWebSocketService.onPrice((tick) => {
      if (tick) handleLivePriceUpdate(tick);
    });
    angelWsErrorUnsubRef.current = angelOneWebSocketService.onError((error) => {
      console.error("❌ AngelOne WebSocket error:", error);
    });

    angelOneWebSocketService.connect();

    return () => {
      angelWsPriceUnsubRef.current?.();
      angelWsErrorUnsubRef.current?.();
      angelWsPriceUnsubRef.current = null;
      angelWsErrorUnsubRef.current = null;
    };
  }, [isAngelOneBroker]);

  useEffect(() => {
    if (!isAngelOneBroker) {
      angelOneMarketDepthService.closeDepth();
      return undefined;
    }

    angelMdServiceUnsubRef.current = angelOneMarketDepthService.subscribe(
      (depth) => {
        setMarketDepth(Array.isArray(depth) ? depth : []);
      },
    );

    return () => {
      angelMdServiceUnsubRef.current?.();
      angelMdServiceUnsubRef.current = null;
      angelOneMarketDepthService.closeDepth();
    };
  }, [isAngelOneBroker]);

  useEffect(() => {
    if (!isGrowBroker) {
      growwLivePriceService.stopPolling(GROW_POLL_SOURCE);
      return undefined;
    }

    const allGrowTargets = [...holdings, ...watchlistHoldings];

    const symbols = Array.from(
      new Set(
        allGrowTargets
          .map((holding) => holding?.LivePriceCacheKey || "")
          .filter(Boolean),
      ),
    );

    if (symbols.length === 0) {
      growwLivePriceService.stopPolling(GROW_POLL_SOURCE);
      return undefined;
    }

    growwLivePriceService.setSymbols(GROW_POLL_SOURCE, symbols);
    const unsubscribe = growwLivePriceService.subscribe((payload) => {
      let updated = false;

      allGrowTargets.forEach((holding) => {
        const cacheKey = holding?.LivePriceCacheKey;
        const ltp = Number(payload?.[cacheKey]);

        if (Number.isFinite(ltp) && cacheKey) {
          livePriceCache.current[cacheKey] = ltp;
          updated = true;
        }
      });

      if (updated) {
        setLiveUpdateTrigger((prev) => prev + 1);
      }
    });

    growwLivePriceService.startPolling(2000);

    return () => {
      unsubscribe?.();
      growwLivePriceService.stopPolling(GROW_POLL_SOURCE);
    };
  }, [isGrowBroker, holdings, watchlistHoldings]);

  useEffect(() => {
    if (isGrowBroker || isAngelOneBroker) {
      return undefined;
    }

    const unsubscribeDepthStore = fivePaisaMarketDepthStore.subscribe((snap) => {
      setMarketDepth(Array.isArray(snap?.activeDepthData) ? snap.activeDepthData : []);
    });

    return () => {
      unsubscribeDepthStore?.();
      fivePaisaMarketDepthStore.closeDepth();
    };
  }, [isGrowBroker, isAngelOneBroker]);

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  useEffect(() => {
    console.log("buySellModalDetails", buySellModalDetails);
  }, [buySellModalDetails]);

  // MarketDepth
  useEffect(() => {
    const modalEl = document.getElementById("MarketDepthModal");
    if (modalEl) {
      // Attach event listener
      modalEl.addEventListener("hidden.bs.modal", handleModalClose);
    }
    // Cleanup when component unmounts
    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleModalClose);
      }
    };
  }, []);

  // Add click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        marketDepthPopoverRef.current &&
        !marketDepthPopoverRef.current.contains(event.target) &&
        marketDepthButtonRef.current &&
        !marketDepthButtonRef.current.contains(event.target)
      ) {
        handleModalClose();
      }
    };

    if (showMarketDepth) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMarketDepth]);

  // Keep ref updated
  useEffect(() => {
    currentMDModalRef.current = currentMDModal;
  }, [currentMDModal]);

  useEffect(() => {
    console.log("📉New Modal Data: ", currentMDModal);
  }, [currentMDModal]);

  useEffect(() => {
    console.log("📉New targetDetails Data: ", targetDetails);
  }, [targetDetails]);

  //----------------------------// Functions //----------------------------//

  // Notification sound function
  const pingNotification = () => {
    try {
      const audio = new Audio("/sounds/notifications.mp3");
      audio.play().catch((error) => {
        console.error("Failed to play notification sound:", error);
      });
    } catch (error) {
      console.error("Error creating audio:", error);
    }
  };

  // Common toast options
  const toastOptions = {
    position: "top-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  };

  // Success toast function
  const showSuccessToast = (message) => {
    toast.success(message, {
      ...toastOptions,
      icon: "✅",
    });
    pingNotification();
  };

  // Error toast function
  const showErrorToast = (message) => {
    toast.error(message, {
      ...toastOptions,
      icon: "⚠️",
    });
    pingNotification();
  };

  // Error toast function
  const showWarningToast = (message) => {
    toast.warn(message, {
      ...toastOptions,
      icon: "⚠️",
    });
    pingNotification();
  };

  //----------------------------// handleMarketDepthClick Functions //----------------------------//

  // Function to handle button click and position popover
  // Update the handleMarketDepthClick function
  const handleMarketDepthClick = (holding, e) => {
    const button = e.currentTarget;
    const buttonRect = button.getBoundingClientRect();

    // Reduced width to 450px
    const popoverWidth = 450;
    const popoverHeight = 500;
    const padding = 16;

    let left = buttonRect.left - popoverWidth - 12; // 12px gap between button and popover
    let top = buttonRect.top - 20;

    // Check if popover goes off-screen on the left
    if (left < padding) {
      // Show to the right instead
      left = buttonRect.right + 12;
    }

    // Check if popover goes off-screen on top
    if (top < padding) {
      top = buttonRect.top + buttonRect.height + 12; // Show below
    }

    // Check if popover goes off-screen on bottom
    if (top + popoverHeight > window.innerHeight - padding) {
      top = window.innerHeight - popoverHeight - padding;
    }

    // Check if popover goes off-screen on right
    if (left + popoverWidth > window.innerWidth - padding) {
      left = window.innerWidth - popoverWidth - padding;
    }

    setMarketDepthPosition({
      top: Math.max(padding, top),
      left: Math.max(padding, left),
    });
    setShowMarketDepth(true);
    setcurrentMDModal(holding);
    if (isAngelOneBroker) {
      const cachedDepth = Array.isArray(holding?.marketDepth)
        ? holding.marketDepth
        : normalizeAngelMarketDepth(holding?.market_quote?.depth);
      if (cachedDepth.length) {
        setMarketDepth(cachedDepth);
      }
    }
    subscribeToMarketDepth(holding);
  };

  const openSetTargetModal = (holding, fallbackCurrentPrice) => {
    const cacheKey = getLivePriceCacheKey(holding);
    const livePrice = cacheKey ? livePriceCache.current?.[cacheKey] : undefined;
    const previousClose = cacheKey
      ? livePCloseCache.current?.[cacheKey]
      : undefined;
    const resolvedCurrentPrice = livePrice ?? fallbackCurrentPrice ?? 0;

    setTargetDetails({
      ...holding,
      initialPrice: resolvedCurrentPrice,
      currentPrice: resolvedCurrentPrice,
      modalCurrentPrice: resolvedCurrentPrice,
      modalPreviousClose:
        previousClose ??
        holding?.["Current Price"] ??
        holding?.previousClose ??
        fallbackCurrentPrice ??
        0,
    });

    const modalElement = document.getElementById("SetTargetModalPortfolio");
    if (modalElement) {
      const modalInstance =
        bootstrap.Modal.getInstance(modalElement) ||
        bootstrap.Modal.getOrCreateInstance(modalElement);
      modalInstance.show();
    }
  };

  //----------------------------// table Search Functions //----------------------------//

  const getSortableValue = useCallback(
    (holding, columnKey) => {
      if (!holding || !columnKey) return "";
      switch (columnKey) {
        case "Name":
          return String(
            holding.full_name || holding.fullName || holding.name || "",
          ).toLowerCase();
        case "Current Price":
          return Number(holding.CurrentPrice || holding.initialPrice || 0);
        case "Net Change":
          return Number(
            holding?.stocks_data?.day_change_perc ??
            holding?.stocks_data?.day_change ??
            0,
          );
        case "Target Price":
          return Number(holding.targetPrice || 0);
        case "Target %": {
          const currentPrice = Number(
            holding.CurrentPrice || holding.initialPrice || 0,
          );
          const targetPrice = Number(holding.targetPrice || 0);
          const percentage = calculateTargetPercentage(
            currentPrice,
            targetPrice,
            holding.target_logic,
          );
          return Number.isFinite(percentage) ? percentage : 0;
        }
        case "Days":
          return Number(holding.days || 0);
        case "DaysLeft":
          return Number(holding.days_remaining || 0);
        default:
          return String(
            holding[columnKey] ??
            holding[columnKey?.replace(/\s+/g, "")] ??
            "",
          ).toLowerCase();
      }
    },
    [calculateTargetPercentage],
  );

  const sortRows = useCallback(
    (rows, sortConfig) => {
      if (!sortConfig?.column || !sortConfig?.direction) return rows;
      const sorted = [...rows].sort((a, b) => {
        const valueA = getSortableValue(a, sortConfig.column);
        const valueB = getSortableValue(b, sortConfig.column);
        if (typeof valueA === "number" && typeof valueB === "number") {
          return valueA - valueB;
        }
        return String(valueA).localeCompare(String(valueB));
      });
      return sortConfig.direction === "desc" ? sorted.reverse() : sorted;
    },
    [getSortableValue],
  );

  const filteredHoldings1 = useMemo(
    () => sortRows(holdings, sortConfig1),
    [holdings, sortConfig1, sortRows],
  );

  const filteredHoldings2 = useMemo(
    () => sortRows(watchlistHoldings, sortConfig2),
    [watchlistHoldings, sortConfig2, sortRows],
  );

  const handleHeaderSort = useCallback((tableKey, column, direction) => {
    if (tableKey === "portfolio") {
      setSortConfig1({ column, direction });
      setCurrentPage1(1);
    } else {
      setSortConfig2({ column, direction });
      setCurrentPage2(1);
    }
    setActiveHeaderMenu(null);
  }, []);

  const renderHeaderMenu = useCallback(
    (tableKey, col, sortConfig) => {
      if (col === "Actions") return null;
      const isOpen =
        activeHeaderMenu?.table === tableKey && activeHeaderMenu?.column === col;
      const selectedDirection =
        sortConfig?.column === col ? sortConfig?.direction : null;
      const menuContent = isOpen ? (
        <div
          className="db-th-menu-popover"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          style={{
            position: "fixed",
            top: activeHeaderMenu?.top ?? 0,
            left: activeHeaderMenu?.left ?? 0,
            width: 184,
            background: "#ffffff",
            borderRadius: 12,
            border: "1px solid #dde3ea",
            boxShadow: "0 10px 24px rgba(18, 34, 51, 0.18)",
            padding: "7px",
            zIndex: 1200,
          }}
        >
          <button
            type="button"
            onClick={() => handleHeaderSort(tableKey, col, "asc")}
            style={{
              width: "100%",
              border: "none",
              background: selectedDirection === "asc" ? "#f4f8ff" : "transparent",
              textAlign: "left",
              padding: "7px 9px",
              borderRadius: 8,
              color: "#44546a",
              fontWeight: 500,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            ↑ Sort Ascending
          </button>
          <button
            type="button"
            onClick={() => handleHeaderSort(tableKey, col, "desc")}
            style={{
              width: "100%",
              border: "none",
              background: selectedDirection === "desc" ? "#f4f8ff" : "transparent",
              textAlign: "left",
              padding: "7px 9px",
              borderRadius: 8,
              color: "#44546a",
              fontWeight: 500,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            ↓ Sort Descending
          </button>
        </div>
      ) : null;
      return (
        <div
          className="db-th-menu-wrap"
          style={{ position: "absolute", right: 6, top: 6 }}
        >
          <button
            type="button"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const rect = e.currentTarget.getBoundingClientRect();
              const menuWidth = 184;
              const viewportPadding = 8;
              const computedLeft = Math.min(
                Math.max(viewportPadding, rect.right - menuWidth),
                window.innerWidth - menuWidth - viewportPadding,
              );
              setActiveHeaderMenu((prev) =>
                prev?.table === tableKey && prev?.column === col
                  ? null
                  : {
                    table: tableKey,
                    column: col,
                    top: rect.bottom + 6,
                    left: computedLeft,
                  },
              );
            }}
            style={{
              border: "none",
              background: "transparent",
              width: 24,
              height: 24,
              padding: 0,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#7f8a99",
              fontSize: 14,
              lineHeight: 1,
              fontWeight: 700,
              cursor: "pointer",
              borderRadius: 6,
            }}
            aria-label={`Open ${col} menu`}
          >
            <EllipsisVertical size={14} strokeWidth={2.2} />
          </button>
          {menuContent && typeof document !== "undefined"
            ? createPortal(menuContent, document.body)
            : null}
        </div>
      );
    },
    [activeHeaderMenu, handleHeaderSort],
  );

  useEffect(() => {
    if (!activeHeaderMenu) return undefined;
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".db-th-menu-wrap, .db-th-menu-popover")) {
        setActiveHeaderMenu(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [activeHeaderMenu]);

  //----------------------------// End table Search Functions //----------------------------//

  const chunkDashboardFeedItems = (items = [], size = 50) => {
    const chunks = [];
    for (let i = 0; i < items.length; i += size) {
      chunks.push(items.slice(i, i + size));
    }
    return chunks;
  };

  const subscribeDashboardFeeds = (items = []) => {
    const marketFeedItems = items
      .map((item) => ({
        Exch: String(item.Exch ?? item.exch ?? "").charAt(0),
        ExchType: String(item.ExchType ?? item.exchType ?? "").charAt(0),
        ScripCode: Number(item.ScripCode ?? item.scripcode ?? item.Scripcode ?? 0),
      }))
      .filter((item) => item.Exch && item.ExchType && item.ScripCode);

    if (!marketFeedItems.length) return;
    fivePaisaWebSocketService.connect();
    fivePaisaWebSocketService.subscribeMarketFeed(marketFeedItems);
  };

  const subscribeAngelDashboardFeeds = (items = []) => {
    const feedItems = items
      .map((item) => ({
        exchangeType: getAngelExchangeTypeFromHolding({
          Exch: item.Exch ?? item.exch,
          ExchSeg: item.ExchSeg ?? item.exch_seg ?? item.Exch,
          ExchType: item.ExchType ?? item.exchType,
          InstrumentType: item.InstrumentType ?? item.instrumenttype,
        }),
        token: String(
          item.LivePriceCacheKey ||
            item.token ||
            item.scripcode ||
            item.scripCode ||
            "",
        ).trim(),
      }))
      .filter((item) => item.exchangeType && item.token);

    if (!feedItems.length) return;
    angelOneWebSocketService.connect();
    chunkDashboardFeedItems(feedItems, 50).forEach((batch) => {
      angelOneWebSocketService.subscribeMarketFeed(batch);
    });
  };

  const subscribeDashboardLiveFeeds = (items = [], brokerFlag = "") => {
    const normalizedBroker = String(brokerFlag || "").toLowerCase();
    if (normalizedBroker === "grow") return;
    if (normalizedBroker === "angelone") {
      subscribeAngelDashboardFeeds(items);
      return;
    }
    if (normalizedBroker === "5paisa") {
      subscribeDashboardFeeds(items);
    }
  };

  // Fetch Portfolio Table
  // const fetchPortfolioData = async (
  //   AccessToken,
  //   ClientCode,
  //   api_key,
  //   columns,
  // ) => {
  //   const url =
  //     "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=getHoldingData";

  //   const data = {
  //     AccessToken,
  //     ClientCode,
  //     api_key,
  //     columns,
  //     userId: sharedData?.ID,
  //   };

  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(data),
  //     });

  //     let responseData;
  //     try {
  //       responseData = await response.json();
  //     } catch (parseError) {
  //       console.warn("Non-JSON response received:", await response.text());
  //       setPortfolioData([]);
  //       return;
  //     }

  //     const holdings = responseData.data || [];
  //     setPortfolioData(holdings);
  //     // setIsLoading(false);
  //     console.log("Portfolio Data for calculations --> :", holdings);

  //     if (responseData.status === "success" && holdings.length > 0) {
  //       dashboardSubsRef.current.portfolio = holdings;
  //       dashboardSubsRef.current.clientCode = ClientCode;
  //       // Update subscribed stocks state for WebSocket
  //       setSubscribedStocks((prev) => {
  //         const newStocks = holdings.map((item) => ({
  //           Scripcode: item.Exch === "N" ? item.NseCode : item.BseCode,
  //           Exch: item.Exch,
  //           ExchType: item.ExchType,
  //           Symbol: item.Symbol,
  //         }));

  //         const merged = [...prev, ...newStocks];
  //         const unique = merged.filter(
  //           (v, i, a) => a.findIndex((t) => t.Scripcode === v.Scripcode) === i,
  //         );

  //         return unique;
  //       });

  //       subscribeDashboardFeeds(
  //         holdings.map((holding) => ({
  //           Exch: holding.Exch,
  //           ExchType: holding.ExchType,
  //           ScripCode: holding.Exch === "N" ? holding.NseCode : holding.BseCode,
  //         })),
  //       );
  //     }

  //     // setProgress(100);
  //   } catch (error) {
  //     console.error("Error fetching holdings:", error);
  //     setPortfolioData([]);
  //     // setIsLoading(false);
  //     // setProgress(100);
  //   }
  // };

  class BaseDashboardPortfolioTargetsAdapter {
    stringOrDefault = (value, fallback = "") =>
      value === null || value === undefined || value === "" ? fallback : String(value);

    numberOrZero = (value) => {
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    };

    normalizeExch = (value) => {
      const raw = this.stringOrDefault(value, "").toUpperCase();
      if (raw.startsWith("B")) return "B";
      if (raw.startsWith("M")) return "M";
      if (raw.startsWith("N")) return "N";
      return "N";
    };

    normalizeExchType = (value) => {
      const raw = this.stringOrDefault(value, "").toUpperCase();
      if (raw.startsWith("C")) return "C";
      return "D";
    };

    normalizeGrowwApiSymbol = (symbol) => {
      if (!symbol) return "";
      return String(symbol).replace(/-/g, "_").trim().toUpperCase();
    };

    parseDateStartOfDay = (value) => {
      const raw = this.stringOrDefault(value, "").trim();
      if (!raw) return null;
      const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
      const date = new Date(normalized);
      if (Number.isNaN(date.getTime())) return null;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    calculateDaysRemaining = (createdAt, targetDays) => {
      const totalDays = this.numberOrZero(targetDays);
      if (totalDays <= 0) return 0;
      const createdDate = this.parseDateStartOfDay(createdAt);
      if (!createdDate) return totalDays;
      const today = new Date();
      const todayStart = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
      );
      const diffMs = todayStart.getTime() - createdDate.getTime();
      const elapsedDays = diffMs > 0 ? Math.floor(diffMs / 86400000) : 0;
      return Math.max(0, totalDays - elapsedDays);
    };

    normalizeTargets = (items = []) => items;
  }

  class FivePaisaDashboardPortfolioTargetsAdapter extends BaseDashboardPortfolioTargetsAdapter {
    normalizeTargets = (items = []) =>
      items.map((item = {}) => {
        const stocksData = item?.stocks_data || {};
        const ohlc = stocksData?.ohlc || {};
        const scripCodeRaw = this.stringOrDefault(item?.scripCode, "");
        const scripCodeNum = this.numberOrZero(scripCodeRaw);
        const currentPrice = this.numberOrZero(
          stocksData?.LastRate ??
          stocksData?.last_price ??
          stocksData?.ltp ??
          ohlc?.close ??
          stocksData?.close ??
          ohlc?.open ??
          stocksData?.open ??
          ohlc?.high ??
          stocksData?.high ??
          ohlc?.low ??
          stocksData?.low ??
          0,
        );
        const previousClose = this.numberOrZero(
          stocksData?.PClose ??
          stocksData?.previous_close ??
          stocksData?.pc ??
          ohlc?.close ??
          stocksData?.close ??
          ohlc?.open ??
          stocksData?.open ??
          0,
        );
        const dayOpen = this.numberOrZero(
          stocksData?.Open ?? ohlc?.open ?? stocksData?.open ?? 0,
        );
        const dayHigh = this.numberOrZero(
          stocksData?.High ?? ohlc?.high ?? stocksData?.high ?? 0,
        );
        const dayLow = this.numberOrZero(
          stocksData?.Low ?? ohlc?.low ?? stocksData?.low ?? 0,
        );
        const dayVolume = this.numberOrZero(
          stocksData?.TotalQty ?? stocksData?.volume ?? 0,
        );

        return {
          ...item,
          Exch: this.normalizeExch(item?.Exch),
          ExchType: this.normalizeExchType(item?.ExchType),
          name: this.stringOrDefault(item?.name, this.stringOrDefault(item?.symbol, "-")),
          symbol: this.stringOrDefault(item?.symbol, "-"),
          scripcode: scripCodeRaw,
          ScripCode: scripCodeNum,
          LivePriceCacheKey: scripCodeNum,
          days_remaining: this.calculateDaysRemaining(
            item?.created_at,
            item?.targetDays,
          ),
          CurrentPrice: currentPrice,
          PreviousClose: previousClose,
          Open: dayOpen,
          TodaysHigh: dayHigh,
          TodaysLow: dayLow,
          volume: dayVolume,
          "52WeekHigh": stocksData?.week_52_high ?? stocksData?.["52WeekHigh"] ?? null,
          "52WeekLow": stocksData?.week_52_low ?? stocksData?.["52WeekLow"] ?? null,
        };
      });
  }

  class AngelOneDashboardPortfolioTargetsAdapter extends BaseDashboardPortfolioTargetsAdapter {
    normalizeTargets = (items = []) =>
      items.map((item = {}) => {
        const stocksData = item?.stocks_data || {};
        const token = this.stringOrDefault(item?.scripCode, item?.token);
        const fields = buildAngelInstrumentFields({
          name: item?.name || item?.full_name,
          symbol: item?.symbol,
          token,
          exch_seg: item?.Exch,
          instrumenttype: item?.instrumenttype,
          expiry: item?.expiry,
        });
        const exch = this.normalizeExch(item?.Exch);
        const exchType =
          exch === "M" || fields.isDerivative
            ? "D"
            : this.normalizeExchType(item?.ExchType);
        const currentPrice = this.numberOrZero(
          stocksData?.ltp ??
            stocksData?.last_price ??
            item?.initialPrice ??
            0,
        );
        const previousClose = this.numberOrZero(
          stocksData?.previous_close ??
            stocksData?.close ??
            stocksData?.PClose ??
            item?.initialPrice ??
            0,
        );
        const dayHigh = this.numberOrZero(
          stocksData?.High ?? stocksData?.high ?? 0,
        );
        const dayLow = this.numberOrZero(
          stocksData?.Low ?? stocksData?.low ?? 0,
        );
        const dayVolume = this.numberOrZero(
          stocksData?.volume ?? stocksData?.TotalQty ?? 0,
        );

        return {
          ...item,
          Exch: exch,
          ExchType: exchType,
          exch,
          exchType,
          ExchSeg: this.stringOrDefault(item?.Exch, ""),
          InstrumentName: fields.instrumentName,
          InstrumentType: fields.instrumentType,
          name: fields.instrumentName,
          symbol: fields.tradingSymbol,
          Symbol: fields.tradingSymbol,
          TradingSymbol: fields.tradingSymbol,
          tradingsymbol: fields.tradingSymbol,
          Token: token,
          fullName: this.stringOrDefault(item?.full_name, fields.fullName),
          full_name: this.stringOrDefault(item?.full_name, fields.fullName),
          scripcode: token,
          ScripCode: this.numberOrZero(token),
          token,
          LivePriceCacheKey: token,
          days_remaining: this.calculateDaysRemaining(
            item?.created_at,
            item?.targetDays,
          ),
          CurrentPrice: currentPrice,
          PreviousClose: previousClose,
          Open: this.numberOrZero(stocksData?.open ?? 0),
          TodaysHigh: dayHigh,
          TodaysLow: dayLow,
          volume: dayVolume,
          "52WeekHigh": stocksData?.week_52_high ?? stocksData?.["52WeekHigh"] ?? null,
          "52WeekLow": stocksData?.week_52_low ?? stocksData?.["52WeekLow"] ?? null,
        };
      });
  }

  class GrowDashboardPortfolioTargetsAdapter extends BaseDashboardPortfolioTargetsAdapter {
    normalizeTargets = (items = []) =>
      items.map((item = {}) => {
        const stocksData = item?.stocks_data || {};
        const ohlc = stocksData?.ohlc || {};
        const scripCodeRaw = this.stringOrDefault(item?.scripCode, "");
        const scripCodeNum = this.numberOrZero(scripCodeRaw);
        const currentPrice = this.numberOrZero(
          stocksData?.last_price ??
          stocksData?.LastRate ??
          stocksData?.ltp ??
          ohlc?.close ??
          stocksData?.close ??
          ohlc?.open ??
          stocksData?.open ??
          ohlc?.high ??
          stocksData?.high ??
          ohlc?.low ??
          stocksData?.low ??
          0,
        );
        const previousClose = this.numberOrZero(
          stocksData?.PClose ?? ohlc?.close ?? stocksData?.close ?? 0,
        );
        const dayOpen = this.numberOrZero(
          stocksData?.Open ?? ohlc?.open ?? stocksData?.open ?? 0,
        );
        const dayHigh = this.numberOrZero(
          stocksData?.High ?? ohlc?.high ?? stocksData?.high ?? 0,
        );
        const dayLow = this.numberOrZero(
          stocksData?.Low ?? ohlc?.low ?? stocksData?.low ?? 0,
        );
        const dayVolume = this.numberOrZero(
          stocksData?.TotalQty ?? stocksData?.volume ?? 0,
        );
        const normalizedExch = this.normalizeExch(item?.Exch);
        const normalizedSymbol = this.stringOrDefault(item?.symbol, "-");
        const exchangePrefix = normalizedExch === "B" ? "BSE" : "NSE";
        const fallbackGrowKey = `${exchangePrefix}_${normalizedSymbol}`;
        const livePriceCacheKey =
          this.normalizeGrowwApiSymbol(item?.stock_groww_symbol) || fallbackGrowKey;

        return {
          ...item,
          Exch: normalizedExch,
          ExchType: this.normalizeExchType(item?.ExchType),
          name: this.stringOrDefault(item?.name, this.stringOrDefault(item?.symbol, "-")),
          symbol: this.stringOrDefault(item?.symbol, "-"),
          scripcode: scripCodeRaw,
          ScripCode: scripCodeNum,
          LivePriceCacheKey: livePriceCacheKey,
          days_remaining: this.calculateDaysRemaining(
            item?.created_at,
            item?.targetDays,
          ),
          CurrentPrice: currentPrice,
          PreviousClose: previousClose,
          Open: dayOpen,
          TodaysHigh: dayHigh,
          TodaysLow: dayLow,
          volume: dayVolume,
          "52WeekHigh": stocksData?.week_52_high ?? stocksData?.["52WeekHigh"] ?? null,
          "52WeekLow": stocksData?.week_52_low ?? stocksData?.["52WeekLow"] ?? null,
        };
      });
  }

  const getDashboardPortfolioTargetsAdapter = (brokerFlag) => {
    const normalizedFlag = String(brokerFlag || "").toLowerCase();
    if (normalizedFlag === "grow")
      return new GrowDashboardPortfolioTargetsAdapter();
    if (normalizedFlag === "angelone")
      return new AngelOneDashboardPortfolioTargetsAdapter();
    if (normalizedFlag === "5paisa")
      return new FivePaisaDashboardPortfolioTargetsAdapter();
    return new BaseDashboardPortfolioTargetsAdapter();
  };

  const fetchPositionsData = async (AccessToken, ClientCode, api_key) => {
    const url =
      "https://Openapi.5paisa.com/VendorsAPI/Service1.svc/V2/NetPositionNetWise";

    const data = {
      head: { key: api_key },
      body: { ClientCode: ClientCode },
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${AccessToken}`,
        },
        body: JSON.stringify(data),
      });

      let responseData;
      try {
        responseData = await response.json();
      } catch (err) {
        console.warn("Non-JSON response:", await response.text());
        setPositionData([]);
        return;
      }

      let positions = responseData?.body?.NetPositionDetail || [];

      // Normalize ScripCode
      positions = positions.map((p) => ({
        ...p,
        ScripCode: p.ScripCode ? Number(p.ScripCode) : 0,
      }));

      console.log("📊 Positions Data:", positions);

      // ✅ STORE
      setPositionData(positions);

      if (positions.length > 0) {
        dashboardSubsRef.current.positions = positions;
        dashboardSubsRef.current.clientCode = ClientCode;
        // ✅ Add to subscribed stocks
        setSubscribedStocks((prev) => {
          const newStocks = positions.map((item) => ({
            Scripcode: item.ScripCode,
            Exch: item.Exch,
            ExchType: item.ExchType,
            Symbol: item.ScripName,
          }));

          const merged = [...prev, ...newStocks];
          const unique = merged.filter(
            (v, i, a) => a.findIndex((t) => t.Scripcode === v.Scripcode) === i,
          );

          return unique;
        });

        subscribeDashboardFeeds(positions);
      }
    } catch (error) {
      console.error("❌ Error fetching positions:", error);
      setPositionData([]);
    }
  };

  // Fetch Portfolio Table
  const fetchPortfolioHoldings = async (ClientCode, options = {}) => {
    const requestId = ++holdingsRequestIdRef.current;
    console.log("aaaaa1 fetchPortfolioHoldings start", {
      requestId,
      clientCode: ClientCode,
      optionsSearch: options?.search,
      stateSearch: searchQuery1,
    });
    let columnsToUse = columns || []; // fallback to existing columns state

    // Fetch column order from API first
    try {
      const userId = Number(sharedData?.ID || localStorage.getItem("id") || 0);
      const userEmail =
        sharedData?.Email_ID ||
        sharedData?.email ||
        localStorage.getItem("email") ||
        "";
      const brokerFlag = String(
        sharedData?.broker_type || localStorage.getItem("broker_type") || "",
      ).toLowerCase();
      const pmsBrokerFlag = toPmsBrokerFlag(brokerFlag);

      const colOrderResponse = await fetch(
        `${pmsApiBaseUrl}/api/v1/columns/list`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            broker_flag: pmsBrokerFlag,
            module_name: "portfolio_target",
            user_id: userId,
            email: userEmail,
          }),
        },
      );

      const colOrderResult = await colOrderResponse.json();

      const colData = colOrderResult?.data;
      const apiColumns = Array.isArray(colData?.columns) ? colData.columns : [];

      if (colData?.status === "success" && apiColumns.length) {
        const dashboardKeyToCol = {
          name: "Name",
          current_price: "Current Price",
          todays_high_low: "TodaysHigh",
          initial_target_price: "Initial Price",
          target: "Target %",
          notification: "Notification",
          days_remaining: "Days",
        };

        const mappedOrder = apiColumns
          .filter(
            (c) =>
              (c?.is_selected === "1" || c?.is_selected === 1 || c?.is_selected === true) &&
              (c?.is_active === "1" || c?.is_active === 1 || c?.is_active === true),
          )
          .sort((a, b) => Number(a?.sort_order || 0) - Number(b?.sort_order || 0))
          .map((c) => dashboardKeyToCol[String(c?.column_key || "").toLowerCase().trim()])
          .filter(Boolean);

        const uniqueOrder = Array.from(new Set(mappedOrder));
        if (uniqueOrder.length) {
          if (!uniqueOrder.includes("Actions")) uniqueOrder.push("Actions");
          setColumnOrder1(uniqueOrder);
          setColumns(uniqueOrder);
          columnsToUse = uniqueOrder; // use updated columns immediately
        } else {
          console.warn("PMS dashboard portfolio_target columns empty after mapping, using default");
        }
      } else {
        console.warn("Failed to fetch column order, using default");
      }
    } catch (error) {
      console.error("Error fetching column order:", error);
    }

    console.log("✅📉Columns is: ", columnsToUse);

    const brokerFlag = String(
      sharedData?.broker_type || localStorage.getItem("broker_type") || "",
    ).toLowerCase();
    const pmsBrokerFlag = toPmsBrokerFlag(brokerFlag);
    const adapter = getDashboardPortfolioTargetsAdapter(pmsBrokerFlag);
    const url = `${pmsApiBaseUrl}/api/v1/dashboard/targets`;

    const data = {
      broker_flag: pmsBrokerFlag,
      source: "portfolio",
      page: 1,
      limit: 20,
      search: String(options?.search ?? searchQuery1 ?? "").trim(),
      user_id: Number(sharedData?.ID || 0),
    };
    console.log("aaaaa1 dashboard targets payload", { requestId, data });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      let responseData;
      try {
        responseData = await response.json();
      } catch (parseError) {
        console.warn("Non-JSON response received:", await response.text());
        if (requestId !== holdingsRequestIdRef.current) return;
        setHoldings([]);
        return;
      }
      const startTime = Date.now();
      const payload = responseData?.data || {};
      const rawItems = Array.isArray(payload?.items) ? payload.items : [];
      const holdings = adapter.normalizeTargets(rawItems);
      console.log("aaaaa1 dashboard targets response", {
        requestId,
        status: payload?.status,
        rawItems: rawItems.length,
        normalized: holdings.length,
      });

      // Ensure loading stays at least 2 seconds
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(3000 - elapsed, 0);

      if (requestId !== holdingsRequestIdRef.current) {
        console.log("aaaaa1 stale response ignored", {
          requestId,
          latestRequestId: holdingsRequestIdRef.current,
        });
        return;
      }
      if (pmsBrokerFlag === "angelone") {
        holdings.forEach((row) => {
          const key = row?.LivePriceCacheKey;
          if (!key) return;
          const ltp = Number(row?.CurrentPrice);
          const pClose = Number(row?.PreviousClose);
          if (Number.isFinite(ltp) && ltp > 0) livePriceCache.current[key] = ltp;
          if (Number.isFinite(pClose) && pClose > 0) {
            livePCloseCache.current[key] = pClose;
          }
        });
      }

      setHoldings(holdings);
      setTimeout(() => {
        if (requestId !== holdingsRequestIdRef.current) return;
        // setIsLoading(false);
        setTimeout(() => {
          if (requestId !== holdingsRequestIdRef.current) return;
          setIsLoading(false);
        }, 2000);
        setShowLoading(false);
      }, remaining);
      console.log("Initial Portfolio Holdings with ScripCode --> :", holdings);

      if (
        String(payload?.status || "").toLowerCase() === "success" &&
        holdings.length > 0
      ) {
        dashboardSubsRef.current.dashboard = holdings;
        dashboardSubsRef.current.clientCode = ClientCode;
        // Update subscribed stocks state for WebSocket
        setSubscribedStocks((prev) => {
          const newStocks = holdings.map((item) => ({
            Scripcode: item.ScripCode, // ✨ Now using the pre-calculated ScripCode
            Exch: item.Exch,
            ExchType: item.ExchType,
            Symbol: item.symbol,
          }));

          const merged = [...prev, ...newStocks];
          const unique = merged.filter(
            (v, i, a) => a.findIndex((t) => t.Scripcode === v.Scripcode) === i,
          );

          return unique;
        });

        subscribeDashboardLiveFeeds(holdings, pmsBrokerFlag);
      }

      setProgress(100);
    } catch (error) {
      console.error("Error fetching holdings:", error);
      console.log("aaaaa1 fetchPortfolioHoldings error", {
        requestId,
        message: error?.message,
      });
      if (requestId !== holdingsRequestIdRef.current) return;
      setHoldings([]);
      // setIsLoading(false);
      setTimeout(() => {
        if (requestId !== holdingsRequestIdRef.current) return;
        setIsLoading(false);
      }, 2000);
      setProgress(100);
    }
  };

  // Fetch watchlist table
  // const fetchWatchlistHoldings = async (AccessToken, ClientCode, api_key, columns) => {
  //   const url = "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=getWatchlistData2";

  //   const data = {
  //     AccessToken,
  //     ClientCode,
  //     api_key,
  //     columns,
  //     userId: sharedData?.ID,
  //   };

  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(data),
  //     });

  //     let responseData;
  //     try {
  //       responseData = await response.json();
  //     } catch (parseError) {
  //       console.warn("Non-JSON response received:", await response.text());
  //       setWatchlistHoldings([]);
  //       return;
  //     }

  //     const holdings = responseData.watchList || [];
  //     setWatchlistHoldings(holdings);
  //     setIsLoading(false);
  //     console.log("Initial Watchlist Holdings --> :", holdings);

  //     // 🔥 Connect to WebSocket after fetching watchlist holdings
  //     handleConnectClick();

  //     if (responseData.message === "success" && holdings.length > 0) {
  //       // Update subscribed stocks state for WebSocket
  //       setSubscribedStocks((prev) => {
  //         const newStocks = holdings.map((item) => ({
  //           Scripcode: item.scripcode,
  //           Exch: item.exch?.charAt(0),
  //           ExchType: item.exchType?.charAt(0),
  //           Symbol: item.name,
  //         }));

  //         const merged = [...prev, ...newStocks];
  //         const unique = merged.filter(
  //           (v, i, a) => a.findIndex((t) => t.Scripcode === v.Scripcode) === i
  //         );

  //         return unique;
  //       });

  //       // 🔥 Subscribe each holding to WebSocket - Wait for connection
  //       const subscribeWhenReady = () => {
  //         // Store holdings for resubscription after reconnects
  //         lastSubscribedHoldings.current = holdings;

  //         const checkConnection = () => {
  //           if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
  //             console.log("🚀 WebSocket ready, subscribing to watchlist holdings...");
  //             holdings.forEach((holding) => {
  //               sendMessageToWebSocket(holding, ClientCode, "Watchlist");
  //             });
  //           } else {
  //             console.log("⏳ Waiting for WebSocket connection...");
  //             setTimeout(checkConnection, 500);
  //           }
  //         };

  //         // Start checking after 1 second
  //         setTimeout(checkConnection, 1000);
  //       };

  //       subscribeWhenReady();
  //     }

  //     setProgress(100);

  //   } catch (error) {
  //     console.error("Error fetching watchlist holdings:", error);
  //     setWatchlistHoldings([]);
  //     setIsLoading(false);
  //     setProgress(100);
  //   }
  // };

  const fetchWatchlistHoldings = async (ClientCode, options = {}) => {
    const requestId = ++watchlistRequestIdRef.current;
    const brokerType = String(
      sharedData?.broker_type || localStorage.getItem("broker_type") || "",
    ).toLowerCase();

    let columnsToUse = columns2 || [];

    // Fetch column order from PMS API first
    try {
      const userId =
        Number(sharedData?.ID || localStorage.getItem("id")) || 0;
      const userEmail =
        sharedData?.Email_ID ||
        sharedData?.email ||
        localStorage.getItem("email") ||
        "";
      const pmsBrokerFlagForColumns = toPmsBrokerFlag(brokerType);

      const colOrderResponse = await fetch(
        "https://pmsapi.infomanav.in/api/v1/columns/list",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            broker_flag: pmsBrokerFlagForColumns,
            module_name: "watchlist_target",
            user_id: userId,
            email: userEmail,
          }),
        },
      );

      const colOrderResult = await colOrderResponse.json();

      if (
        colOrderResult?.data?.status === "success" &&
        Array.isArray(colOrderResult?.data?.columns)
      ) {
        const columnDisplayMap = {
          name: "Name",
          watchlist: "Watchlist",
          current_price: "Current Price",
          todays_high_low: "TodaysHigh",
          initial_target_price: "Initial Price",
          target: "Target %",
          notification: "Notification",
          days_remaining: "Days",
        };

        const orderedCols = [...colOrderResult.data.columns]
          .sort((a, b) => Number(a?.sort_order || 0) - Number(b?.sort_order || 0))
          .map((col) => columnDisplayMap[col?.column_key] || col?.column_label)
          .filter(Boolean);

        if (!orderedCols.includes("Actions")) {
          orderedCols.push("Actions");
        }
        setColumnOrder2(orderedCols);
        setColumns2(orderedCols);
        columnsToUse = orderedCols;
      } else {
        console.warn("Failed to fetch column order, using default");
      }
    } catch (error) {
      console.error("Error fetching column order:", error);
    }

    console.log("✅📉Columns is: ", columnsToUse);

    const pmsBrokerFlag = toPmsBrokerFlag(brokerType);
    const url = `${pmsApiBaseUrl}/api/v1/dashboard/targets`;
    const data = {
      broker_flag: pmsBrokerFlag,
      source: "watchlist",
      page: 1,
      limit: 20,
      search: String(options?.search ?? searchQuery2 ?? "").trim(),
      user_id: Number(sharedData?.ID || 0),
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      let responseData;
      try {
        responseData = await response.json();
      } catch (parseError) {
        console.warn("Non-JSON response received:", await response.text());
        if (requestId !== watchlistRequestIdRef.current) return;
        setWatchlistHoldings([]);
        return;
      }

      const payload = responseData?.data || {};
      const watchlistAdapter = getDashboardPortfolioTargetsAdapter(pmsBrokerFlag);
      const holdings = watchlistAdapter.normalizeTargets(
        Array.isArray(payload?.items) ? payload.items : [],
      ).map((item) => ({
        ...item,
        fullName: item.fullName || item.full_name || item.name,
        name: item.symbol || item.name,
        exch: item.Exch ?? item.exch,
        exchType: item.ExchType ?? item.exchType,
        createdDate: item?.created_at || item.createdDate || "",
      }));

      const uniqueWatchlists = Array.from(
        new Set(
          holdings
            .map((item) => String(item?.source_watchlist || "").trim())
            .filter(Boolean),
        ),
      );
      if (requestId !== watchlistRequestIdRef.current) return;
      if (pmsBrokerFlag === "angelone") {
        holdings.forEach((row) => {
          const key = row?.LivePriceCacheKey;
          if (!key) return;
          const ltp = Number(row?.CurrentPrice);
          const pClose = Number(row?.PreviousClose);
          if (Number.isFinite(ltp) && ltp > 0) livePriceCache.current[key] = ltp;
          if (Number.isFinite(pClose) && pClose > 0) {
            livePCloseCache.current[key] = pClose;
          }
        });
      }
      setUserWatchlists(uniqueWatchlists);
      setWatchlistHoldings(holdings);
      setTimeout(() => {
        if (requestId !== watchlistRequestIdRef.current) return;
        setIsLoading(false);
      }, 2000);
      console.log("Transformed Watchlist Holdings --> :", holdings);

      if (String(payload?.status || "").toLowerCase() === "success" && holdings.length > 0) {
        // Update subscribed stocks state for WebSocket
        setSubscribedStocks((prev) => {
          const newStocks = holdings.map((item) => ({
            Scripcode: item.ScripCode,
            Exch: item.Exch,
            ExchType: item.ExchType,
            Symbol: item.symbol || item.name,
          }));

          const merged = [...prev, ...newStocks];
          const unique = merged.filter(
            (v, i, a) => a.findIndex((t) => t.Scripcode === v.Scripcode) === i,
          );

          return unique;
        });

        subscribeDashboardLiveFeeds(holdings, pmsBrokerFlag);
      }

      setProgress(100);
    } catch (error) {
      console.error("Error fetching watchlist holdings:", error);
      if (requestId !== watchlistRequestIdRef.current) return;
      setWatchlistHoldings([]);
      setTimeout(() => {
        if (requestId !== watchlistRequestIdRef.current) return;
        setIsLoading(false);
      }, 2000);
      setProgress(100);
    }
  };

  //----------------------------//  target % notification Functions //----------------------------//
  const getLivePriceCacheKey = (holding = {}) => {
    if (!holding) return "";
    if (isAngelOneBroker) {
      return String(
        holding?.LivePriceCacheKey ||
          holding?.token ||
          holding?.scripcode ||
          holding?.scripCode ||
          "",
      ).trim();
    }
    if (!isGrowBroker) {
      return holding?.ScripCode || holding?.scripcode || "";
    }
    if (holding?.LivePriceCacheKey) {
      return holding.LivePriceCacheKey;
    }
    const rawSymbol = String(holding?.Symbol || holding?.symbol || holding?.name || "")
      .trim()
      .toUpperCase();
    if (!rawSymbol) return "";
    const exchRaw = String(holding?.Exch || holding?.exch || "N").toUpperCase();
    const exchangePrefix = exchRaw.startsWith("B") ? "BSE" : "NSE";
    return `${exchangePrefix}_${rawSymbol}`;
  };

  function calculateTargetPercentage(currentPrice, targetPrice, targetLogic) {
    const parsedCurrentPrice = Number(currentPrice);
    const parsedTargetPrice = Number(targetPrice);

    if (
      !Number.isFinite(parsedCurrentPrice) ||
      !Number.isFinite(parsedTargetPrice) ||
      parsedTargetPrice === 0
    ) {
      return null;
    }

    if (targetPercentCalculationFlag === "oldCalculation") {
      return ((parsedCurrentPrice - parsedTargetPrice) / parsedTargetPrice) * 100 + 100;
    }

    if (targetLogic === "lower_target") {
      return 100 - ((parsedCurrentPrice - parsedTargetPrice) / parsedTargetPrice) * 100;
    }

    return ((parsedCurrentPrice - parsedTargetPrice) / parsedTargetPrice) * 100 + 100;
  }

  const checkStockTargets = () => {
    const targetPercentages = [];
    watchlistHoldings.forEach((holding) => {
      const target = parseFloat(holding.targetPrice);
      const cacheKey = getLivePriceCacheKey(holding);
      const scripCode = holding.ScripCode;
      const livePrice = parseFloat(livePriceCache.current[cacheKey]);

      // console.log("zxcv")
      // console.log("zxcv")
      // console.log("zxcv")
      // console.log("zxcv")

      // console.log("zxcv fullName: ", holding.fullName)
      // console.log("zxcv initial price: ", initial)
      // console.log("zxcv target price: ", target)

      const currentPrice = !isNaN(livePrice)
        ? livePrice
        : parseFloat(
          holding.CurrentPrice ??
          holding["Current Price"] ??
          holding.initialPrice ??
          0,
        );
      // console.log("zxcv Current price: ", currentPrice)
      // Skip if any values are invalid
      if (
        isNaN(target) ||
        isNaN(currentPrice)
      ) {
        targetPercentages.push({
          name: holding.fullName || holding.name || holding.symbol || "-",
          scripCode,
          percent: null,
        });
        return;
      }

      const targetLogic = holding.target_logic;
      const isNotified = Number(holding.isNotified);
      const percent = calculateTargetPercentage(currentPrice, target, targetLogic);
      if (percent === null) {
        targetPercentages.push({
          name: holding.fullName || holding.name || holding.symbol || "-",
          scripCode,
          percent: null,
        });
        return;
      }
      targetPercentages.push({
        name: holding.fullName || holding.name || holding.symbol || "-",
        scripCode,
        percent: Number(percent.toFixed(2)),
      });

      // console.log("zxcv Percentage: ",percent)
      // console.log("zxcv isNotified: ",isNotified)

      // Check if target reached (>= 100%) and not yet notified
      if (percent >= 100 && isNotified === 0) {
        // Legacy notifyWatchlistTarget API (beta zerodha) – disabled; replace with PMS when ready.
        // const payload = {
        //   userId: holding.user_id,
        //   source: "watchlist",
        //   scripcode: holding.ScripCode,
        //   exch: holding?.exch?.charAt(0),
        //   exchType: holding?.exchType?.charAt(0),
        //   name: holding.symbol,
        //   FullName: holding.fullName || holding.name,
        //   targetPrice: holding.targetPrice,
        //   initialPrice: holding.initialPrice,
        //   target_logic: holding.target_logic,
        // };
        // console.log("zxcv Condition matched, sending payload: ", payload);
        // fetch(
        //   "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=notifyWatchlistTarget",
        //   {
        //     method: "POST",
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify(payload),
        //   },
        // )
        //   .then((response) => response.json())
        //   .then((data) => {
        //     if (data.status === "success") {
        //       console.log(
        //         `zxcv Notification sent successfully for ${holding.name}`,
        //       );
        //       showSuccessToast(
        //         `Hurry!, ${holding.name} has reached the target percentage`,
        //       );
        //       holding.isNotified = 1;
        //       setUpdateWatchlistTrigger(updateWatchlistTrigger + 1);
        //     } else {
        //       console.error("zxcv Notification failed:", data.message);
        //     }
        //   })
        //   .catch((error) => {
        //     console.error("zxcv Error sending notification:", error);
        //   });

        console.log(`zxcv Target notification triggered for ${holding.name}`);
      }
    });
    console.log("target:", targetPercentages);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      console.log("✅✅✅Running 5 sec check");
      checkStockTargets();
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval); // Cleanup
  }, [watchlistHoldings, livePriceCache]);

  const checkPortfolioTargets = () => {
    holdings.forEach((stock) => {
      const target = parseFloat(stock.targetPrice);
      const cacheKey = getLivePriceCacheKey(stock);
      const livePrice = parseFloat(livePriceCache.current[cacheKey]);
      const currentPrice = !isNaN(livePrice)
        ? livePrice
        : parseFloat(stock["Current Price"]);

      // Skip if any values are invalid
      if (isNaN(target) || isNaN(currentPrice)) {
        return;
      }

      const targetLogic = stock.target_logic;
      let isNotified = Number(stock.isNotified);
      const percent = calculateTargetPercentage(currentPrice, target, targetLogic);
      if (percent === null) return;

      // Check if target reached (>= 100%) and not yet notified
      if (percent >= 100 && isNotified === 0) {
        // Call API to send notification
        const payload = {
          userId: sharedData.ID, // Add userId to your portfolio data
          source: "portfolio",
          // scripcode: stock.Exch === "B" ? stock.BseCode : stock.NseCode, // Use NseCode or BseCode as scripcode
          scripcode: stock.ScripCode, // Use NseCode or BseCode as scripcode
          exch: stock.Exch, // Already single character 'N' or 'B'
          exchType: stock.ExchType, // Already single character 'C' or 'D'
          name: stock.name,
          FullName: stock.name,
          targetPrice: stock.targetPrice,
          initialPrice: stock.initialPrice,
          target_logic: stock.target_logic,
        };

        fetch(
          "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=notifyPortfolioTarget",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (data.status === "success") {
              console.log(
                `✅ Portfolio notification sent successfully for ${stock.Symbol}`,
              );
              showSuccessToast(
                `Hurry!, ${stock.name} has reached the target percentage`,
              );

              // Update local state to reflect isNotified = 1
              stock.isNotified = 1;
              setUpdatePortfolioTrigger((prev) => prev + 1); // Trigger portfolio refresh
            } else if (data.status === "warning") {
              console.warn(
                "⚠️ Notification sent but database not updated:",
                data.message,
              );
            } else {
              console.error("❌ Notification failed:", data.message);
            }
          })
          .catch((error) => {
            console.error("❌ Error sending portfolio notification:", error);
            // Optional: Show error toast to user
            // showErrorToast('Failed to send notification. Please try again.');
          });

        console.log(
          `✅ Portfolio target notification triggered for ${stock.Symbol}`,
        );
      }
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      checkPortfolioTargets();
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval); // Cleanup
  }, [holdings, livePriceCache]);

  //----------------------------// Dashboard cards calculation Functions //----------------------------//

  const getTotalInvested = (portfolioData) => {
    if (!Array.isArray(portfolioData)) return 0;

    return portfolioData.reduce((total, holding) => {
      const avgRate = parseFloat(holding.AvgRate) || 0;
      const qty = parseInt(holding.DPQty) || 0;

      return total + avgRate * qty;
    }, 0);
  };

  const getCurrentValue = (portfolioData, livePriceCache) => {
    if (!Array.isArray(portfolioData)) return 0;

    return portfolioData.reduce((total, holding) => {
      const qty = parseFloat(holding.DPQty) || 0;
      const scripCode =
        holding.Exch === "N" ? holding.NseCode : holding.BseCode;

      const livePrice = livePriceCache?.current?.[scripCode];
      const price = livePrice
        ? parseFloat(livePrice)
        : parseFloat(holding.CurrentPrice) || 0;

      return total + qty * price;
    }, 0);
  };

  const getOverallPL = (portfolioData, livePriceCache) => {
    const investedValue = getTotalInvested(portfolioData);
    const currentValue = getCurrentValue(portfolioData, livePriceCache);

    const pl = currentValue - investedValue;

    let percent = 0;
    if (investedValue > 0) {
      percent = (pl / investedValue) * 100;
    }

    return {
      pl,
      percent,
    };
  };

  const getTodaysPL = (portfolioData, livePriceCache, livePCloseCache) => {
    if (!Array.isArray(portfolioData)) {
      return { totalPL: 0, percent: 0, totalPrev: 0 };
    }

    let totalPL = 0;
    let totalPreviousDayValue = 0;

    portfolioData.forEach((holding) => {
      const qty = parseFloat(holding.DPQty) || 0;
      const scripCode =
        holding.Exch === "N" ? holding.NseCode : holding.BseCode;

      const livePrice = livePriceCache?.current?.[scripCode];
      const pClose = livePCloseCache?.current?.[scripCode];

      const currentPrice = livePrice
        ? parseFloat(livePrice)
        : parseFloat(holding.CurrentPrice) || 0;
      const previousClose = pClose
        ? parseFloat(pClose)
        : parseFloat(holding.CurrentPrice) || 0;

      const dailyPL = (currentPrice - previousClose) * qty;
      const previousDayValue = previousClose * qty;

      totalPL += dailyPL;
      totalPreviousDayValue += previousDayValue;
    });

    const percent =
      totalPreviousDayValue > 0 ? (totalPL / totalPreviousDayValue) * 100 : 0;

    return {
      totalPL,
      percent,
      totalPrev: totalPreviousDayValue,
    };
  };

  const getPositionCurrentValue = (positionData, livePriceCache) => {
    if (!Array.isArray(positionData)) return 0;

    return positionData.reduce((total, pos) => {
      const qty = parseFloat(pos.NetQty) || 0;
      const multiplier = parseFloat(pos.Multiplier) || 1;

      const scripCode = pos.ScripCode;
      const livePrice = livePriceCache?.current?.[scripCode];

      const price = livePrice
        ? parseFloat(livePrice)
        : parseFloat(pos.LTP) || 0;

      return total + price * qty * multiplier;
    }, 0);
  };

  const getPositionInvestedValue = (positionData) => {
    if (!Array.isArray(positionData)) return 0;

    return positionData.reduce((total, pos) => {
      const qty = parseFloat(pos.NetQty) || 0;
      const multiplier = parseFloat(pos.Multiplier) || 1;

      const rate =
        pos.BuyQty > 0
          ? parseFloat(pos.BuyAvgRate) || 0
          : parseFloat(pos.AvgRate) || 0;

      return total + qty * rate * multiplier;
    }, 0);
  };

  const getPositionTodaysPL = (
    positionData,
    livePriceCache,
    livePCloseCache,
  ) => {
    if (!Array.isArray(positionData)) {
      return { totalPL: 0, percent: 0, totalPrev: 0 };
    }

    let totalPL = 0;
    let totalPrev = 0;

    positionData.forEach((pos) => {
      const qty = parseFloat(pos.NetQty) || 0;
      const multiplier = parseFloat(pos.Multiplier) || 1;

      const scripCode = pos.ScripCode;

      const livePrice = livePriceCache?.current?.[scripCode];
      const pClose = livePCloseCache?.current?.[scripCode];

      const currentPrice = livePrice
        ? parseFloat(livePrice)
        : parseFloat(pos.LTP) || 0;

      const prevClose = pClose
        ? parseFloat(pClose)
        : parseFloat(pos.PreviousClose) || 0;

      const pl = (currentPrice - prevClose) * qty * multiplier;
      const prevVal = prevClose * qty * multiplier;

      totalPL += pl;
      totalPrev += prevVal;
    });

    const percent = totalPrev !== 0 ? (totalPL / totalPrev) * 100 : 0;

    return { totalPL, percent, totalPrev };
  };

  const getPositionOverallPL = (positionData, livePriceCache) => {
    const invested = getPositionInvestedValue(positionData);
    const current = getPositionCurrentValue(positionData, livePriceCache);

    const pl = current - invested;

    const percent = invested !== 0 ? (pl / invested) * 100 : 0;

    return { pl, percent };
  };

  const portfolioInvested = getTotalInvested(portfolioData);
  const portfolioCurrent = getCurrentValue(portfolioData, livePriceCache);
  const portfolioToday = getTodaysPL(
    portfolioData,
    livePriceCache,
    livePCloseCache,
  );
  const portfolioOverall = getOverallPL(portfolioData, livePriceCache);

  const positionInvested = getPositionInvestedValue(positionData);
  const positionCurrent = getPositionCurrentValue(positionData, livePriceCache);
  const positionToday = getPositionTodaysPL(
    positionData,
    livePriceCache,
    livePCloseCache,
  );
  const positionOverall = getPositionOverallPL(positionData, livePriceCache);

  const totalInvested = portfolioInvested + positionInvested;
  const totalCurrent = portfolioCurrent + positionCurrent;

  const totalPL = totalCurrent - totalInvested;
  const totalPLPercent =
    totalInvested !== 0 ? (totalPL / totalInvested) * 100 : 0;

  const totalTodayPL = portfolioToday.totalPL + positionToday.totalPL;

  const totalPrevValue = portfolioToday.totalPrev + positionToday.totalPrev;

  const cardsTotalInvested = Number(dashboardStats?.total_investment_amount) || 0;
  const cardsCurrentValue = Number(dashboardStats?.current_value) || 0;
  const cardsOverallPL = Number(dashboardStats?.overall_profit_loss) || 0;
  const cardsOverallPercent =
    cardsTotalInvested !== 0 ? (cardsOverallPL / cardsTotalInvested) * 100 : 0;
  const cardsTodayPL =
    dashboardStats?.today_profit_loss === null ||
      dashboardStats?.today_profit_loss === undefined
      ? 0
      : Number(dashboardStats?.today_profit_loss) || 0;
  const hasApiTodayPLPercent =
    dashboardStats?.today_profit_loss_percentage !== null &&
    dashboardStats?.today_profit_loss_percentage !== undefined &&
    Number.isFinite(Number(dashboardStats?.today_profit_loss_percentage));
  const cardsTodayPercent =
    hasApiTodayPLPercent
      ? Number(dashboardStats?.today_profit_loss_percentage) || 0
      : totalPrevValue !== 0
        ? (cardsTodayPL / totalPrevValue) * 100
        : 0;

  //----------------------------// End target % notification Functions //----------------------------//

  // Handle Live Price Updates
  const handleLivePriceUpdate = (data) => {
    const {
      Token: scriptCode,
      LastRate: lastRateValue,
      PClose,
      Volume,
      High, // ✅ Added
      Low, // ✅ Added
    } = data;

    if (!scriptCode || lastRateValue === undefined) return;

    if (!livePriceCache.current) livePriceCache.current = {};
    if (!livePCloseCache.current) livePCloseCache.current = {};
    if (!liveDiffCache.current) liveDiffCache.current = {};
    if (!liveChangePercentageCache.current)
      liveChangePercentageCache.current = {};
    if (!liveVolumeCache.current) liveVolumeCache.current = {};
    if (!livePLCache.current) livePLCache.current = {};
    if (!liveHighCache.current) liveHighCache.current = {}; // ✅ Added
    if (!liveLowCache.current) liveLowCache.current = {}; // ✅ Added

    livePriceCache.current[scriptCode] = lastRateValue;
    livePCloseCache.current[scriptCode] = PClose;
    liveDiffCache.current[scriptCode] = lastRateValue - PClose;
    liveChangePercentageCache.current[scriptCode] =
      ((lastRateValue - PClose) / PClose) * 100;
    liveVolumeCache.current[scriptCode] = Volume;
    liveHighCache.current[scriptCode] = High; // ✅ Added
    liveLowCache.current[scriptCode] = Low; // ✅ Added

    const totalPL = lastRateValue - PClose;
    livePLCache.current[scriptCode] =
      `${totalPL.toFixed(2)} (${liveChangePercentageCache.current[scriptCode].toFixed(2)}%)`;

    setLiveUpdateTrigger((prev) => prev + 1);
    // console.log(
    //   `📈 [${scriptCode}] LTP ₹${lastRateValue} | High ₹${High} | Low ₹${Low}`,
    // ); // ✅ Updated
  };

  const increase = () => {
    if (state.value < state.max) {
      setState({ ...state, value: state.value + 1 });
    }
  };

  const decrease = () => {
    if (state.value > state.min) {
      setState({ ...state, value: state.value - 1 });
    }
  };

  const handlePreview = () => setIsPreview(true);
  const handleGoBack = () => setIsPreview(false);

  const SettingBuyModalDetails = (stockData, Type) => {
    setBuySellModalDetails((prevState) => ({
      ...prevState,
      FullName: stockData.name || stockData.fullName || "",
      Symbol: stockData.symbol || stockData.Symbol || stockData.name || "",
      Type: Type,
      OrderQty: 1,
      LimitPrice: 0,
      order: stockData, // store complete order object
    }));
  };

  const checkNotifications = (percentage) => {
    if (percentage >= 100) {
      return "🎉 Congratulations! You have reached your target price. Consider securing your gains.";
    } else if (percentage >= 90) {
      return "🏁 Excellent progress! You are 90% towards your target.";
    } else if (percentage >= 80) {
      return "💼 Strong performance. 80% of your target has been achieved.";
    } else if (percentage >= 70) {
      return "📈 Good momentum at 70% of your target.";
    } else if (percentage >= 60) {
      return "⚡ Keep it up! 60% progress made towards your target.";
    } else if (percentage >= 50) {
      return "🔔 Halfway there! You have reached 50% of your target.";
    } else if (percentage >= 40) {
      return "🔎 40% progress noted. Stay focused on your investment plan.";
    } else if (percentage >= 30) {
      return "⏳ 30% attained. Maintain your strategy and patience.";
    } else if (percentage >= 20) {
      return "📊 20% progress. Continue monitoring market conditions.";
    } else if (percentage >= 10) {
      return "👍 Good start, 10% of your target achieved.";
    } else if (percentage >= 0) {
      return "🛠️ Position initiated. Monitor closely for future developments.";
    } else if (percentage >= -10) {
      return "⚠️ Slight decline. Assess market trends and stay vigilant.";
    } else if (percentage >= -30) {
      return "🔄 Moderate pullback. Consider holding position carefully.";
    } else if (percentage >= -50) {
      return "⚠️ Significant setback. Reevaluate investment strategy.";
    } else if (percentage >= -75) {
      return "🚨 Substantial loss. Consider consulting with a financial advisor.";
    } else {
      return "❗ Critical decline. Immediate action may be required.";
    }
  };

  // const getNotificationMeta = (percentage) => {
  //   return { percentage };
  // };

  const getNotificationMeta = (percentage) => {
    if (percentage >= 100) {
      return {
        Icon: LuTrophy,
        color: "#16a34a",
        variant: "hit",
        label: "Target hit",
        message:
          "Congratulations! You have reached your target price. Consider securing your gains.",
      };
    } else if (percentage >= 90) {
      return {
        Icon: LuFlag,
        color: "#16a34a",
        variant: "near",
        label: "Near target",
        message: "Excellent progress! You are 90% towards your target.",
      };
    } else if (percentage >= 80) {
      return {
        Icon: LuBriefcase,
        color: "#16a34a",
        variant: "strong",
        label: "Strong gain",
        message: "Strong performance. 80% of your target has been achieved.",
      };
    } else if (percentage >= 70) {
      return {
        Icon: LuTrendingUp,
        color: "#16a34a",
        variant: "momentum",
        label: "Good momentum",
        message: "Good momentum at 70% of your target.",
      };
    } else if (percentage >= 60) {
      return {
        Icon: LuZap,
        color: "#0d9488",
        variant: "fast",
        label: "Fast progress",
        message: "Keep it up! 60% progress made towards your target.",
      };
    } else if (percentage >= 50) {
      return {
        Icon: LuBell,
        color: "#f59e0b",
        variant: "halfway",
        label: "Halfway",
        message: "Halfway there! You have reached 50% of your target.",
      };
    } else if (percentage >= 40) {
      return {
        Icon: LuSearch,
        color: "#3b82f6",
        variant: "watch",
        label: "Keep watch",
        message: "40% progress noted. Stay focused on your investment plan.",
      };
    } else if (percentage >= 30) {
      return {
        Icon: LuHourglass,
        color: "#3b82f6",
        variant: "early",
        label: "Early stage",
        message: "30% attained. Maintain your strategy and patience.",
      };
    } else if (percentage >= 20) {
      return {
        Icon: LuChartBar,
        color: "#3b82f6",
        variant: "initial",
        label: "Initial move",
        message: "20% progress. Continue monitoring market conditions.",
      };
    } else if (percentage >= 10) {
      return {
        Icon: LuThumbsUp,
        color: "#2563eb",
        variant: "start",
        label: "Good start",
        message: "Good start, 10% of your target achieved.",
      };
    } else if (percentage >= 0) {
      return {
        Icon: LuWrench,
        color: "#6b7280",
        variant: "live",
        label: "Position live",
        message: "Position initiated. Monitor closely for future developments.",
      };
    } else if (percentage >= -10) {
      return {
        Icon: LuTriangleAlert,
        color: "#f59e0b",
        variant: "decline",
        label: "Slight decline",
        message: "Slight decline. Assess market trends and stay vigilant.",
      };
    } else if (percentage >= -30) {
      return {
        Icon: LuRefreshCcw,
        color: "#f97316",
        variant: "pullback",
        label: "Pullback",
        message: "Moderate pullback. Consider holding position carefully.",
      };
    } else if (percentage >= -50) {
      return {
        Icon: LuOctagonAlert,
        color: "#ea580c",
        variant: "setback",
        label: "Setback",
        message: "Significant setback. Reevaluate investment strategy.",
      };
    } else if (percentage >= -75) {
      return {
        Icon: LuAlarmSmoke,
        color: "#dc2626",
        variant: "severe",
        label: "Severe loss",
        message:
          "Substantial loss. Consider consulting with a financial advisor.",
      };
    } else {
      return {
        Icon: LuOctagonX,
        color: "#b91c1c",
        variant: "critical",
        label: "Critical",
        message: "Critical decline. Immediate action may be required.",
      };
    }
  };

  //----------------------------//  Buy-Sell Functions //----------------------------//`

  // Placing Order steps:
  // CDSL Record Count Function
  // CDSL Record Count Function with Debug Logging
  async function getCDSLRecordCount(userId) {
    console.log("🔍 getCDSLRecordCount - Starting function");
    console.log("📋 Input userId:", userId);

    const apiUrl =
      "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=getCDSLRecord";
    console.log("🌐 API URL:", apiUrl);

    try {
      console.log("📤 Preparing to send request...");

      const requestBody = { userId: userId };
      console.log("📦 Request body:", JSON.stringify(requestBody));

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      console.log("📥 Response received");
      console.log("✅ Response status:", response.status);
      console.log("📊 Response statusText:", response.statusText);
      console.log("🔗 Response OK:", response.ok);

      if (!response.ok) {
        console.error("❌ Response not OK - throwing error");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      console.log("🔄 Parsing response as JSON...");
      const data = await response.json();
      console.log("📋 Raw response data:", data);

      const count = data.count;
      console.log("🔢 Extracted count:", count);
      console.log("✅ getCDSLRecordCount - Function completed successfully");

      return count;
    } catch (error) {
      console.error("💥 Error in getCDSLRecordCount:");
      console.error("❌ Error message:", error.message);
      console.error("📊 Full error object:", error);
      console.log("🔄 Returning default value: 0");

      // Return 0 as default if error occurs
      return 0;
    }
  }

  const fetchDataPortfolio = (watchlist, transactionSide, status) => {
    console.log("🚀 fetchDataPortfolio - Starting function");
    console.log("📊 Input parameters:");
    console.log("   - watchlist:", watchlist);
    console.log("   - transactionSide:", transactionSide);
    console.log("   - status:", status);

    const Exch = watchlist.Exch;
    console.log("🏛️ Exchange (Exch):", Exch);

    const ExchType = Exch === "M" ? "D" : "C";
    console.log(
      "📈 Exchange Type (ExchType):",
      ExchType,
      `(${Exch === "M" ? "Derivative" : "Cash"})`,
    );

    const Name = watchlist.FullName || watchlist.symbol;
    console.log("🏢 Company Name:", Name);

    let Scripcode = "";

    if (status === "Portfolio") {
      // ✨ Use Number conversion for ScripCode with fallback
      Scripcode = Number(watchlist.ScripCode) || Number(watchlist.scripcode);
      console.log("📋 Portfolio mode - Using pre-calculated ScripCode:");
      console.log(
        `   - Exchange is ${watchlist.Exch}, ScripCode: ${Scripcode}`,
      );
      console.log(
        `   - NseCode: ${watchlist.NseCode}, BseCode: ${watchlist.BseCode}`,
      );
      console.log(`   - Selected Scripcode: ${Scripcode}`);
    } else if (status === "DashboardPortfolio") {
      const Name = watchlist.symbol || watchlist.name;
      console.log("🏢 Company Name:", Name);
      Scripcode = Number(watchlist.ScripCode) || Number(watchlist.scripcode);
      console.log(`   - Selected Scripcode: ${Scripcode}`);
    } else {
      Scripcode = watchlist.Scripcode || watchlist.ScripCode;
      console.log("📝 Watchlist mode - Using direct Scripcode:", Scripcode);
    }

    let watchlist_price = "0";
    let min_qty = "0";

    // ✅ Get values from modal state instead of DOM
    watchlist_price =
      orderType === "Market Order"
        ? "0"
        : buySellModalDetails.LimitPrice.toString();
    min_qty = buySellModalDetails.OrderQty.toString();

    console.log("💰 Price & Quantity from modal:");
    console.log("   - Execution (Market/Limit):", orderType);
    console.log("   - Price (watchlist_price):", watchlist_price);
    console.log("   - Quantity (min_qty):", min_qty);
    console.log("   - buySellModalDetails:", buySellModalDetails);

    const userId = sharedData.ID;
    console.log("👤 User ID:", userId);
    console.log("📱 sharedData object:", sharedData);

    const order_type = transactionSide;
    console.log("📊 Final order_type (Buy/Sell):", order_type);

    // Create a JavaScript object with the request data
    const requestData = {
      ExchType,
      order_type,
      Exch,
      Name,
      Scripcode,
      watchlist_price,
      min_qty,
      userId,
    };

    console.log("📦 Complete request data object:");
    console.log(JSON.stringify(requestData, null, 2));

    // ✅ CDSL validation for 5paisa Sell only (not Grow / AngelOne)
    if (transactionSide === "Sell" && isAngelOneBroker) {
      console.log("🛑 SELL order (AngelOne) - skipping CDSL validation");
      executeBuySellOrderPortfolio(
        requestData,
        watchlist,
        transactionSide,
        status,
      );
    } else if (transactionSide === "Sell") {
      console.log("🛑 SELL order detected - checking CDSL validation");
      getCDSLRecordCount(userId)
        .then((count) => {
          console.log("✅ CDSL validation completed");
          console.log("🔢 CDSL Record Count:", count);

          if (count === 0) {
            console.error(
              "❌ CDSL Record Count is 0 - cannot place sell order",
            );
            console.log("🚫 Sell order blocked - CDSL setup required");
            // TODO: Show error modal - user needs to complete CDSL setup
            // document.getElementById("modalClick").click();
          } else {
            console.log(
              "✅ CDSL validation passed - proceeding with sell order",
            );
            executeBuySellOrderPortfolio(
              requestData,
              watchlist,
              transactionSide,
              status,
            );
          }
        })
        .catch((error) => {
          console.error("💥 Error getting CDSL count:", error);
          console.log(
            "⚠️ CDSL validation failed - proceeding with order anyway",
          );
          // Proceed with order anyway or show error
          executeBuySellOrderPortfolio(
            requestData,
            watchlist,
            transactionSide,
            status,
          );
        });
    } else if (transactionSide === "Buy") {
      console.log("💚 BUY order detected - no CDSL validation needed");
      console.log("🚀 Proceeding directly to order execution");
      executeBuySellOrderPortfolio(
        requestData,
        watchlist,
        transactionSide,
        status,
      );
    } else {
      console.error("❓ Unknown transaction side:", transactionSide);
    }

    console.log("🏁 fetchDataPortfolio - Function end");
  };

  // Function to handle the checkSell value
  // const executeBuySellOrderPortfolio = (requestData, watchlist, orderType, status) => {
  //   console.log("🔧 executeBuySellOrderPortfolio - Starting function");
  //   console.log("📥 Input parameters:");
  //   console.log("   - requestData:", requestData);
  //   console.log("   - watchlist:", watchlist);
  //   console.log("   - orderType:", orderType);
  //   console.log("   - status:", status);

  //   const apiUrl = "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=addFivePaisaOrder";
  //   console.log("🌐 API URL:", apiUrl);
  //   console.log("📤 Preparing to send order to database...");

  //   // Send a POST request using fetch
  //   fetch(apiUrl, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(requestData),
  //   })
  //     .then((response) => {
  //       console.log("📥 Database response received");
  //       console.log("✅ Response status:", response.status);
  //       console.log("📊 Response statusText:", response.statusText);
  //       console.log("🔗 Response OK:", response.ok);

  //       if (!response.ok) {
  //         console.error("❌ Database response not OK");
  //         throw new Error("Network response was not ok");
  //       }

  //       console.log("🔄 Parsing database response as JSON...");
  //       return response.json();
  //     })
  //     .then((data) => {
  //       console.log("📋 Database response data:", data);

  //       // Handle the response data here
  //       if (data.message === "No data found in table") {
  //         console.log("⚠️ No data found in order table");
  //         console.log("🛑 Order execution stopped");
  //       } else {
  //         console.log("✅ Database order saved successfully");
  //         console.log("🚀 Proceeding to place order with 5paisa API");
  //         clickPlaceOrderPortfolio(watchlist, orderType, status);

  //         console.log("🔄 Starting holdings refresh...");

  //         const holdingsRefreshData = {
  //           AccessToken: sharedData.accessToken,
  //           ClientCode: sharedData.ClientCode,
  //           api_key: sharedData.api_key,
  //           userId: sharedData.ID,
  //         };

  //         console.log("📦 Holdings refresh request data:", holdingsRefreshData);

  //         // ✅ Refresh holdings in DB
  //         // fetch("https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=getHoldingData", {
  //         //   method: "POST",
  //         //   headers: { "Content-Type": "application/json" },
  //         //   body: JSON.stringify(holdingsRefreshData),
  //         // })
  //         //   .then((res) => {
  //         //     console.log("📥 Holdings refresh response received");
  //         //     console.log("✅ Holdings refresh status:", res.status);
  //         //     console.log("🔗 Holdings refresh OK:", res.ok);
  //         //     return res.json();
  //         //   })
  //         //   .then((holdingsData) => {
  //         //     console.log("✅ Holdings refreshed successfully");
  //         //     console.log("📊 Updated holdings data:", holdingsData);
  //         //   })
  //         //   .catch((err) => {
  //         //     console.error("💥 Error refreshing holdings:");
  //         //     console.error("❌ Holdings refresh error:", err);
  //         //   });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("💥 Database operation failed:");
  //       console.error("❌ Fetch error message:", error.message);
  //       console.error("📊 Full error object:", error);
  //       console.log("🛑 Order execution terminated due to database error");
  //     });

  //   console.log("🏁 executeBuySellOrderPortfolio - Function end (async operations continue)");
  // };
  const executeBuySellOrderPortfolio = (
    requestData,
    watchlist,
    transactionSide,
    status,
  ) => {
    console.log("🔧 executeBuySellOrderPortfolio - Starting function");
    console.log("📥 Input parameters:");
    console.log("   - requestData:", requestData);
    console.log("   - watchlist:", watchlist);
    console.log("   - transactionSide:", transactionSide);
    console.log("   - status:", status);

    // ✅ REMOVED: Database call - now happens AFTER order placement
    console.log("🚀 Proceeding to PMS place_order");
    clickPlaceOrderPortfolio(requestData, watchlist, transactionSide, status);

    console.log("🏁 executeBuySellOrderPortfolio - Function end");
  };

  // const clickPlaceOrderPortfolio = (watchlist, orderType, status) => {
  //   console.log("🎯 clickPlaceOrderPortfolio - Starting 5paisa API call");
  //   console.log("📥 Input parameters:");
  //   console.log("   - watchlist:", watchlist);
  //   console.log("   - orderType:", orderType);
  //   console.log("   - status:", status);

  //   const token = sharedData.accessToken;
  //   const client = sharedData.ClientCode;
  //   const exch = watchlist.Exch;
  //   const exchType = exch === "M" ? "D" : "C";

  //   console.log("🔑 Authentication data:");
  //   console.log("   - token:", token ? `${token.substring(0, 20)}...` : "MISSING");
  //   console.log("   - client:", client);
  //   console.log("   - sharedData.api_key:", sharedData.api_key ? `${sharedData.api_key.substring(0, 20)}...` : "MISSING");

  //   console.log("🏛️ Exchange information:");
  //   console.log("   - exch:", exch);
  //   console.log("   - exchType:", exchType, `(${exch === "M" ? "Derivative" : "Cash"})`);

  //   let scripCode = "";
  //   if (status === "Portfolio") {
  //     scripCode = Number(watchlist.ScripCode) || Number(watchlist.scripcode);
  //     console.log("📋 Portfolio mode - Using pre-calculated ScripCode:");
  //     console.log(`   - Exchange: ${watchlist.Exch}, ScripCode: ${scripCode}`);
  //     console.log(`   - NseCode: ${watchlist.NseCode}, BseCode: ${watchlist.BseCode}`);
  //     console.log(`   - Final scripCode: ${scripCode}`);
  //   }
  //   else if(status === "DashboardPortfolio"){
  //     const Name = watchlist.symbol || watchlist.name;
  //     console.log("🏢 Company Name:", Name);
  //     scripCode = Number(watchlist.ScripCode) || Number(watchlist.scripcode);
  //     console.log(`   - Selected Scripcode: ${scripCode}`);
  //   }
  //   else {
  //     scripCode = watchlist.Scripcode;
  //     console.log("📝 Watchlist mode - Direct scripCode:", scripCode);
  //   }

  //   let min_qty = "0";
  //   let price = "0";

  //   min_qty = buySellModalDetails.OrderQty.toString();
  //   price = orderType === "Market Order" ? "0" : buySellModalDetails.LimitPrice.toString();

  //   console.log("💰 Order details from modal:");
  //   console.log("   - orderType:", orderType);
  //   console.log("   - min_qty:", min_qty);
  //   console.log("   - price:", price);
  //   console.log("   - buySellModalDetails:", buySellModalDetails);

  //   const type = orderType;
  //   const key = sharedData.api_key;

  //   console.log("🍪 Cookie information:");
  //   console.log("COOKIE : " + document.cookie);

  //   const apiUrl = "https://openapi.5paisa.com/VendorsAPI/Service1.svc/V1/PlaceOrderRequest";
  //   console.log("🌐 5paisa API URL:", apiUrl);

  //   const requestBody = {
  //     head: {
  //       key: sharedData.api_key,
  //     },
  //     body: {
  //       ClientCode: sharedData.ClientCode,
  //       Exchange: exch,
  //       ExchangeType: exchType,
  //       Qty: min_qty,
  //       Price: orderType === "Market Order" ? 0 : parseFloat(buySellModalDetails.LimitPrice),
  //       AtMarket: orderType === "Market Order" ? "Y" : "N",
  //       OrderType: type,
  //       ScripCode: scripCode,
  //       IsIntraday: false,
  //       IsAHOrder: "N",
  //     },
  //   };

  //   console.log("📦 Complete 5paisa request body:");
  //   console.log(JSON.stringify(requestBody, null, 2));

  //   const requestHeaders = {
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${sharedData.accessToken}`,
  //     Cookie: "5paisacookie=j2usr4wuddgegs14hcjrh3d4; NSC_JOh0em50e1pajl5b5jvyafempnkehc3=ffffffffaf103e0f45525d5f4f58455e445a4a423660; 5paisacookie=vthjiv5kqxuwrq1zizi3alt0; NSC_JOh0em50e1pajl5b5jvyafempnkehc3=ffffffffaf103e0f45525d5f4f58455e445a4a423660",
  //   };

  //   console.log("📤 Request headers:");
  //   console.log("   - Content-Type:", requestHeaders["Content-Type"]);
  //   console.log("   - Authorization:", requestHeaders.Authorization ? `Bearer ${requestHeaders.Authorization.substring(7, 27)}...` : "MISSING");
  //   console.log("   - Cookie:", requestHeaders.Cookie ? `${requestHeaders.Cookie.substring(0, 50)}...` : "MISSING");

  //   console.log("🚀 Sending request to 5paisa API...");

  //   fetch(apiUrl, {
  //     method: "POST",
  //     headers: requestHeaders,
  //     body: JSON.stringify(requestBody),
  //   })
  //     .then((response) => {
  //       console.log("📥 5paisa API response received");
  //       console.log("✅ Response status:", response.status);
  //       console.log("📊 Response statusText:", response.statusText);
  //       console.log("🔗 Response OK:", response.ok);

  //       if (!response.ok) {
  //         console.error("❌ 5paisa API response not OK");
  //         console.error("💥 HTTP Error:", response.status, response.statusText);
  //       }

  //       console.log("🔄 Parsing 5paisa response as JSON...");
  //       return response.json();
  //     })
  //     .then((data) => {
  //       console.log("📋 5paisa API Response Data:");
  //       console.log("Place Order : " + data.body.Message);
  //       console.log("Place Order : " + JSON.stringify(data, null, 2));

  //       const message = data.body.Message || "";
  //       const rmsResponseCode = data.body.RMSResponseCode;

  //       // 🔒 CHECK FOR CDSL AUTHORIZATION ERROR - MUST BE FIRST
  //       console.log("🔍 Checking for CDSL authorization error...");
  //       console.log("   - RMSResponseCode:", rmsResponseCode);
  //       console.log("   - Message:", message);

  //       if (
  //         rmsResponseCode === -162 ||
  //         message.toLowerCase().includes("sell authorization not received") ||
  //         message.toLowerCase().includes("authorization not received")
  //       ) {
  //         console.log("🚨 CDSL Authorization Required - Opening Modal");

  //         // Show error toast
  //         toast.error("CDSL authorization required to place sell orders");

  //         // Close the buy/sell modal FIRST
  //         console.log("🔄 Closing buy/sell modal...");
  //         if (orderType === "Buy") {
  //           document.getElementById("buyModalClick")?.click();
  //         } else if (orderType === "Sell") {
  //           document.getElementById("sellModalClick")?.click();
  //         }

  //         // Wait for modal to close, then open CDSL modal
  //         setTimeout(() => {
  //           const triggerButton = document.getElementById('openCDSLModalBtn');
  //           console.log("🔍 Looking for openCDSLModalBtn button:", triggerButton);

  //           if (triggerButton) {
  //             triggerButton.click();
  //             console.log("✅ CDSL Authorization Modal opened successfully");
  //           } else {
  //             console.error("❌ openCDSLModalBtn button NOT FOUND in DOM");
  //             console.error("   Make sure the button exists with id='openCDSLModalBtn'");
  //           }
  //         }, 500);

  //         console.log("🛑 Order placement stopped - CDSL authorization required");
  //         return; // EXIT EARLY - THIS IS CRITICAL - DO NOT REMOVE THIS LINE
  //       }

  //       // 📊 HANDLE OTHER RESPONSE MESSAGES (only reached if NOT CDSL error)
  //       console.log("✅ No CDSL error detected - processing normal response");

  //       if (message.includes("Pending") || message.includes("pending")) {
  //         // toast.warn(message);
  //         showWarningToast(message);
  //       } else if (message.includes("rejected") || message.includes("Rejected")) {
  //         // toast.error(message);
  //         showErrorToast(message)
  //       } else if (message.includes("partially") || message.includes("Partially")) {
  //         toast.success(message, { style: { background: "lightgreen", color: "#000" } }, pingNotification());
  //         pingNotification()

  //       } else if (message.includes("Fully") || message.includes("fully")) {
  //         toast.success(message, { style: { background: "darkgreen", color: "#fff" } }, pingNotification());
  //         pingNotification()
  //       } else if (message.includes("Cancelled") || message.includes("cancelled")) {
  //         toast(message, { style: { background: "gray", color: "#fff" } }, pingNotification());
  //         pingNotification()
  //       } else if (message.includes("Accepted") || message.includes("accepted")) {
  //         // toast.success(message);
  //         showSuccessToast(message)
  //       } else {
  //         toast.info(message);
  //         pingNotification()
  //       }

  //       console.log("🔄 Triggering post-order actions...");

  //       if (orderType === "Buy") {
  //         console.log("💚 Buy order - triggering buyModalClick");
  //         document.getElementById("buyModalClick")?.click();
  //       } else if (orderType === "Sell") {
  //         console.log("🔴 Sell order - triggering sellModalClick");
  //         document.getElementById("sellModalClick")?.click();
  //       }

  //       console.log("✅ Order process completed successfully");
  //       console.log("END");
  //     })
  //     .catch((error) => {
  //       console.error("💥 5paisa API call failed:");
  //       console.error("❌ Error type:", error.name);
  //       console.error("❌ Error message:", error.message);
  //       console.error("📊 Full error object:", error);
  //       console.log("🛑 Order placement terminated due to API error");

  //       // toast.error("Failed to place order. Please try again.");
  //       showErrorToast("Failed to place order. Please try again.");
  //     });

  //   console.log("🏁 clickPlaceOrderPortfolio - Function end (async 5paisa call continues)");
  // };

  // const clickPlaceOrderPortfolio = (requestData, watchlist, orderType, status) => {
  //   console.log("🎯 clickPlaceOrderPortfolio - Starting 5paisa API call");
  //   console.log("📥 Input parameters:");
  //   console.log("   - requestData:", requestData);
  //   console.log("   - watchlist:", watchlist);
  //   console.log("   - orderType:", orderType);
  //   console.log("   - status:", status);

  //   const token = sharedData.accessToken;
  //   const client = sharedData.ClientCode;
  //   const exch = watchlist.Exch;
  //   const exchType = exch === "M" ? "D" : "C";

  //   console.log("🔑 Authentication data:");
  //   console.log("   - token:", token ? `${token.substring(0, 20)}...` : "MISSING");
  //   console.log("   - client:", client);
  //   console.log("   - sharedData.api_key:", sharedData.api_key ? `${sharedData.api_key.substring(0, 20)}...` : "MISSING");

  //   console.log("🏛️ Exchange information:");
  //   console.log("   - exch:", exch);
  //   console.log("   - exchType:", exchType, `(${exch === "M" ? "Derivative" : "Cash"})`);

  //   let scripCode = "";
  //   if (status === "Portfolio") {
  //     scripCode = Number(watchlist.ScripCode) || Number(watchlist.scripcode);
  //     console.log("📋 Portfolio mode - Using pre-calculated ScripCode:");
  //     console.log(`   - Exchange: ${watchlist.Exch}, ScripCode: ${scripCode}`);
  //     console.log(`   - NseCode: ${watchlist.NseCode}, BseCode: ${watchlist.BseCode}`);
  //     console.log(`   - Final scripCode: ${scripCode}`);
  //   } else if (status === "DashboardPortfolio") {
  //     const Name = watchlist.symbol || watchlist.name;
  //     console.log("🏢 Company Name:", Name);
  //     scripCode = Number(watchlist.ScripCode) || Number(watchlist.scripcode);
  //     console.log(`   - DashboardPortfolio mode - Selected Scripcode: ${scripCode}`);
  //   } else {
  //     scripCode = watchlist.Scripcode;
  //     console.log("📝 Watchlist mode - Direct scripCode:", scripCode);
  //   }

  //   let min_qty = "0";
  //   let price = "0";

  //   min_qty = buySellModalDetails.OrderQty.toString();
  //   price = orderType === "Market Order" ? "0" : buySellModalDetails.LimitPrice.toString();

  //   console.log("💰 Order details from modal:");
  //   console.log("   - orderType:", orderType);
  //   console.log("   - min_qty:", min_qty);
  //   console.log("   - price:", price);
  //   console.log("   - buySellModalDetails:", buySellModalDetails);

  //   const type = orderType;
  //   const key = sharedData.api_key;

  //   console.log("🍪 Cookie information:");
  //   console.log("COOKIE : " + document.cookie);

  //   const apiUrl = "https://openapi.5paisa.com/VendorsAPI/Service1.svc/V1/PlaceOrderRequest";
  //   console.log("🌐 5paisa API URL:", apiUrl);

  //   const requestBody = {
  //     head: {
  //       key: sharedData.api_key,
  //     },
  //     body: {
  //       ClientCode: sharedData.ClientCode,
  //       Exchange: exch,
  //       ExchangeType: exchType,
  //       Qty: min_qty,
  //       Price: orderType === "Market Order" ? 0 : parseFloat(buySellModalDetails.LimitPrice),
  //       AtMarket: orderType === "Market Order" ? "Y" : "N",
  //       OrderType: type,
  //       ScripCode: scripCode,
  //       IsIntraday: false,
  //       IsAHOrder: "N",
  //     },
  //   };

  //   console.log("📦 Complete 5paisa request body:");
  //   console.log(JSON.stringify(requestBody, null, 2));

  //   const requestHeaders = {
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${sharedData.accessToken}`,
  //     Cookie: "5paisacookie=j2usr4wuddgegs14hcjrh3d4; NSC_JOh0em50e1pajl5b5jvyafempnkehc3=ffffffffaf103e0f45525d5f4f58455e445a4a423660; 5paisacookie=vthjiv5kqxuwrq1zizi3alt0; NSC_JOh0em50e1pajl5b5jvyafempnkehc3=ffffffffaf103e0f45525d5f4f58455e445a4a423660",
  //   };

  //   console.log("📤 Request headers:");
  //   console.log("   - Content-Type:", requestHeaders["Content-Type"]);
  //   console.log("   - Authorization:", requestHeaders.Authorization ? `Bearer ${requestHeaders.Authorization.substring(7, 27)}...` : "MISSING");
  //   console.log("   - Cookie:", requestHeaders.Cookie ? `${requestHeaders.Cookie.substring(0, 50)}...` : "MISSING");

  //   console.log("🚀 Sending request to 5paisa API...");

  //   fetch(apiUrl, {
  //     method: "POST",
  //     headers: requestHeaders,
  //     body: JSON.stringify(requestBody),
  //   })
  //     .then((response) => {
  //       console.log("📥 5paisa API response received");
  //       console.log("✅ Response status:", response.status);
  //       console.log("📊 Response statusText:", response.statusText);
  //       console.log("🔗 Response OK:", response.ok);

  //       if (!response.ok) {
  //         console.error("❌ 5paisa API response not OK");
  //         console.error("💥 HTTP Error:", response.status, response.statusText);
  //       }

  //       console.log("🔄 Parsing 5paisa response as JSON...");
  //       return response.json();
  //     })
  //     .then((data) => {
  //       console.log("📋 5paisa API Response Data:");
  //       console.log("Place Order : " + data.body.Message);
  //       console.log("Place Order : " + JSON.stringify(data, null, 2));

  //       const message = data.body.Message || "";
  //       const rmsResponseCode = data.body.RMSResponseCode;
  //       const brokerOrderID = data.body.BrokerOrderID || "";
  //       const exchangeOrderID = data.body.ExchOrderID || "";

  //       // 🆕 Determine order status based on Message content
  //       let orderStatus = "Unknown";
  //       let orderReason = message;

  //       console.log("🔍 Analyzing message for order status...");
  //       console.log("   - Message:", message);
  //       console.log("   - RMSResponseCode:", rmsResponseCode);

  //       // 🔒 CHECK FOR CDSL AUTHORIZATION ERROR FIRST
  //       if (
  //         rmsResponseCode === -162 ||
  //         message.toLowerCase().includes("sell authorization not received") ||
  //         message.toLowerCase().includes("authorization not received")
  //       ) {
  //         console.log("🚨 CDSL Authorization Required");
  //         orderStatus = "CDSL Authorization Required";

  //         // ✅ Save to database with CDSL error status
  //         saveOrderToDatabase(requestData, orderStatus, orderReason, brokerOrderID, exchangeOrderID, data);

  //         toast.error("CDSL authorization required to place sell orders");

  //         // Close the buy/sell modal FIRST
  //         console.log("🔄 Closing buy/sell modal...");
  //         if (orderType === "Buy") {
  //           document.getElementById("buyModalClick")?.click();
  //         } else if (orderType === "Sell") {
  //           document.getElementById("sellModalClick")?.click();
  //         }

  //         // Wait for modal to close, then open CDSL modal
  //         setTimeout(() => {
  //           const triggerButton = document.getElementById('openCDSLModalBtn');
  //           console.log("🔍 Looking for openCDSLModalBtn button:", triggerButton);

  //           if (triggerButton) {
  //             triggerButton.click();
  //             console.log("✅ CDSL Authorization Modal opened successfully");
  //           } else {
  //             console.error("❌ openCDSLModalBtn button NOT FOUND in DOM");
  //           }
  //         }, 500);

  //         console.log("🛑 Order placement stopped - CDSL authorization required");
  //         return; // Exit early
  //       }

  //       // 📊 Determine order status from message keywords
  //       const messageLower = message.toLowerCase();

  //       if (messageLower.includes("fully") || messageLower.includes("complete")) {
  //         orderStatus = "Fully Executed";
  //         console.log("✅ Order Status: Fully Executed");
  //       } else if (messageLower.includes("partially")) {
  //         orderStatus = "Partially Executed";
  //         console.log("⚠️ Order Status: Partially Executed");
  //       } else if (messageLower.includes("accepted")) {
  //         orderStatus = "Accepted";
  //         console.log("✅ Order Status: Accepted");
  //       } else if (messageLower.includes("pending")) {
  //         orderStatus = "Pending";
  //         console.log("⏳ Order Status: Pending");
  //       } else if (messageLower.includes("rejected") || messageLower.includes("cannot place")) {
  //         orderStatus = "Rejected";
  //         console.log("❌ Order Status: Rejected");
  //       } else if (messageLower.includes("cancelled")) {
  //         orderStatus = "Cancelled";
  //         console.log("🚫 Order Status: Cancelled");
  //       } else if (messageLower.includes("closed") || messageLower.includes("exchange is closed")) {
  //         orderStatus = "Exchange Closed";
  //         console.log("🔒 Order Status: Exchange Closed");
  //       } else if (messageLower.includes("insufficient")) {
  //         orderStatus = "Insufficient Funds";
  //         console.log("💰 Order Status: Insufficient Funds");
  //       } else if (messageLower.includes("invalid")) {
  //         orderStatus = "Invalid Order";
  //         console.log("⚠️ Order Status: Invalid Order");
  //       } else if (messageLower.includes("timeout") || messageLower.includes("timed out")) {
  //         orderStatus = "Timeout";
  //         console.log("⏱️ Order Status: Timeout");
  //       } else {
  //         orderStatus = "Unknown";
  //         console.log("❓ Order Status: Unknown");
  //       }

  //       console.log("📊 Final Determined Order Status:", orderStatus);
  //       console.log("📝 Order Reason:", orderReason);

  //       // ✅ 🆕 SAVE ORDER TO DATABASE WITH STATUS
  //       console.log("💾 Saving order to database with status...");
  //       saveOrderToDatabase(requestData, orderStatus, orderReason, brokerOrderID, exchangeOrderID, data);

  //       // 📊 HANDLE UI NOTIFICATIONS BASED ON STATUS
  //       console.log("🔔 Showing notification based on status...");

  //       if (orderStatus === "Pending") {
  //         showWarningToast(message);
  //       } else if (orderStatus === "Rejected" || orderStatus === "Exchange Closed" || orderStatus === "Invalid Order") {
  //         showErrorToast(message);
  //       } else if (orderStatus === "Partially Executed") {
  //         toast.success(message, { style: { background: "lightgreen", color: "#000" } });
  //         pingNotification();
  //       } else if (orderStatus === "Fully Executed") {
  //         toast.success(message, { style: { background: "darkgreen", color: "#fff" } });
  //         pingNotification();
  //       } else if (orderStatus === "Cancelled") {
  //         toast(message, { style: { background: "gray", color: "#fff" } });
  //         pingNotification();
  //       } else if (orderStatus === "Accepted") {
  //         showSuccessToast(message);
  //       } else if (orderStatus === "Insufficient Funds") {
  //         showErrorToast(message);
  //       } else if (orderStatus === "Timeout") {
  //         showWarningToast(message);
  //       } else {
  //         toast.info(message);
  //         pingNotification();
  //       }

  //       console.log("🔄 Triggering post-order actions...");

  //       if (orderType === "Buy") {
  //         console.log("💚 Buy order - triggering buyModalClick");
  //         document.getElementById("buyModalClick")?.click();
  //       } else if (orderType === "Sell") {
  //         console.log("🔴 Sell order - triggering sellModalClick");
  //         document.getElementById("sellModalClick")?.click();
  //       }

  //       // 🔄 Refresh holdings only if order was successful
  //       if (orderStatus === "Fully Executed" || orderStatus === "Partially Executed" || orderStatus === "Accepted") {
  //         console.log("🔄 Starting holdings refresh...");
  //         refreshHoldings();
  //         updateMargin();

  //       } else {
  //         console.log("⏭️ Skipping holdings refresh - order not executed");
  //       }

  //       setTimeout(() => {
  //         navigate('/Order');
  //       }, 1500); // Wait 1.5 seconds for error toast

  //       console.log("✅ Order process completed successfully");
  //       console.log("END");
  //     })
  //     .catch((error) => {
  //       console.error("💥 5paisa API call failed:");
  //       console.error("❌ Error type:", error.name);
  //       console.error("❌ Error message:", error.message);
  //       console.error("📊 Full error object:", error);
  //       console.log("🛑 Order placement terminated due to API error");

  //       // ✅ Save failed order to database
  //       saveOrderToDatabase(requestData, "API Error", error.message, "", "", null);

  //       showErrorToast("Failed to place order. Please try again.");

  //       setTimeout(() => {
  //         navigate('/Order');
  //       }, 1500); // Wait 1 second for modal close and toast
  //     });

  //   console.log("🏁 clickPlaceOrderPortfolio - Function end (async 5paisa call continues)");
  // };

  const clickPlaceOrderPortfolio = (
    requestData,
    watchlist,
    transactionSide,
    status,
  ) => {
    const executionType = orderType;

    console.log("🎯 clickPlaceOrderPortfolio — PMS /api/v1/place_order");
    console.log(
      "   transactionSide:",
      transactionSide,
      "executionType:",
      executionType,
    );

    placeOrderViaPms({
      pmsApiBaseUrl,
      sharedData,
      watchlist,
      listStatus: status,
      transactionSide,
      executionType,
      qty: buySellModalDetails.OrderQty,
      limitPrice: buySellModalDetails.LimitPrice,
    }).then((result) => {
      if (result.error) {
        console.error("💥 place_order:", result.error);
        showErrorToast("Failed to place order. Please try again.");
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      const data = result.data;
      console.log("📋 place_order response:", JSON.stringify(data, null, 2));

      const normalized = normalizePlaceOrderResponse(data);

      if (!result.ok) {
        const msg = normalized.message || "Failed to place order";
        showErrorToast(msg);
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      const message = normalized.message || "";
      const rmsResponseCode = normalized.rmsResponseCode;
      const brokerOrderID = normalized.brokerOrderID;
      const exchangeOrderID = normalized.exchangeOrderID;

      if (
        isFivePaisaBroker(sharedData) &&
        (rmsResponseCode === -162 ||
          message.toLowerCase().includes("sell authorization not received") ||
          message.toLowerCase().includes("authorization not received"))
      ) {
        toast.error("CDSL authorization required to place sell orders");
        if (transactionSide === "Buy") {
          document.getElementById("buyModalClick")?.click();
        } else if (transactionSide === "Sell") {
          document.getElementById("sellModalClick")?.click();
        }
        setTimeout(() => {
          document.getElementById("openCDSLModalBtn")?.click();
        }, 500);
        return;
      }

      if (normalized.headStatus !== "0") {
        showErrorToast(message || "Failed to place order");
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      runPlaceOrderAcceptedFlow({
        transactionSide,
        tr,
        showSuccessToast,
        navigate,
      });
    });

    console.log(
      "🏁 clickPlaceOrderPortfolio - Function end (async PMS call continues)",
    );
  };

  const refreshHoldings = () => {
    console.log("🔄 Starting holdings refresh...");
  };

  const updateMargin = () => {
    console.log("💰 updateMargin - Starting margin update");

    // Get sharedData from localStorage
    const saved = JSON.parse(localStorage.getItem("sharedData"));

    if (!saved || !saved.accessToken || !saved.api_key || !saved.ClientCode) {
      console.error("❌ Missing required data for margin update");
      return;
    }

    const apiUrl =
      "https://Openapi.5paisa.com/VendorsAPI/Service1.svc/V4/Margin";
    console.log("🌐 Margin API URL:", apiUrl);

    const requestBody = {
      head: {
        key: saved.api_key,
      },
      body: {
        ClientCode: saved.ClientCode,
      },
    };

    console.log("📦 Margin request body:", requestBody);

    const requestHeaders = {
      Authorization: `Bearer ${saved.accessToken}`,
      "Content-Type": "application/json",
    };

    console.log("📤 Sending margin update request...");

    fetch(apiUrl, {
      method: "POST",
      headers: requestHeaders,
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        console.log("📥 Margin API response received");
        console.log("✅ Response status:", response.status);

        if (!response.ok) {
          console.error("❌ Margin API response not OK");
          throw new Error("Margin API response was not ok");
        }

        return response.json();
      })
      .then((data) => {
        console.log("📋 Margin API Response Data:");
        console.log(JSON.stringify(data, null, 2));

        // Extract NetAvailableMargin from response
        const equityMargin = data.body?.EquityMargin?.[0];

        if (equityMargin && equityMargin.NetAvailableMargin !== undefined) {
          const netAvailableMargin = equityMargin.NetAvailableMargin;
          console.log("💵 NetAvailableMargin:", netAvailableMargin);

          // Update sharedData in localStorage
          const currentSharedData = JSON.parse(
            localStorage.getItem("sharedData"),
          );
          currentSharedData.margin = netAvailableMargin;

          localStorage.setItem("sharedData", JSON.stringify(currentSharedData));
          console.log("✅ Margin updated in localStorage:", netAvailableMargin);

          // 🆕 Optional: Update state if you have margin in component state
          // setSharedData(currentSharedData); // Uncomment if you use state

          // Show success toast
          console.log("💰 Available Margin: ₹" + netAvailableMargin.toFixed(2));
        } else {
          console.error("❌ NetAvailableMargin not found in response");
          console.error("📊 EquityMargin data:", equityMargin);
        }
      })
      .catch((error) => {
        console.error("💥 Margin API call failed:");
        console.error("❌ Error type:", error.name);
        console.error("❌ Error message:", error.message);
        console.error("📊 Full error object:", error);
      });

    console.log("🏁 updateMargin - Function end (async call continues)");
  };

  const getPriceForCalculation = () => {
    if (orderType === "Market Order") {
      // Use live price for Market orders
      const cacheKey = getLivePriceCacheKey(buySellModalDetails.order);
      const livePrice = livePriceCache.current[cacheKey];
      return (
        livePrice ||
        buySellModalDetails.order?.CurrentPrice ||
        buySellModalDetails.order?.initialPrice ||
        0
      );
    } else {
      // Use limit price for Limit orders
      return buySellModalDetails.LimitPrice || 0;
    }
  };

  //----------------------------// End Buy-Sell Functions //----------------------------//`

  //----------------------------//  Market Depth Functions //----------------------------//`
  // Function to subscribe to MarketDepth for a given stock
  // 🔥 Subscribe to Market Depth (Order Book) for a stock
  const subscribeToMarketDepth = (holding) => {
    if (!holding) return;

    if (isAngelOneBroker) {
      const userId =
        Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      angelOneMarketDepthService.openDepth(holding, {
        pmsApiBaseUrl,
        userId,
      });
      return;
    }

    if (!isGrowBroker) {
      fivePaisaMarketDepthStore.openDepth(holding);
    }
  };

  const unsubscribeFromMarketDepth = () => {
    if (isAngelOneBroker) {
      angelOneMarketDepthService.closeDepth();
      return;
    }

    if (!isGrowBroker) {
      fivePaisaMarketDepthStore.closeDepth();
    }
  };

  // Function to run when modal closes

  const handleModalClose = () => {
    console.log("📉📉📉 MarketDepth modal closed!");

    if (currentMDModalRef.current) {
      console.log("📉 Unsubscribing to:", currentMDModalRef.current);
    }
    unsubscribeFromMarketDepth();
    console.log("📉 Unsubscribed");
    currentMDModalRef.current = null;
    setcurrentMDModal(null);
    setMarketDepth([]);
    setShowMarketDepth(false);
  };

  //----------------------------// End market Depth Functions //----------------------------//`
  //----------------------------//  Pagination Functions //----------------------------//

  // Pagination calculations for Table 1
  const indexOfLastItem1 = currentPage1 * pageSize1;
  const indexOfFirstItem1 = indexOfLastItem1 - pageSize1;
  const currentItems1 = filteredHoldings1.slice(
    indexOfFirstItem1,
    indexOfLastItem1,
  );
  const totalPages1 = Math.ceil(filteredHoldings1.length / pageSize1);

  // Handle page change for Table 1
  const handlePageChange1 = (pageNumber) => {
    setCurrentPage1(pageNumber);
  };

  // Handle page size change for Table 1
  const handlePageSizeChange1 = (event) => {
    setPageSize1(Number(event.target.value));
    setCurrentPage1(1); // Reset to first page when page size changes
  };

  // Generate page numbers to display for Table 1
  const getPageNumbers1 = () => {
    const pageNumbers = [];
    const maxPagesToShow = 3;

    if (totalPages1 <= maxPagesToShow) {
      for (let i = 1; i <= totalPages1; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage1 <= 2) {
        for (let i = 1; i <= 3; i++) pageNumbers.push(i);
      } else if (currentPage1 >= totalPages1 - 1) {
        for (let i = totalPages1 - 2; i <= totalPages1; i++)
          pageNumbers.push(i);
      } else {
        for (let i = currentPage1 - 1; i <= currentPage1 + 1; i++)
          pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  // Pagination calculations for Table 2
  const indexOfLastItem2 = currentPage2 * pageSize2;
  const indexOfFirstItem2 = indexOfLastItem2 - pageSize2;
  const currentItems2 = filteredHoldings2.slice(
    indexOfFirstItem2,
    indexOfLastItem2,
  );
  const totalPages2 = Math.ceil(filteredHoldings2.length / pageSize2);

  // Handle page change for Table 2
  const handlePageChange2 = (pageNumber) => {
    setCurrentPage2(pageNumber);
  };

  // Handle page size change for Table 2
  const handlePageSizeChange2 = (event) => {
    setPageSize2(Number(event.target.value));
    setCurrentPage2(1); // Reset to first page when page size changes
  };

  // Generate page numbers to display for Table 2
  const getPageNumbers2 = () => {
    const pageNumbers = [];
    const maxPagesToShow = 3;

    if (totalPages2 <= maxPagesToShow) {
      for (let i = 1; i <= totalPages2; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage2 <= 2) {
        for (let i = 1; i <= 3; i++) pageNumbers.push(i);
      } else if (currentPage2 >= totalPages2 - 1) {
        for (let i = totalPages2 - 2; i <= totalPages2; i++)
          pageNumbers.push(i);
      } else {
        for (let i = currentPage2 - 1; i <= currentPage2 + 1; i++)
          pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  useEffect(() => {
    setCurrentPage1(1);
  }, [filteredHoldings1.length]);

  useEffect(() => {
    setCurrentPage2(1);
  }, [filteredHoldings2.length]);

  //----------------------------// End Pagination Functions //----------------------------//`

  //----------------------------// Drag-N-Drop Functions //----------------------------//
  //----------------------------//  TABLE 1 //----------------------------//

  const saveColumnOrder1 = async (
    newOrder,
    moduleName = "portfolio_target",
  ) => {
    try {
      const userId =
        Number(sharedData?.ID || localStorage.getItem("id")) || 0;
      const userEmail =
        sharedData?.Email_ID ||
        sharedData?.email ||
        localStorage.getItem("email") ||
        "";
      const brokerFlag = String(
        sharedData?.broker_type || localStorage.getItem("broker_type") || "",
      ).toLowerCase();
      const pmsBrokerFlag = toPmsBrokerFlag(brokerFlag);
      if (!userId || !userEmail) {
        console.warn("saveColumnOrder1: missing user_id/email");
        return;
      }

      const columnKeyMap = {
        Name: "name",
        "Current Price": "current_price",
        TodaysHigh: "todays_high_low",
        "Initial Price": "initial_target_price",
        "Target %": "target",
        Notification: "notification",
        Days: "days_remaining",
        DaysLeft: "days_remaining",
      };

      const columns = (newOrder || [])
        .filter((col) => col && col !== "Actions")
        .map((col, index) => ({
          column_key: columnKeyMap[col] || String(col).toLowerCase(),
          sort_order: index + 1,
        }));

      const response = await fetch("https://pmsapi.infomanav.in/api/v1/columns/order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          broker_flag: pmsBrokerFlag,
          module_name: moduleName,
          user_id: userId,
          email: userEmail,
          columns,
        }),
      });
      const result = await response.json();
      console.log("Saved portfolio target column order:", result);
    } catch (err) {
      console.error("Error saving column order:", err);
    }
  };

  // Drag Start
  const handleDragStart1 = (e, columnKey) => {
    if (columnKey === "Actions") return;
    setDraggedColumn1(columnKey);

    const dragPreview = document.createElement("div");
    dragPreview.style.position = "absolute";
    dragPreview.style.top = "-9999px";
    dragPreview.style.padding = "6px 16px";
    dragPreview.style.background = "#C9E0FF";
    dragPreview.style.border = "1px solid #99bde0";
    dragPreview.style.borderRadius = "4px";
    dragPreview.style.color = "#000";
    dragPreview.style.fontSize = "16px";
    dragPreview.style.fontWeight = "bold";
    dragPreview.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.15)";
    dragPreview.textContent = columnKey;

    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(dragPreview);
    }, 0);
  };

  // Drag Over
  const handleDragOver1 = (e) => {
    e.preventDefault(); // Allow drop
  };

  // Drop
  // const handleDrop1 = (e, targetColumnKey) => {
  //   e.preventDefault();

  //   const draggedIndex = columnOrder1.indexOf(draggedColumn1);
  //   const targetIndex = columnOrder1.indexOf(targetColumnKey);

  //   if (draggedIndex === -1 || targetIndex === -1 || draggedIndex === targetIndex) {
  //     setDraggedColumn1(null);
  //     return;
  //   }

  //   const tableContainer = document.querySelector(".table").closest("div");
  //   if (tableContainer) tableContainer.style.overflowY = "hidden";

  //   const newColumnOrder = [...columnOrder1];
  //   const [movedColumn] = newColumnOrder.splice(draggedIndex, 1);
  //   newColumnOrder.splice(targetIndex, 0, movedColumn);

  //   setColumnOrder1(newColumnOrder);
  //   setDraggedColumn1(null);
  //   saveColumnOrder1(newColumnOrder);

  //   requestAnimationFrame(() => {
  //     const cells = document.querySelectorAll(`[data-column-id="${movedColumn}"]`);
  //     const table = document.querySelector("table");
  //     const tableHeight = table.offsetHeight;
  //     table.style.height = `${tableHeight}px`;

  //     cells.forEach((cell) => {
  //       void cell.offsetWidth;
  //       cell.classList.add("column-drop-animate");
  //     });

  //     setTimeout(() => {
  //       cells.forEach((cell) => {
  //         cell.classList.remove("column-drop-animate");
  //       });
  //       table.style.height = "";
  //       if (tableContainer) tableContainer.style.overflowY = "";

  //       table.classList.add("table-highlight-column");
  //       setTimeout(() => {
  //         table.classList.remove("table-highlight-column");
  //       }, 600);
  //     }, 850);
  //   });
  // };
  const handleDrop1 = (e, targetColumnKey) => {
    e.preventDefault();
    if (targetColumnKey === "Actions" || draggedColumn1 === "Actions") {
      setDraggedColumn1(null);
      return;
    }

    const draggedIndex = columnOrder1.indexOf(draggedColumn1);
    const targetIndex = columnOrder1.indexOf(targetColumnKey);

    if (
      draggedIndex === -1 ||
      targetIndex === -1 ||
      draggedIndex === targetIndex
    ) {
      setDraggedColumn1(null);
      return;
    }

    const tableContainer = document.querySelector(".table")?.closest("div");
    if (tableContainer) tableContainer.style.overflowY = "hidden";

    const newColumnOrder = [...columnOrder1];
    const [movedColumn] = newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, movedColumn);

    setColumnOrder1(newColumnOrder);
    setDraggedColumn1(null);
    saveColumnOrder1(newColumnOrder);

    // Animation wrapped in requestAnimationFrame to prevent layout loops
    requestAnimationFrame(() => {
      const cells = document.querySelectorAll(
        `[data-column-id="${movedColumn}"]`,
      );

      // Start animation
      cells.forEach((cell) => cell.classList.add("column-drop-animate"));

      // Remove animation after timeout
      setTimeout(() => {
        cells.forEach((cell) => cell.classList.remove("column-drop-animate"));

        // Temporary highlight of table
        const table = document.querySelector("table");
        table?.classList.add("table-highlight-column");
        setTimeout(() => {
          table?.classList.remove("table-highlight-column");
          if (tableContainer) tableContainer.style.overflowY = "";
        }, 600);
      }, 850);
    });
  };

  // Drag End
  const handleDragEnd1 = () => {
    setDraggedColumn1(null);
  };

  //----------------------------//  TABLE 2 //----------------------------//

  const saveColumnOrder2 = async (
    newOrder,
    moduleName = "watchlist_target",
  ) => {
    try {
      const userId =
        Number(sharedData?.ID || localStorage.getItem("id")) || 0;
      const userEmail =
        sharedData?.Email_ID ||
        sharedData?.email ||
        localStorage.getItem("email") ||
        "";
      const brokerFlag = String(
        sharedData?.broker_type || localStorage.getItem("broker_type") || "",
      ).toLowerCase();
      const pmsBrokerFlag = toPmsBrokerFlag(brokerFlag);
      if (!userId || !userEmail) {
        console.warn("saveColumnOrder2: missing user_id/email");
        return;
      }

      const columnKeyMap = {
        Name: "name",
        Watchlist: "watchlist",
        "Current Price": "current_price",
        TodaysHigh: "todays_high_low",
        "Initial Price": "initial_target_price",
        "Target %": "target",
        Notification: "notification",
        Days: "days_remaining",
        DaysLeft: "days_remaining",
      };

      const columns = (newOrder || [])
        .filter((col) => col && col !== "Actions")
        .map((col, index) => ({
          column_key: columnKeyMap[col] || String(col).toLowerCase(),
          sort_order: index + 1,
        }));

      const response = await fetch("https://pmsapi.infomanav.in/api/v1/columns/order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          broker_flag: pmsBrokerFlag,
          module_name: moduleName,
          user_id: userId,
          email: userEmail,
          columns,
        }),
      });
      const result = await response.json();
      console.log("Saved watchlist column order:", result);
    } catch (err) {
      console.error("Error saving column order:", err);
    }
  };

  // Drag Start
  const handleDragStart2 = (e, columnKey) => {
    if (columnKey === "Actions") return;
    setDraggedColumn2(columnKey);

    const dragPreview = document.createElement("div");
    dragPreview.style.position = "absolute";
    dragPreview.style.top = "-9999px";
    dragPreview.style.padding = "6px 16px";
    dragPreview.style.background = "#C9E0FF";
    dragPreview.style.border = "1px solid #99bde0";
    dragPreview.style.borderRadius = "4px";
    dragPreview.style.color = "#000";
    dragPreview.style.fontSize = "16px";
    dragPreview.style.fontWeight = "bold";
    dragPreview.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.15)";
    dragPreview.textContent = columnKey;

    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(dragPreview);
    }, 0);
  };

  // Drag Over
  const handleDragOver2 = (e) => {
    e.preventDefault(); // Allow drop
  };


  const handleDrop2 = (e, targetColumnKey) => {
    e.preventDefault();
    if (targetColumnKey === "Actions" || draggedColumn2 === "Actions") {
      setDraggedColumn2(null);
      return;
    }

    const draggedIndex = columnOrder2.indexOf(draggedColumn2);
    const targetIndex = columnOrder2.indexOf(targetColumnKey);

    if (
      draggedIndex === -1 ||
      targetIndex === -1 ||
      draggedIndex === targetIndex
    ) {
      setDraggedColumn2(null);
      return;
    }

    const tableContainer = document.querySelector(".table")?.closest("div");
    if (tableContainer) tableContainer.style.overflowY = "hidden";

    const newColumnOrder = [...columnOrder2];
    const [movedColumn] = newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, movedColumn);

    setColumnOrder2(newColumnOrder);
    setDraggedColumn2(null);
    saveColumnOrder2(newColumnOrder);

    // Animation wrapped in requestAnimationFrame to prevent layout loops
    requestAnimationFrame(() => {
      const cells = document.querySelectorAll(
        `[data-column-id="${movedColumn}"]`,
      );

      // Start animation
      cells.forEach((cell) => cell.classList.add("column-drop-animate"));

      // Remove animation after timeout
      setTimeout(() => {
        cells.forEach((cell) => cell.classList.remove("column-drop-animate"));

        // Temporary highlight of table
        const table = document.querySelector("table");
        table?.classList.add("table-highlight-column");
        setTimeout(() => {
          table?.classList.remove("table-highlight-column");
          if (tableContainer) tableContainer.style.overflowY = "";
        }, 600);
      }, 850);
    });
  };

  // Drag End
  const handleDragEnd2 = () => {
    setDraggedColumn2(null);
  };

  //----------------------------// End Drag-N-Drop Functions //----------------------------//

  return (
    <>
      {/* <Header /> */}
      <Header tabName={tabName} />
      <div className="wrapper__page pb-5">
        <Sidebar />

        <div className="content_col">
          <h1 className="dashboard-page-title">{tr("dashboard")}</h1>

          <>
            {/* Chart Cards */}
            <div className="chart-cards-row" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '20px',
              marginTop: '24px',
              marginBottom: '30px'
            }}>
              {/* Total Invested Amount card */}
              <ChartCard
                title={tr("totalInvestedAmount")}
                iconSrc={iconWalet}
                modalChartType="candlestick"
                modalChartBasePrice={Math.max(cardsTotalInvested || 0, 1000)}
                modalChartSeed={11}
                modalTrendBias={1}
                value={!dashboardStatsReady ? (
                  <Placeholder.Graph active height={24} width={100} />
                ) : (
                  `₹${cardsTotalInvested.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                )}
                chartColor="#3B82F6"
                data={[
                  { name: 'Day 1', value: 3200 },
                  { name: 'Day 2', value: 3800 },
                  { name: 'Day 3', value: 3400 },
                  { name: 'Day 4', value: 4100 },
                  { name: 'Day 5', value: 3700 },
                  { name: 'Day 6', value: 4400 },
                  { name: 'Day 7', value: 4292 },
                ]}
                isHovered={isHovered1}
                onMouseEnter={() => setIsHovered1(true)}
                onMouseLeave={() => setIsHovered1(false)}
              />

              {/* Current Value card */}
              <ChartCard
                title={tr("currentValue")}
                iconSrc={iconGraph}
                modalChartType="subcharts-lines"
                modalChartBasePrice={Math.max(cardsCurrentValue || 0, 1200)}
                modalChartSeed={23}
                modalTrendBias={1}
                value={!dashboardStatsReady ? (
                  <Placeholder.Graph active height={24} width={100} />
                ) : (
                  `₹${cardsCurrentValue.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                )}
                chartColor="#8B5CF6"
                data={[
                  { name: 'Day 1', value: 3500 },
                  { name: 'Day 2', value: 4100 },
                  { name: 'Day 3', value: 3600 },
                  { name: 'Day 4', value: 4200 },
                  { name: 'Day 5', value: 3300 },
                  { name: 'Day 6', value: 3900 },
                  { name: 'Day 7', value: 3682 },
                ]}
                isHovered={isHovered2}
                onMouseEnter={() => setIsHovered2(true)}
                onMouseLeave={() => setIsHovered2(false)}
              />

              {/* Overall Profits(%) card */}
              <ChartCard
                title={tr("overallProfitsPercent")}
                iconSrc={iconLineChart}
                modalChartType="multi-pane"
                modalChartBasePrice={Math.max(Math.abs(cardsOverallPL || 0), 800)}
                modalChartSeed={37}
                modalTrendBias={cardsOverallPL >= 0 ? 1 : -1}
                value={!dashboardStatsReady ? (
                  <Placeholder.Graph active height={24} width={100} />
                ) : cardsTotalInvested === 0 ? (
                  <span>₹0.00 <span style={{ fontSize: '14px' }}>(0.00%)</span></span>
                ) : (
                  <span style={{ color: cardsOverallPL < 0 ? "#F44336" : "#1EA355" }}>
                    ₹{cardsOverallPL < 0 ? "-" : ""}{Math.abs(cardsOverallPL).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })} <span style={{ fontSize: '14px' }}>({cardsOverallPL >= 0 ? "+" : ""}{cardsOverallPercent.toFixed(2)}%)</span>
                  </span>
                )}
                chartColor="#EF4444"
                data={[
                  { name: 'Day 1', value: 1400 },
                  { name: 'Day 2', value: 1100 },
                  { name: 'Day 3', value: 1300 },
                  { name: 'Day 4', value: 800 },
                  { name: 'Day 5', value: 1200 },
                  { name: 'Day 6', value: 600 },
                  { name: 'Day 7', value: 790 },
                ]}
                isHovered={isHovered3}
                onMouseEnter={() => setIsHovered3(true)}
                onMouseLeave={() => setIsHovered3(false)}
              />

              {/* Today's P/L(%) card */}
              <ChartCard
                title={tr("todaysPLPercent")}
                iconSrc={iconPie}
                modalChartType="todays-breakdown"
                modalChartBasePrice={Math.max(Math.abs(cardsTodayPL || 0), 500)}
                modalChartSeed={49}
                modalTrendBias={cardsTodayPL >= 0 ? 1 : -1}
                value={!dashboardStatsReady ? (
                  <Placeholder.Graph active height={24} width={100} />
                ) : !hasApiTodayPLPercent && totalPrevValue === 0 ? (
                  <span>₹0.00 <span style={{ fontSize: '14px' }}>(0.00%)</span></span>
                ) : (
                  <span style={{ color: cardsTodayPL < 0 ? "#F44336" : "#1EA355" }}>
                    ₹{cardsTodayPL < 0 ? "-" : ""}{Math.abs(cardsTodayPL).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })} <span style={{ fontSize: '14px' }}>({cardsTodayPL >= 0 ? "+" : ""}{cardsTodayPercent.toFixed(2)}%)</span>
                  </span>
                )}
                chartColor="#10B981"
                data={[
                  { name: 'Day 1', value: 300 },
                  { name: 'Day 2', value: 400 },
                  { name: 'Day 3', value: 150 },
                  { name: 'Day 4', value: 350 },
                  { name: 'Day 5', value: 200 },
                  { name: 'Day 6', value: 450 },
                  { name: 'Day 7', value: 250 },
                ]}
                isHovered={isHovered4}
                onMouseEnter={() => setIsHovered4(true)}
                onMouseLeave={() => setIsHovered4(false)}
              />
            </div>

            {/* Portfolio Value Over Time */}
            <div className="table_main">
              <div className="table_title_with_view_all_row">
                {/* <h5>Portfolio Value Over Time</h5> */}
                <h5>{tr("portfolioTargets")}</h5>

                <NavLink to="/Portfolio" className="view_all_link">
                  <span>{tr("viewAll")}</span> <i className="icon-arrow-view-all"></i>
                </NavLink>
              </div>

              <div className="table-responsive db-portfolio-targets-wrap">
                {isLoading && (
                  <Placeholder.Grid
                    rows={20}
                    columns={9}
                    active
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }}
                  />
                )}

                {!isLoading && (
                  <>
                    <style>{`
      /* Portfolio Targets table row highlight (scoped)
         Left: 100% opacity, Right: 0% opacity (same color) */
      .db-portfolio-targets-wrap{
        overflow-x: auto !important;
        overflow-y: visible !important;
        -webkit-overflow-scrolling: touch;
        width: 100%;
        min-width: 0;
      }
      .db-portfolio-targets-table{
        border-collapse: collapse;
        border-spacing: 0;
        width: max-content;
        min-width: 100%;
      }
      .db-portfolio-targets-table thead tr {
        position: static !important;
        top: auto !important;
        z-index: auto !important;
        background: #f8fbff !important;
      }
      .db-portfolio-targets-table thead tr th {
        position: sticky !important;
        top: 0px !important;
        z-index: 20 !important;
        background: #f8fbff !important;
      }
      .db-portfolio-targets td{
        background: transparent !important; /* let tr background be visible */
        background-color: transparent !important;
      }
      .db-portfolio-targets tr{
        background: #ffffff !important;
      }
      .db-portfolio-targets tr:nth-child(even){
        background: #fbfdff !important;
      }
      .db-portfolio-targets tr[style*="--target-bg-rgb"]{
        background: rgba(var(--target-bg-rgb), 0.22) !important;
      }
    `}</style>
                    <table className="table db-portfolio-targets-table">
                      <thead>
                        <tr>
                          {columnOrder1.map((col) => (
                            <th
                              key={col}
                              draggable={col !== "Actions"}
                              onDragStart={(e) => handleDragStart1(e, col)}
                              onDragOver={(e) => handleDragOver1(e)}
                              onDrop={(e) => handleDrop1(e, col)}
                              onDragEnd={handleDragEnd1}
                              data-column-id={col}
                              style={{
                                transition: "all 0.3s ease",
                                transform:
                                  draggedColumn1 === col
                                    ? "scale(1.03)"
                                    : "scale(1)",
                                boxShadow:
                                  draggedColumn1 === col
                                    ? "0 0 10px #C9E0FF"
                                    : "none",
                                cursor: "grab",
                                position: "sticky",
                                top: 0,
                                right: col === "Actions" ? 0 : undefined,
                                zIndex: col === "Actions" ? 60 : 30,
                                background:
                                  col === "Actions" ? "#f8fbff" : "#f6f6f6",
                                textAlign: getTableColumnAlignment(col),
                                maxWidth: col === "Name" ? 250 : undefined,
                                minWidth: col === "Name" ? 250 : undefined,
                                width: col === "Name" ? 250 : undefined,
                                overflow: col === "Name" ? "visible" : undefined,
                                textOverflow:
                                  col === "Name" ? "ellipsis" : undefined,
                                whiteSpace: col === "Name" ? "nowrap" : undefined,
                                paddingLeft: col === "Actions" ? 0 : col === "Notification" ? "10px" : undefined,
                                paddingRight: col === "Actions" ? 0 : undefined,
                                display: [
                                  "TodaysLow",
                                  "Profit %",
                                  "52WeekLow",
                                  "Target Price",
                                  "DaysLeft",
                                  "Net Change",
                                  "TodaysLow",
                                  "Target Price",
                                  "targetPrice",
                                ].includes(col)
                                  ? "none"
                                  : undefined,
                              }}
                            >
                              {col === "Name" ? (
                                <div className="table_head_search">
                                  <div style={{ padding: "2px" }}>
                                    <button
                                      style={{
                                        padding: "2px 0 2px 5px",
                                        borderRight: "1px solid #e4e4e4ff",
                                      }}
                                      onClick={() =>
                                        searchInputRef1.current?.focus()
                                      }
                                    >
                                      <i className="icon-search" />
                                    </button>
                                    <input
                                      type="text"
                                      placeholder={tr("nameSearchHere")}
                                      style={{
                                        paddingLeft: "10px",
                                        marginLeft: "5px",
                                      }}
                                      value={searchQuery1}
                                      onChange={(e) => {
                                        console.log("aaaaa1 search input change", {
                                          value: e.target.value,
                                        });
                                        setSearchQuery1(e.target.value);
                                      }}
                                      ref={searchInputRef1}
                                    />
                                  </div>
                                  {/* <button><i className="icon-settings" /></button> */}
                                </div>
                              ) : col === "Notification" ? (
                                <Whisper
                                  placement="top"
                                  trigger="hover"
                                  speaker={
                                    <Tooltip
                                      className="common__tooltip"
                                      style={{ maxWidth: "400px" }}
                                    >
                                      {translateColumnLabel(
                                        typeof col === "object" && col
                                          ? col
                                          : col,
                                        currentLanguage,
                                      )}
                                      :<br />- {tr("notificationColumnTooltip")}
                                    </Tooltip>
                                  }
                                >
                                  <div style={{ fontSize: "1em", textAlign: "left", paddingLeft: 0 }}>
                                    {translateColumnLabel(
                                      typeof col === "object" && col ? col : col,
                                      currentLanguage,
                                    )}
                                  </div>
                                </Whisper>
                              ) : //             : col === "Current Price" ? (
                                //   <Whisper
                                //     placement="top"
                                //     trigger="hover"
                                //     speaker={<Tooltip className="common__tooltip">Current Price:<br /> - The real-time market price at which the stock is currently trading, also known as Last Traded Price (LTP).</Tooltip>}
                                //   >
                                //     <div style={{width: "142px"}}>
                                //       {typeof col === "object" && col ? col : col}
                                //     </div>
                                //   </Whisper>
                                // )

                                // : col === "Net Change" ? (
                                //             <Whisper
                                //               placement="top"
                                //               trigger="hover"
                                //               speaker={<Tooltip className="common__tooltip">Net Change:<br /> - Displays the absolute price difference and percentage change from the previous trading session's close</Tooltip>}
                                //             >
                                //               <>
                                //                 Net Change
                                //               </>
                                //             </Whisper>
                                //           )

                                col === "Current Price" ? (
                                  <Whisper
                                    placement="top"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip
                                        className="common__tooltip"
                                        style={{ maxWidth: "400px" }}
                                      >
                                        {tr("currentPriceNetChangeTitle")}:<br />-{" "}
                                        {tr("currentPriceNetChangeTop")}
                                        <br />- {tr("currentPriceNetChangeBottom")}
                                      </Tooltip>
                                    }
                                  >
                                    <div style={{ width: "142px", margin: "auto" }}>
                                      {translateColumnLabel(
                                        typeof col === "object" && col ? col : col,
                                        currentLanguage,
                                      )}
                                    </div>
                                  </Whisper>
                                ) : col === "Net Change" ? (
                                  <></>
                                ) : col === "Profit/Loss" ? (
                                  <div style={{ width: "180px" }}>
                                    {typeof col === "object" && col ? col : col}
                                  </div>
                                ) : col === "Actions" ? (
                                  <> </> // Empty for 'Actions' column
                                ) : //             : col === "TodaysHigh" ? (
                                  //             <Whisper
                                  //   placement="top"
                                  //   trigger="hover"
                                  //   speaker={
                                  //     <Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                  //       Today's High:<br /> - The highest price at which the stock has traded during the current trading session.
                                  //       <br />
                                  //       - Note: Highlighted in orange when the live price is near this level
                                  //     </Tooltip>
                                  //   }
                                  // >
                                  //   <>
                                  //     Today's High
                                  //   </>
                                  // </Whisper>

                                  //             )
                                  //             : col === "TodaysLow" ? (
                                  //   <Whisper
                                  //     placement="top"
                                  //     trigger="hover"
                                  //     speaker={
                                  //       <Tooltip className="common__tooltip">
                                  //         Today's Low:<br /> - The lowest price at which the stock has traded during the current trading session.
                                  //         <br />
                                  //         Note: Highlighted in red when the live price is near this level
                                  //       </Tooltip>
                                  //     }
                                  //   >
                                  //     <>
                                  //       Today's Low
                                  //     </>
                                  //   </Whisper>
                                  // )

                                  col === "TodaysHigh" ? (
                                    <Whisper
                                      placement="top"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip
                                          className="common__tooltip"
                                          style={{ maxWidth: "400px" }}
                                        >
                                          {tr("todaysHighLowTitle")}:<br />
                                          - {tr("todaysHighLowTopDetail")}
                                          <br />- {tr("todaysHighLowBottomDetail")}
                                        </Tooltip>
                                      }
                                    >
                                      <>{tr("todaysHighLow")}</>
                                    </Whisper>
                                  ) : col === "TodaysLow" ? (
                                    <></>
                                  ) : //           : col === "Initial Price" ? (
                                    //   <Whisper
                                    //     placement="top"
                                    //     trigger="hover"
                                    //     speaker={
                                    //       <Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                    //         Initial Price:<br />
                                    //         - The stock's price at the time you set your target, used as a reference point to track price movement.
                                    //       </Tooltip>
                                    //     }
                                    //   >
                                    //     <>
                                    //       Initial Price
                                    //     </>
                                    //   </Whisper>
                                    // )

                                    //            : col === "Target Price" ? (
                                    //   <Whisper
                                    //     placement="top"
                                    //     trigger="hover"
                                    //     speaker={
                                    //       <Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                    //         Target Price:<br />
                                    //         - Your manually set price goal at which you plan to exit the position and book profits.
                                    //       </Tooltip>
                                    //     }
                                    //   >
                                    //     <>
                                    //       Target Price
                                    //     </>
                                    //   </Whisper>
                                    // )

                                    col === "Initial Price" ? (
                                      <Whisper
                                        placement="top"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip
                                            className="common__tooltip"
                                            style={{ maxWidth: "400px" }}
                                          >
                                            {tr("initialTargetPriceTitle")}:<br />
                                            - {tr("initialTargetPriceTop")}
                                            <br />- {tr("initialTargetPriceBottom")}
                                          </Tooltip>
                                        }
                                      >
                                        <>{tr("initialTargetPrice")}</>
                                      </Whisper>
                                    ) : col === "Target Price" ? (
                                      <></>
                                    ) : // : col === "Days" ? (
                                      //   <></>
                                      // )
                                      // : col === "DaysLeft" ? (
                                      //   <></>
                                      // )

                                      col === "Days" ? (
                                        <Whisper
                                          placement="top"
                                          trigger="hover"
                                          speaker={
                                            <Tooltip
                                              className="common__tooltip"
                                              style={{ maxWidth: "400px" }}
                                            >
                                              {tr("daysRemainingTitle")}:<br />
                                              - {tr("daysRemainingTopDetail")}
                                              <br />- {tr("daysRemainingBottomDetail")}
                                            </Tooltip>
                                          }
                                        >
                                          <>{tr("daysRemaining")}</>
                                        </Whisper>
                                      ) : col === "DaysLeft" ? (
                                        <></>
                                      ) : col === "Target %" ? (
                                        <Whisper
                                          placement="top"
                                          trigger="hover"
                                          speaker={
                                            <Tooltip
                                              className="common__tooltip"
                                              style={{ maxWidth: "400px" }}
                                            >
                                              {tr("targetPercent")}:<br />- {tr("targetPercentTooltip")}
                                            </Tooltip>
                                          }
                                        >
                                          <>{tr("targetPercent")}</>
                                        </Whisper>
                                      ) : translateColumnLabel(
                                        typeof col === "object" && col ? col : col,
                                        currentLanguage,
                                      )
                              }
                              {renderHeaderMenu("portfolio", col, sortConfig1)}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {/* <td colSpan={columns.length} style={{ padding: '20px', textAlign: 'center', color: '#666' }}> */}

                      <tbody className="db-portfolio-targets">
                        {holdings.length === 0 ? (
                          <tr>
                            <td
                              colSpan={columns.length}
                              className="table-empty-state-cell"
                            >
                              <span className="table-empty-order-text">
                                {/* {tr("noTargetsData")} */}
                                No targets set yet. Set targets for your holdings to
                                track them here.
                              </span>
                            </td>
                          </tr>
                        ) : currentItems1.length === 0 ? (
                          <tr>
                            <td
                              colSpan={columns.length}
                              className="table-empty-state-cell"
                            >
                              {/* {tr("noMatchFound")} */}
                              No match found
                            </td>
                          </tr>
                        ) : (
                          currentItems1.map((holding, index) => (
                            <tr
                              key={holding.Symbol || index}
                              onClick={() => {
                                if (supportsCandleChart(broker_type)) {
                                  handleRowClick(holding);
                                }
                              }}
                              style={{
                                cursor: supportsCandleChart(broker_type)
                                  ? "pointer"
                                  : "default",
                                "--target-bg-rgb": (() => {
                                  const target = parseFloat(holding.targetPrice);
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice = parseFloat(
                                    livePriceCache.current?.[cacheKey],
                                  );
                                  const fallbackCurrentPrice = parseFloat(
                                    holding.CurrentPrice ?? holding.initialPrice,
                                  );
                                  const currentPrice = Number.isFinite(livePrice)
                                    ? livePrice
                                    : fallbackCurrentPrice;
                                  const percentRaw = calculateTargetPercentage(
                                    currentPrice,
                                    target,
                                    holding.target_logic,
                                  );
                                  if (percentRaw === null) return undefined;
                                  // Use same gradient shades everywhere:
                                  //  - 90%  -> #e2ffed
                                  //  - 100% -> #e0ffea
                                  if (percentRaw >= 90 && percentRaw < 100)
                                    return "226,255,237"; // #e2ffed
                                  if (percentRaw >= 100) return "201,255,219"; // #e0ffea
                                  return undefined;
                                })(),
                              }}
                            >
                              {columnOrder1.map((col) => {
                                let content;

                                if (col === "Name") {
                                  const symbolName = String(
                                    holding.symbol ||
                                      holding.Symbol ||
                                      holding.TradingSymbol ||
                                      holding.name ||
                                      "",
                                  ).trim();
                                  const exchShort =
                                    holding.Exch === "N"
                                      ? "NSE"
                                      : holding.Exch === "B"
                                        ? "BSE"
                                        : holding.Exch === "M"
                                          ? "MCX"
                                          : "BSE";
                                  const exchSegment =
                                    holding.ExchType === "D"
                                      ? "Derivative"
                                      : "Cash";
                                  const exchFullLabel = `${exchShort} ${exchSegment}`;

                                  content = (
                                    <div
                                      className="main_table_company_cell"
                                      style={{}}
                                    >
                                      <div style={{ paddingLeft: "15px" }}>
                                        <h5
                                          title={
                                            holding.full_name ||
                                            holding.fullName ||
                                            holding.name
                                          }
                                          style={{
                                            maxWidth: 250,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            margin: 0,
                                          }}
                                        >
                                          {holding.full_name ||
                                            holding.fullName ||
                                            holding.name}
                                        </h5>
                                        <ul
                                          className="company_table_tags"
                                          style={{
                                            paddingLeft: 0,
                                            marginTop: 4,
                                            flexWrap: "nowrap",
                                            alignItems: "center",
                                            marginBottom: 0,
                                            gap: "4px",
                                            minWidth: 0,
                                          }}
                                        >
                                          <li
                                            className="csymbol"
                                            style={{
                                              minWidth: 0,
                                              maxWidth: 85,
                                              overflow: "hidden",
                                            }}
                                          >
                                            <Whisper
                                              placement="top"
                                              trigger="hover"
                                              speaker={
                                                <Tooltip
                                                  className="common__tooltip"
                                                  style={{ maxWidth: "320px" }}
                                                >
                                                  {symbolName || "-"}
                                                </Tooltip>
                                              }
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  maxWidth: "100%",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  verticalAlign: "bottom",
                                                  cursor: "default",
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                {symbolName || "-"}
                                              </span>
                                            </Whisper>
                                          </li>
                                          <li
                                            className="cbse_nse"
                                            style={{
                                              minWidth: 0,
                                              flexShrink: 0,
                                            }}
                                          >
                                            <Whisper
                                              placement="top"
                                              trigger="hover"
                                              speaker={
                                                <Tooltip className="common__tooltip">
                                                  {exchFullLabel}
                                                </Tooltip>
                                              }
                                            >
                                              <span
                                                style={{
                                                  cursor: "default",
                                                  whiteSpace: "nowrap",
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                {exchShort}
                                              </span>
                                            </Whisper>
                                          </li>
                                          <Whisper
                                            placement="top"
                                            trigger="hover"
                                            speaker={
                                              <Tooltip className="common__tooltip">
                                                Set Target
                                              </Tooltip>
                                            }
                                          >
                                            <li
                                              className="cset__target"
                                              role="button"
                                              tabIndex={0}
                                              aria-label="Set Target"
                                              style={{
                                                zIndex: 30,
                                                minWidth: "unset",
                                                padding: "2px 6px",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                lineHeight: 1,
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                openSetTargetModal(holding);
                                              }}
                                              onKeyDown={(e) => {
                                                if (
                                                  e.key === "Enter" ||
                                                  e.key === " "
                                                ) {
                                                  e.preventDefault();
                                                  e.stopPropagation();
                                                  openSetTargetModal(holding);
                                                }
                                              }}
                                            >
                                              <TbTarget size={16} />
                                            </li>
                                          </Whisper>
                                        </ul>
                                      </div>
                                    </div>
                                  );
                                } else if (
                                  col === "Current Price" ||
                                  col === "Live Price"
                                ) {
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice =
                                    livePriceCache.current[cacheKey];
                                  const pClose =
                                    livePCloseCache.current[cacheKey];
                                  const currentPrice =
                                    livePrice || holding.CurrentPrice;
                                  const previousClose =
                                    pClose ||
                                    holding.PreviousClose ||
                                    holding.CurrentPrice ||
                                    holding.initialPrice ||
                                    currentPrice;
                                  const isPositive =
                                    parseFloat(currentPrice) >=
                                    parseFloat(previousClose);

                                  // Get Net Change data
                                  const currentPriceNum = parseFloat(currentPrice);
                                  const base = parseFloat(previousClose);
                                  const apiDayChange = Number(holding?.stocks_data?.day_change);
                                  const apiDayChangePerc = Number(holding?.stocks_data?.day_change_perc);
                                  const hasApiChangeData =
                                    Number.isFinite(apiDayChange) &&
                                    Number.isFinite(apiDayChangePerc);
                                  const hasFallbackChangeData =
                                    Number.isFinite(currentPriceNum) &&
                                    Number.isFinite(base) &&
                                    base !== 0;
                                  const hasChangeData = hasFallbackChangeData || hasApiChangeData;
                                  const change = hasFallbackChangeData
                                    ? currentPriceNum - base
                                    : hasApiChangeData
                                      ? apiDayChange
                                      : 0;
                                  const changePercent = hasFallbackChangeData
                                    ? (change / base) * 100
                                    : hasApiChangeData
                                      ? apiDayChangePerc
                                      : 0;
                                  const isChangePositive = change >= 0;
                                  if (!hasChangeData) {
                                    console.log("netchangeeee table1 missing change data", {
                                      symbol: holding?.symbol || holding?.name,
                                      cacheKey,
                                      currentPrice,
                                      previousClose,
                                      currentPriceNum,
                                      base,
                                      apiDayChangeRaw: holding?.stocks_data?.day_change,
                                      apiDayChangePercRaw: holding?.stocks_data?.day_change_perc,
                                      hasApiChangeData,
                                      hasFallbackChangeData,
                                      holding,
                                    });
                                  }

                                  content = (
                                    <div
                                      className="trade__price__cell"
                                      style={{
                                        textAlign: "center",
                                        minWidth: "150px",
                                      }}
                                    >
                                      {/* Current Price (Top) */}
                                      <div
                                        className={
                                          isPositive
                                            ? "text_success_color"
                                            : "text_danger_color"
                                        }
                                      >
                                        ₹{formatNumber(currentPrice)}
                                        <i
                                          className={`icon-arrow-${isPositive ? "up" : "down"}`}
                                          style={{ paddingLeft: "4px" }}
                                        ></i>
                                      </div>

                                      {/* Separator Line */}
                                      <div
                                        style={{
                                          width: "30px",
                                          height: "1px",
                                          background:
                                            "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                          margin: "4px auto",
                                          opacity: "0.5",
                                        }}
                                      ></div>

                                      {/* Net Change (Bottom) */}
                                      <div
                                        className={
                                          hasChangeData
                                            ? isChangePositive
                                              ? "text_success_color"
                                              : "text_danger_color"
                                            : "text_muted"
                                        }
                                        style={{}}
                                      >
                                        {hasChangeData ? (
                                          <>
                                            {isChangePositive ? "+" : "-"}₹
                                            {Math.abs(change).toFixed(2)}
                                            <span style={{ paddingLeft: "4px" }}>
                                              ({isChangePositive ? "+" : "-"}
                                              {Math.abs(changePercent).toFixed(2)}
                                              %)
                                            </span>
                                            <i
                                              className={`icon-arrow-${isChangePositive ? "up" : "down"}`}
                                              style={{ marginLeft: "4px" }}
                                            ></i>
                                          </>
                                        ) : (
                                          <span style={{ color: "grey" }}>-</span>
                                        )}
                                      </div>
                                    </div>
                                  );
                                } else if (col === "Net Change") {
                                  content = <></>;
                                } else if (col === "TodaysHigh") {
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const liveDayHigh =
                                    liveHighCache.current[cacheKey];
                                  const liveDayLow =
                                    liveLowCache.current[cacheKey];
                                  const currentDayHigh =
                                    liveDayHigh || holding.TodaysHigh || 0;
                                  const currentDayLow =
                                    liveDayLow || holding.TodaysLow || 0;

                                  // Get live price to check if near high/low
                                  const livePrice =
                                    livePriceCache.current[cacheKey] ||
                                    holding.LTP;

                                  // Check if price is within 0.5% of day's high or low
                                  const isNearHigh =
                                    currentDayHigh > 0 &&
                                    Math.abs(
                                      ((livePrice - currentDayHigh) /
                                        currentDayHigh) *
                                      100,
                                    ) < 0.5;
                                  const isNearLow =
                                    currentDayLow > 0 &&
                                    Math.abs(
                                      ((livePrice - currentDayLow) /
                                        currentDayLow) *
                                      100,
                                    ) < 0.5;

                                  content = (
                                    <div
                                      className="trade__price__cell"
                                      style={{
                                        textAlign: "center",
                                        width: "100px",
                                        margin: "auto",
                                      }}
                                    >
                                      {/* Today's High (Top) */}
                                      <div
                                        className={
                                          isNearHigh ? "text_warning_color" : ""
                                        }
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "20px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#16A34A",
                                            fontWeight: "600",
                                          }}
                                        >
                                          H
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          ₹{formatNumber(currentDayHigh)}
                                          {isNearHigh && (
                                            <i
                                              className="icon-arrow-up"
                                              style={{
                                                color: "#FFA726",
                                                marginLeft: "4px",
                                              }}
                                            ></i>
                                          )}
                                        </div>
                                      </div>

                                      {/* Separator Line */}
                                      <div
                                        style={{
                                          width: "30px",
                                          height: "1px",
                                          background:
                                            "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                          margin: "4px auto",
                                          opacity: "0.5",
                                        }}
                                      ></div>

                                      {/* Today's Low (Bottom) */}
                                      <div
                                        className={
                                          isNearLow ? "text_danger_color" : ""
                                        }
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "20px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#DC2626",
                                            fontWeight: "600",
                                          }}
                                        >
                                          L
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          ₹{formatNumber(currentDayLow)}
                                          {isNearLow && (
                                            <i
                                              className="icon-arrow-down"
                                              style={{
                                                color: "#EF5350",
                                                marginLeft: "4px",
                                              }}
                                            ></i>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }

                                // TodaysLow Column
                                else if (col === "TodaysLow") {
                                  content = <></>;
                                } else if (
                                  col === "Initial Price" ||
                                  col === "initialPrice"
                                ) {
                                  const initialPrice = holding["initialPrice"];
                                  const targetPrice = holding["targetPrice"];

                                  content = (
                                    <div
                                      className="trade__price__cell"
                                      style={{
                                        textAlign: "center",
                                        width: "100px",
                                        margin: "auto",
                                      }}
                                    >
                                      {/* Initial Price (Top) */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "20px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#2457BF",
                                            fontWeight: "600",
                                          }}
                                        >
                                          I
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          {formatNumber(initialPrice) || "-"}
                                        </div>
                                      </div>

                                      {/* Separator Line */}
                                      <div
                                        style={{
                                          width: "30px",
                                          height: "1px",
                                          background:
                                            "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                          margin: "4px auto",
                                          opacity: "0.5",
                                        }}
                                      ></div>

                                      {/* Target Price (Bottom) */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "20px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#D67A1F",
                                            fontWeight: "600",
                                          }}
                                        >
                                          T
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          {formatNumber(targetPrice) || "-"}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                } else if (
                                  col === "Target Price" ||
                                  col === "targetPrice"
                                ) {
                                  content = <></>;
                                } else if (
                                  col === "Target %" ||
                                  col === "TargetPercent"
                                ) {
                                  const target = parseFloat(holding.targetPrice);
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice = parseFloat(
                                    livePriceCache.current?.[cacheKey],
                                  );
                                  const targetLogic = holding.target_logic;
                                  const fallbackCurrentPrice = parseFloat(
                                    holding.CurrentPrice ?? holding.initialPrice,
                                  );
                                  const currentPrice = Number.isFinite(livePrice)
                                    ? livePrice
                                    : fallbackCurrentPrice;
                                  const reasonText =
                                    holding.targetReason ||
                                    holding.target_reason ||
                                    holding.reason ||
                                    "";
                                  const reasonDetailsText =
                                    holding.targetReasonDetails ||
                                    holding.target_reason_details ||
                                    holding.reason_details ||
                                    "";
                                  const hasReason = !!String(reasonText).trim();
                                  const percent = calculateTargetPercentage(
                                    currentPrice,
                                    target,
                                    targetLogic,
                                  );

                                  if (percent === null) {
                                    content = (
                                      <span className="medium_font dark_grey_color">
                                        -
                                      </span>
                                    );
                                  } else {
                                    // Darker gradient with better contrast on white
                                    const getTargetColor = (percentage) => {
                                      const clampedPercent = Math.max(
                                        0,
                                        Math.min(100, percentage),
                                      );

                                      const colors = [
                                        { max: 10, color: "#C62828" }, // Dark Red
                                        { max: 20, color: "#D84315" }, // Dark Orange-Red
                                        { max: 30, color: "#E65100" }, // Dark Orange
                                        { max: 40, color: "#EF6C00" }, // Orange
                                        { max: 50, color: "#F57C00" }, // Amber
                                        { max: 60, color: "#F9A825" }, // Dark Yellow
                                        { max: 70, color: "#AFB42B" }, // Olive/Lime
                                        { max: 80, color: "#7CB342" }, // Light Green
                                        { max: 90, color: "#43A047" }, // Green
                                        { max: 100, color: "#2E7D32" }, // Dark Green
                                      ];

                                      const range = colors.find(
                                        (c) => clampedPercent <= c.max,
                                      );
                                      return range ? range.color : "#C62828";
                                    };

                                    const textColor = getTargetColor(percent);

                                    content = (
                                      <div
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 6,
                                        }}
                                      >
                                        <span
                                          className="medium_font"
                                          style={{
                                            color: textColor,
                                            fontWeight: "600",
                                          }}
                                        >
                                          {percent.toFixed(2)}%
                                        </span>

                                        {hasReason ? (
                                          <Whisper
                                            placement="top"
                                            trigger="hover"
                                            speaker={
                                              <Tooltip
                                                className="common__tooltip"
                                                style={{ maxWidth: "320px" }}
                                              >
                                                <div>
                                                  <b>Reason:</b>{" "}
                                                  {String(reasonText).trim()}
                                                </div>
                                                <div style={{ marginTop: "4px" }}>
                                                  <b>Details:</b>{" "}
                                                  {String(
                                                    reasonDetailsText,
                                                  ).trim() ||
                                                    "No additional details provided."}
                                                </div>
                                              </Tooltip>
                                            }
                                          >
                                            <button
                                              type="button"
                                              data-bs-toggle="modal"
                                              data-bs-target="#TargetReasonDetailsModal"
                                              aria-label="View target reason details"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setTargetReasonModalData({
                                                  stockName:
                                                    holding.name ||
                                                    holding.FullName ||
                                                    holding.symbol ||
                                                    "-",
                                                  reason:
                                                    String(reasonText).trim(),
                                                  details:
                                                    String(
                                                      reasonDetailsText,
                                                    ).trim(),
                                                });
                                              }}
                                              style={{
                                                width: "16px",
                                                height: "16px",
                                                minWidth: "16px",
                                                borderRadius: "50%",
                                                border: "1px solid #CBD5E1",
                                                background: "#FFFFFF",
                                                color: "#475569",
                                                fontSize: "11px",
                                                fontWeight: 700,
                                                lineHeight: 1,
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                padding: 0,
                                              }}
                                            >
                                              !
                                            </button>
                                          </Whisper>
                                        ) : null}
                                      </div>
                                    );
                                  }
                                } else if (col === "Notification") {
                                  const target = parseFloat(holding.targetPrice);
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice = parseFloat(
                                    livePriceCache.current?.[cacheKey],
                                  );
                                  const fallbackCurrentPrice = parseFloat(
                                    holding.CurrentPrice ?? holding.initialPrice,
                                  );
                                  const currentPrice = Number.isFinite(livePrice)
                                    ? livePrice
                                    : fallbackCurrentPrice;
                                  const percentage = calculateTargetPercentage(
                                    currentPrice,
                                    target,
                                    holding.target_logic,
                                  );

                                  if (percentage === null) {
                                    content = (
                                      <span className="medium_font dark_grey_color">
                                        -
                                      </span>
                                    );
                                  } else {

                                    const { Icon, color, label, message, variant } =
                                      getNotificationMeta(percentage);

                                    content = (
                                      <Whisper
                                        placement="top"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip
                                            className="common__tooltip"
                                            style={{ maxWidth: "320px" }}
                                          >
                                            <div>
                                              <b>{label}</b>
                                            </div>
                                            <div style={{ marginTop: "4px" }}>
                                              {message}
                                            </div>
                                          </Tooltip>
                                        }
                                      >
                                        <span
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            cursor: "default",
                                            width: "100%",
                                          }}
                                        >
                                          <span
                                            className={`table-notification-chip table-notification-chip--${variant}`}
                                            style={{ "--chip-accent": color }}
                                          >
                                            <span className="table-notification-chip__icon">
                                              <Icon size={13} strokeWidth={2.25} />
                                            </span>
                                            <span className="table-notification-chip__label">
                                              {label}
                                            </span>
                                          </span>
                                        </span>
                                      </Whisper>
                                    );
                                  }
                                }

                                // else if (col === "Days" || col === "targetDays") {
                                //   content = <div style={{ textAlign: 'center' }}>{holding.targetDays}</div>;
                                // }
                                // else if (col === "DaysLeft" || col === "days_remaining") {
                                //   content = <div style={{ textAlign: 'center' }}>{holding.days_remaining}</div>;
                                // }
                                else if (col === "Days" || col === "targetDays") {
                                  const targetDays = holding.targetDays;
                                  const daysRemaining = holding.days_remaining;

                                  content = (
                                    <div
                                      className="trade__price__cell"
                                      style={{
                                        textAlign: "center",
                                        width: "55px",
                                        margin: "auto",
                                      }}
                                    >
                                      {/* Target Days (Top) */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "16px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#64748B",
                                            fontWeight: "600",
                                          }}
                                        >
                                          D
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          {targetDays}
                                        </div>
                                      </div>

                                      {/* Separator Line */}
                                      <div
                                        style={{
                                          width: "25px",
                                          height: "1px",
                                          background:
                                            "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                          margin: "4px auto",
                                          opacity: "0.5",
                                        }}
                                      ></div>

                                      {/* Days Remaining (Bottom) */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "16px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#64748B",
                                            fontWeight: "600",
                                          }}
                                        >
                                          R
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          {daysRemaining}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                } else if (
                                  col === "DaysLeft" ||
                                  col === "days_remaining"
                                ) {
                                  content = <></>;
                                } else if (col === "Profit %") {
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice = livePriceCache.current[cacheKey];
                                  const currentPrice =
                                    livePrice || holding.CurrentPrice;
                                  const change =
                                    parseFloat(currentPrice) -
                                    parseFloat(holding.AvgRate);
                                  const changePercent = (
                                    (change / parseFloat(holding.AvgRate)) *
                                    100
                                  ).toFixed(2);
                                  const isPositive = change >= 0;

                                  content = (
                                    <div
                                      className={`trade__price__cell ${isPositive ? "text_success_color" : "text_danger_color"}`}
                                    >
                                      {isPositive ? "+" : ""}
                                      {changePercent}%
                                      <i
                                        className={`icon-arrow-${isPositive ? "up" : "down"}`}
                                      ></i>
                                    </div>
                                  );
                                } else if (col === "Volume") {
                                  const scripCode = holding.scripcode;
                                  const liveVolume =
                                    liveVolumeCache.current[scripCode];
                                  const volumeValue =
                                    liveVolume || holding.volume || 0;
                                  content = (
                                    <div style={{ textAlign: "center" }}>
                                      {formatNumber(volumeValue)}
                                    </div>
                                  );
                                } else if (col === "Trade Price") {
                                  content = (
                                    <div style={{ textAlign: "center" }}>
                                      ₹{formatNumber(holding.AvgRate)}
                                    </div>
                                  );
                                } else if (col === "Quantity") {
                                  content = (
                                    <div style={{ textAlign: "center" }}>
                                      {holding.DPQty}
                                    </div>
                                  );
                                } else if (col === "52WeekHigh") {
                                  content = (
                                    <div style={{ textAlign: "center" }}>
                                      {holding["52WeekHigh"]}
                                    </div>
                                  );
                                } else if (col === "52WeekLow") {
                                  content = (
                                    <div style={{ textAlign: "center" }}>
                                      {holding["52WeekLow"]}
                                    </div>
                                  );
                                } else if (col === "Actions") {
                                  content = (
                                    <ul
                                      className="table__action_hover"
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        top: 0,
                                        gap: "8px",
                                        paddingRight: "6px",
                                        minWidth: "max-content",
                                        border: "none",
                                        height: "98%",
                                        background:
                                          "linear-gradient(270deg, #FFFFFF 20%, rgba(255,255,255,0.9) 55%, rgba(255,255,255,0) 100%)",
                                      }}
                                    >
                                      <li>
                                        <div className="buy-sell-segmented">
                                          <button
                                            className="btn_buy wl-premium-action-btn wl-premium-buy"
                                            type="button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#BuySellModal"
                                            onClick={() => {
                                              SettingBuyModalDetails(
                                                holding,
                                                "Buy",
                                              );
                                            }}
                                          >
                                            {tr("buy")}
                                          </button>

                                          <button
                                            className="btn_sell wl-premium-action-btn wl-premium-sell"
                                            type="button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#BuySellModal"
                                            onClick={() => {
                                              SettingBuyModalDetails(
                                                holding,
                                                "Sell",
                                              );
                                            }}
                                          >
                                            {tr("sell")}
                                          </button>
                                        </div>
                                      </li>
                                      {!isGrowBroker && (
                                        <Whisper
                                          placement="top"
                                          trigger="hover"
                                          speaker={
                                            <Tooltip className="common__tooltip">
                                              {tr("marketDepth")}
                                            </Tooltip>
                                          }
                                        >
                                          <li>
                                            <button
                                              ref={marketDepthButtonRef}
                                              onClick={(e) =>
                                                handleMarketDepthClick(holding, e)
                                              }
                                              className="wl-premium-action-btn wl-premium-depth"
                                              style={{
                                                width: "38px",
                                                height: "34px",
                                                borderRadius: "8px",
                                                border: "none",
                                                background: "transparent",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                transition: "all 0.2s ease",
                                              }}
                                              onMouseEnter={(e) => {
                                                const el = e.currentTarget;
                                                el.style.background = "#F3F7FF";
                                                el.style.boxShadow =
                                                  "0 5px 14px rgba(20,38,71,0.20)";
                                                el.style.transform = "translateY(-1px)";
                                              }}
                                              onMouseLeave={(e) => {
                                                const el = e.currentTarget;
                                                el.style.background = "transparent";
                                                el.style.boxShadow = "none";
                                                el.style.transform = "none";
                                              }}
                                            >
                                              <MarketDepthIcon />
                                            </button>
                                          </li>
                                        </Whisper>
                                      )}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                      {/* ****************************          **********************************          ************************************ */}
                                    </ul>
                                  );
                                } else {
                                  content =
                                    holding[col] !== undefined &&
                                      holding[col] !== null
                                      ? holding[col]
                                      : "-";
                                  content = (
                                    <div
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {content}
                                    </div>
                                  );
                                }

                                return (
                                  <td
                                    key={col}
                                    className={
                                      col === "Actions" ? "action-cell" : undefined
                                    }
                                    style={{
                                      textAlign: getTableColumnAlignment(col),
                                      maxWidth: col === "Name" ? 260 : undefined,
                                      minWidth: col === "Name" ? 260 : undefined,
                                      width: col === "Name" ? 260 : undefined,
                                      paddingLeft:
                                        col === "Actions" ? 0 : col === "Notification" ? "10px" : undefined,
                                      paddingRight:
                                        col === "Actions" ? 0 : undefined,
                                      display: [
                                        "TodaysLow",
                                        "Profit %",
                                        "52WeekLow",
                                        "Target Price",
                                        "DaysLeft",
                                        "Net Change",
                                        "TodaysLow",
                                        "Target Price",
                                        "targetPrice",
                                      ].includes(col)
                                        ? "none"
                                        : undefined,
                                    }}
                                  >
                                    {content}
                                  </td>
                                );
                              })}
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </>
                )}
              </div>

              {/* {!isLoading && ( */}
              {!isLoading && holdings.length > 0 && (
                <div className="table__footer_row">
                  <div
                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <h6>
                      {getItemsRangeText(
                        indexOfFirstItem1 + 1,
                        Math.min(indexOfLastItem1, filteredHoldings1.length),
                        filteredHoldings1.length,
                      )}
                    </h6>
                    <TablePageSizeSelect
                      value={pageSize1}
                      onChange={handlePageSizeChange1}
                    />
                  </div>

                  <nav aria-label="Page navigation example">
                    <ul className="pagination justify-content-center">
                      {/* First Page Button */}
                      <li
                        className={`page-item ${currentPage1 === 1 ? "disabled" : ""}`}
                      >
                        <a
                          className="page-link"
                          onClick={() => currentPage1 > 1 && handlePageChange1(1)}
                          style={{
                            cursor:
                              currentPage1 === 1 ? "not-allowed" : "pointer",
                          }}
                          title="First Page"
                        >
                          {/* <i className="icon-arrow-prev-paging"></i>
            <i className="icon-arrow-prev-paging"></i> */}
                          <MdKeyboardDoubleArrowLeft
                            style={{ fontSize: "18px" }}
                          />
                        </a>
                      </li>

                      {/* Previous Page Button */}
                      <li
                        className={`page-item ${currentPage1 === 1 ? "disabled" : ""}`}
                      >
                        <a
                          className="page-link"
                          onClick={() =>
                            currentPage1 > 1 &&
                            handlePageChange1(currentPage1 - 1)
                          }
                          style={{
                            cursor:
                              currentPage1 === 1 ? "not-allowed" : "pointer",
                          }}
                          title="Previous Page"
                        >
                          {/* <i className="icon-arrow-prev-paging"></i> */}
                          <IoIosArrowBack />
                        </a>
                      </li>

                      {/* Page Numbers */}
                      {getPageNumbers1().map((pageNum) => (
                        <li
                          key={pageNum}
                          className={`page-item ${currentPage1 === pageNum ? "active" : ""}`}
                        >
                          <a
                            className="page-link"
                            onClick={() => handlePageChange1(pageNum)}
                            style={{ cursor: "pointer" }}
                          >
                            {pageNum}
                          </a>
                        </li>
                      ))}

                      {/* Next Page Button */}
                      <li
                        className={`page-item ${currentPage1 === totalPages1 ? "disabled" : ""}`}
                      >
                        <a
                          className="page-link"
                          onClick={() =>
                            currentPage1 < totalPages1 &&
                            handlePageChange1(currentPage1 + 1)
                          }
                          style={{
                            cursor:
                              currentPage1 === totalPages1
                                ? "not-allowed"
                                : "pointer",
                          }}
                          title="Next Page"
                        >
                          {/* <i className="icon-arrow-next-paging"></i> */}
                          <IoIosArrowForward />
                        </a>
                      </li>

                      {/* Last Page Button */}
                      <li
                        className={`page-item ${currentPage1 === totalPages1 ? "disabled" : ""}`}
                      >
                        <a
                          className="page-link"
                          onClick={() =>
                            currentPage1 < totalPages1 &&
                            handlePageChange1(totalPages1)
                          }
                          style={{
                            cursor:
                              currentPage1 === totalPages1
                                ? "not-allowed"
                                : "pointer",
                          }}
                          title="Last Page"
                        >
                          {/* <i className="icon-arrow-next-paging"></i>
            <i className="icon-arrow-next-paging"></i> */}
                          <MdKeyboardDoubleArrowRight
                            style={{ fontSize: "18px" }}
                          />
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>

            {/* Watchlist Value Over Time */}
            <div className="table_main">
              <div className="table_title_with_view_all_row">
                {/* <h5>Watchlist Value Over Time</h5> */}
                <h5>{tr("watchlistTargets")}</h5>
                <NavLink to="/Watchlist" className="view_all_link">
                  <span>{tr("viewAll")}</span> <i className="icon-arrow-view-all"></i>
                </NavLink>
              </div>

              <div className="table-responsive db-portfolio-targets-wrap table_dashboard_wtarget">
                {isLoading && (
                  <Placeholder.Grid
                    rows={20}
                    columns={9}
                    active
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }}
                  />
                )}

                {!isLoading && (
                  <>
                    <style>{`
      /* Watchlist Targets table highlight (scoped)
         Left: 100% opacity, Right: 0% opacity (same color) */
      .db-portfolio-targets-wrap{
        overflow-x: auto !important;
        overflow-y: visible !important;
        -webkit-overflow-scrolling: touch;
        width: 100%;
        min-width: 0;
      }
      .db-portfolio-targets-table{
        border-collapse: collapse;
        border-spacing: 0;
        width: max-content;
        min-width: 100%;
      }
      .db-portfolio-targets-table thead tr {
        position: static !important;
        top: auto !important;
        z-index: auto !important;
        background: #f8fbff !important;
      }
      .db-portfolio-targets-table thead tr th {
        position: sticky !important;
        top: 0px !important;
        z-index: 20 !important;
        background: #f8fbff !important;
      }
      .db-watchlist-targets td{
        background: transparent !important; /* let tr background be visible */
        background-color: transparent !important;
      }
      .db-watchlist-targets tr{
        background: #ffffff !important;
      }
      .db-watchlist-targets tr:nth-child(even){
        background: #fbfdff !important;
      }
      .db-watchlist-targets tr[style*="--target-bg-rgb"]{
        background: rgba(var(--target-bg-rgb), 0.22) !important;
      }
  
    `}</style>
                    <table className="table db-portfolio-targets-table">
                      <thead>
                        <tr>
                          {columnOrder2.map((col) => {
                            return (
                              <th
                                key={col}
                                draggable={col !== "Actions"}
                                onDragStart={(e) => handleDragStart2(e, col)}
                                onDragOver={(e) => handleDragOver2(e)}
                                onDrop={(e) => handleDrop2(e, col)}
                                onDragEnd={handleDragEnd2}
                                data-column-id={col}
                                style={{
                                  transition: "all 0.3s ease",
                                  transform:
                                    draggedColumn2 === col
                                      ? "scale(1.03)"
                                      : "scale(1)",
                                  boxShadow:
                                    draggedColumn2 === col
                                      ? "0 0 10px #C9E0FF"
                                      : "none",
                                  cursor: "grab",
                                  position: "sticky",
                                  top: 0,
                                  right: col === "Actions" ? 0 : undefined,
                                  zIndex: col === "Actions" ? 60 : 30,
                                  background:
                                    col === "Actions" ? "#f8fbff" : "#f6f6f6",
                                  textAlign: getTableColumnAlignment(col),
                                  maxWidth: col === "Name" ? 215 : undefined,
                                  minWidth: col === "Name" ? 215 : undefined,
                                  width: col === "Name" ? 215 : undefined,
                                  overflow: col === "Name" ? "hidden" : undefined,
                                  verticalAlign: "middle",
                                  textOverflow:
                                    col === "Name" ? "ellipsis" : undefined,
                                  whiteSpace:
                                    col === "Name" ? "nowrap" : undefined,
                                  paddingLeft: col === "Actions" ? 0 : col === "Notification" ? "10px" : undefined,
                                  paddingRight: col === "Actions" ? 0 : undefined,
                                  display: [
                                    "TodaysLow",
                                    "Profit %",
                                    "52WeekLow",
                                    "Target Price",
                                    "DaysLeft",
                                    "Net Change",
                                    "TodaysLow",
                                    "Target Price",
                                    "targetPrice",
                                  ].includes(col)
                                    ? "none"
                                    : undefined,
                                }}
                              >
                                {col === "Name" ? (
                                  <div className="table_head_search">
                                    <div style={{ padding: "2px" }}>
                                      <button
                                        style={{
                                          padding: "2px 0 2px 5px",
                                          borderRight: "1px solid #e4e4e4ff",
                                        }}
                                        onClick={() =>
                                          searchInputRef2.current?.focus()
                                        }
                                      >
                                        <i className="icon-search" />
                                      </button>

                                      <input
                                        type="text"
                                        placeholder={tr("nameSearchHere")}
                                        style={{
                                          paddingLeft: "10px",
                                          marginLeft: "5px",
                                          maxWidth: "150px",
                                          width: "100%",
                                          boxSizing: "border-box",
                                        }}
                                        value={searchQuery2}
                                        onChange={(e) =>
                                          setSearchQuery2(e.target.value)
                                        }
                                        ref={searchInputRef2}
                                      />
                                    </div>
                                    {/* <button><i className="icon-settings" /></button> */}
                                  </div>
                                ) : col === "Notification" ? (
                                  <Whisper
                                    placement="top"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip
                                        className="common__tooltip"
                                        style={{ maxWidth: "400px" }}
                                      >
                                        {translateColumnLabel(
                                          col,
                                          currentLanguage,
                                        )}
                                        :<br />- {tr("notificationColumnTooltip")}
                                      </Tooltip>
                                    }
                                  >
                                    <div
                                      style={{
                                        fontSize: "1em",
                                      }}
                                    >
                                      {translateColumnLabel(
                                        col,
                                        currentLanguage,
                                      )}
                                    </div>
                                  </Whisper>
                                ) : // : col === "Current Price" ? (
                                  //   <Whisper
                                  //     placement="top"
                                  //     trigger="hover"
                                  //     speaker={<Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                  //       Current Price:<br />
                                  //       - The real-time market price at which the stock is currently trading, also known as Last Traded Price (LTP).
                                  //     </Tooltip>}
                                  //   >
                                  //     <div style={{ minWidth: "110px" }}>
                                  //       {col}
                                  //     </div>
                                  //   </Whisper>
                                  // )
                                  col === "Current Price" ? (
                                    <Whisper
                                      placement="top"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip
                                          className="common__tooltip"
                                          style={{ maxWidth: "400px" }}
                                        >
                                          {tr("currentPriceNetChangeTitle")}:<br />-{" "}
                                          {tr("currentPriceNetChangeTop")}
                                          <br />-{" "}
                                          {tr("currentPriceNetChangeBottom")}
                                        </Tooltip>
                                      }
                                    >
                                      <div style={{ minWidth: "110px" }}>
                                        {translateColumnLabel(col, currentLanguage)}
                                      </div>
                                    </Whisper>
                                  ) : col === "Net Change" ? (
                                    <></>
                                  ) : // : col === "Net Change" ? (
                                    //   <Whisper
                                    //     placement="top"
                                    //     trigger="hover"
                                    //     speaker={<Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                    //       Net Change:<br />
                                    //       - Displays the absolute price difference and percentage change from the previous trading session's close

                                    //     </Tooltip>}
                                    //   >
                                    //     <div style={{ minWidth: "180px", paddingRight: "20px" }}>
                                    //       {col}
                                    //     </div>
                                    //   </Whisper>
                                    // )

                                    col === "Net Change" ? (
                                      <></>
                                    ) : // : col === "TodaysHigh" ? (
                                      //   <Whisper
                                      //     placement="top"
                                      //     trigger="hover"
                                      //     speaker={<Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                      //       Today's High:<br />
                                      //       - The highest price at which the stock has traded during the current trading session.
                                      //       <br />
                                      //       - Note: Highlighted in orange when the live price is near this level
                                      //     </Tooltip>}
                                      //   >
                                      //     <>
                                      //       Today's High/Low
                                      //     </>
                                      //   </Whisper>
                                      // )

                                      col === "TodaysHigh" ? (
                                        <Whisper
                                          placement="top"
                                          trigger="hover"
                                          speaker={
                                            <Tooltip
                                              className="common__tooltip"
                                              style={{ maxWidth: "400px" }}
                                            >
                                              {tr("todaysHighLowTitle")}:<br />
                                              - {tr("todaysHighLowTopDetail")}
                                              <br />- {tr("todaysHighLowBottomDetail")}
                                            </Tooltip>
                                          }
                                        >
                                          <>{tr("todaysHighLow")}</>
                                        </Whisper>
                                      ) : // :
                                        //      col === "Current Price" ? (
                                        //       <>
                                        //       Current Price
                                        //       </>
                                        //     )

                                        col === "Target %" ? (
                                          <Whisper
                                            placement="top"
                                            trigger="hover"
                                            speaker={
                                              <Tooltip
                                                className="common__tooltip"
                                                style={{ maxWidth: "400px" }}
                                              >
                                                {tr("targetPercent")}:<br />- {tr("targetPercentTooltip")}
                                              </Tooltip>
                                            }
                                          >
                                            <>{tr("targetPercent")}</>
                                          </Whisper>
                                        ) : col === "Target Price" ? (
                                          <></>
                                        ) : //                   : col === "Target Price" ? (
                                          //   <Whisper
                                          //     placement="top"
                                          //     trigger="hover"
                                          //     speaker={
                                          //       <Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                          //         Target Price:<br />
                                          //         - Your manually set price goal at which you plan to exit the position and book profits.
                                          //       </Tooltip>
                                          //     }
                                          //   >
                                          //     <>
                                          //       Target Price
                                          //     </>
                                          //   </Whisper>
                                          // )

                                          //                   : col === "Initial Price" ? (
                                          //   <Whisper
                                          //     placement="top"
                                          //     trigger="hover"
                                          //     speaker={
                                          //       <Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                          //         Initial Price:<br />
                                          //         - The stock's price at the time you set your target, used as a reference point to track price movement.
                                          //       </Tooltip>
                                          //     }
                                          //   >
                                          //     <>
                                          //       Initial/Target Price
                                          //     </>
                                          //   </Whisper>
                                          // )
                                          col === "Initial Price" ? (
                                            <Whisper
                                              placement="top"
                                              trigger="hover"
                                              speaker={
                                                <Tooltip
                                                  className="common__tooltip"
                                                  style={{ maxWidth: "400px" }}
                                                >
                                                  {tr("initialTargetPriceTitle")}:<br />
                                                  - {tr("initialTargetPriceTop")}
                                                  <br />- {tr("initialTargetPriceBottom")}
                                                </Tooltip>
                                              }
                                            >
                                              <>{tr("initialTargetPrice")}</>
                                            </Whisper>
                                          ) : col === "TodaysLow" ? (
                                            <></>
                                          ) : col === "Days" ? (
                                            <Whisper
                                              placement="top"
                                              trigger="hover"
                                              speaker={
                                                <Tooltip
                                                  className="common__tooltip"
                                                  style={{ maxWidth: "400px" }}
                                                >
                                                  {tr("daysRemainingTitle")}:
                                                  <br />
                                                  - {tr("daysRemainingTopDetail")}
                                                  <br />- {tr("daysRemainingBottomDetail")}
                                                </Tooltip>
                                              }
                                            >
                                              <>{tr("daysRemaining")}</>
                                            </Whisper>
                                          ) : col === "DaysLeft" ? (
                                            <></>
                                          ) : // : col === "TodaysLow" ? (
                                            //   <Whisper
                                            //     placement="top"
                                            //     trigger="hover"
                                            //     speaker={<Tooltip className="common__tooltip" style={{ maxWidth: '400px' }}>
                                            //       Today's Low:<br />
                                            //       - The lowest price at which the stock has traded during the current trading session.
                                            //       <br />
                                            //       - Note: Highlighted in red when the live price is near this level
                                            //     </Tooltip>}
                                            //   >
                                            //     <>
                                            //       Today's Low
                                            //     </>
                                            //   </Whisper>
                                            // )

                                            col === "Actions" ? (
                                              <></>
                                            ) : (
                                              translateColumnLabel(col, currentLanguage)
                                            )}
                                {renderHeaderMenu("watchlist", col, sortConfig2)}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>

                      <tbody className="db-watchlist-targets">
                        {watchlistHoldings.length === 0 ? (
                          <tr>
                            <td
                              colSpan={columns.length}
                              className="table-empty-state-cell"
                            >
                              <span className="table-empty-order-text">
                                No targets set yet. Set targets for your holdings to
                                track them here.
                              </span>
                            </td>
                          </tr>
                        ) : currentItems2.length === 0 ? (
                          <tr>
                            <td
                              colSpan={columnOrder2.length}
                              className="table-empty-state-cell"
                            >
                              No match found
                            </td>
                          </tr>
                        ) : (
                          currentItems2.map((holding, index) => (
                            <tr
                              key={holding.Symbol || index}
                              onClick={() => {
                                if (supportsCandleChart(broker_type)) {
                                  handleRowClick(holding);
                                }
                              }}
                              style={{
                                cursor: supportsCandleChart(broker_type)
                                  ? "pointer"
                                  : "default",
                                "--target-bg-rgb": (() => {
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice = parseFloat(
                                    livePriceCache.current?.[cacheKey],
                                  );
                                  const fallbackCurrentPrice = parseFloat(
                                    holding.CurrentPrice ?? holding.initialPrice,
                                  );
                                  const currentPrice = Number.isFinite(livePrice)
                                    ? livePrice
                                    : fallbackCurrentPrice;
                                  const targetPrice = parseFloat(
                                    holding.targetPrice,
                                  );
                                  const percentage = calculateTargetPercentage(
                                    currentPrice,
                                    targetPrice,
                                    holding.target_logic,
                                  );
                                  if (percentage === null) return undefined;

                                  //  - 90%  -> #e2ffed
                                  //  - 100% -> #e0ffea
                                  if (percentage >= 100) return "201,255,219"; // #e0ffea
                                  if (percentage >= 90) return "226,255,237"; // #e2ffed
                                  return undefined;
                                })(),
                              }}
                            >
                              {columnOrder2.map((col) => {
                                let content;

                                if (col === "Name") {
                                  const symbolName = String(
                                    holding.symbol ||
                                      holding.Symbol ||
                                      holding.TradingSymbol ||
                                      holding.name ||
                                      "",
                                  ).trim();
                                  const exchShort =
                                    holding.Exch === "N"
                                      ? "NSE"
                                      : holding.Exch === "B"
                                        ? "BSE"
                                        : holding.Exch === "M"
                                          ? "MCX"
                                          : "BSE";
                                  const exchSegment =
                                    holding.ExchType === "D"
                                      ? "Derivative"
                                      : "Cash";
                                  const exchFullLabel = `${exchShort} ${exchSegment}`;

                                  content = (
                                    <div
                                      className="main_table_company_cell"
                                      style={{ minWidth: 0 }}
                                    >
                                      <div style={{ paddingLeft: "10px", minWidth: 0 }}>
                                        <h5
                                          title={
                                            holding.full_name ||
                                            holding.fullName ||
                                            holding.name
                                          }
                                          style={{
                                            maxWidth: 145,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            margin: 0,
                                          }}
                                        >
                                          {holding.full_name ||
                                            holding.fullName ||
                                            holding.name}
                                        </h5>
                                        <ul
                                          className="company_table_tags"
                                          style={{
                                            paddingLeft: 0,
                                            marginTop: 4,
                                            flexWrap: "nowrap",
                                            alignItems: "center",
                                            marginBottom: 0,
                                            gap: "4px",
                                            minWidth: 0,
                                          }}
                                        >
                                          <li
                                            className="csymbol"
                                            style={{
                                              minWidth: 0,
                                              maxWidth: 85,
                                              overflow: "hidden",
                                            }}
                                          >
                                            <Whisper
                                              placement="top"
                                              trigger="hover"
                                              speaker={
                                                <Tooltip
                                                  className="common__tooltip"
                                                  style={{ maxWidth: "320px" }}
                                                >
                                                  {symbolName || "-"}
                                                </Tooltip>
                                              }
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  maxWidth: "100%",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  verticalAlign: "bottom",
                                                  cursor: "default",
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                {symbolName || "-"}
                                              </span>
                                            </Whisper>
                                          </li>
                                          <li
                                            className="cbse_nse"
                                            style={{
                                              minWidth: 0,
                                              flexShrink: 0,
                                            }}
                                          >
                                            <Whisper
                                              placement="top"
                                              trigger="hover"
                                              speaker={
                                                <Tooltip className="common__tooltip">
                                                  {exchFullLabel}
                                                </Tooltip>
                                              }
                                            >
                                              <span
                                                style={{
                                                  cursor: "default",
                                                  whiteSpace: "nowrap",
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                {exchShort}
                                              </span>
                                            </Whisper>
                                          </li>
                                          <Whisper
                                            placement="top"
                                            trigger="hover"
                                            speaker={
                                              <Tooltip className="common__tooltip">
                                                Set Target
                                              </Tooltip>
                                            }
                                          >
                                            <li
                                              className="cset__target"
                                              role="button"
                                              tabIndex={0}
                                              aria-label="Set Target"
                                              style={{
                                                zIndex: 30,
                                                minWidth: "unset",
                                                padding: "2px 6px",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                lineHeight: 1,
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                openSetTargetModal(holding);
                                              }}
                                              onKeyDown={(e) => {
                                                if (
                                                  e.key === "Enter" ||
                                                  e.key === " "
                                                ) {
                                                  e.preventDefault();
                                                  e.stopPropagation();
                                                  openSetTargetModal(holding);
                                                }
                                              }}
                                            >
                                              <TbTarget size={16} />
                                            </li>
                                          </Whisper>
                                        </ul>
                                      </div>
                                    </div>
                                  );
                                } else if (col === "Current Price") {
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice =
                                    livePriceCache.current[cacheKey];
                                  const pClose =
                                    livePCloseCache.current[cacheKey];
                                  const currentPrice =
                                    livePrice || holding.CurrentPrice || holding.initialPrice || "-";
                                  const previousClose =
                                    pClose ||
                                    holding.PreviousClose ||
                                    holding.CurrentPrice ||
                                    holding.initialPrice ||
                                    currentPrice;
                                  const isValidPrice =
                                    currentPrice !== "-" &&
                                    previousClose !== "-" &&
                                    currentPrice &&
                                    previousClose;
                                  const isPositive = isValidPrice
                                    ? parseFloat(currentPrice) >=
                                    parseFloat(previousClose)
                                    : true;

                                  // Get Net Change data
                                  const currentPriceNum = parseFloat(currentPrice);
                                  const previousCloseNum = parseFloat(previousClose);
                                  const apiDayChange = Number(holding?.stocks_data?.day_change);
                                  const apiDayChangePerc = Number(holding?.stocks_data?.day_change_perc);
                                  const hasApiChangeData =
                                    Number.isFinite(apiDayChange) &&
                                    Number.isFinite(apiDayChangePerc);
                                  const fallbackPriceDifference =
                                    Number.isFinite(currentPriceNum) &&
                                      Number.isFinite(previousCloseNum)
                                      ? currentPriceNum - previousCloseNum
                                      : NaN;
                                  const fallbackChangePercent =
                                    Number.isFinite(fallbackPriceDifference) &&
                                      Number.isFinite(previousCloseNum) &&
                                      previousCloseNum !== 0
                                      ? (fallbackPriceDifference / previousCloseNum) * 100
                                      : NaN;
                                  const priceDifference = Number.isFinite(fallbackPriceDifference)
                                    ? fallbackPriceDifference
                                    : hasApiChangeData
                                      ? apiDayChange
                                      : NaN;
                                  const changePercent = Number.isFinite(fallbackChangePercent)
                                    ? fallbackChangePercent
                                    : hasApiChangeData
                                      ? apiDayChangePerc
                                      : NaN;
                                  const hasChangeData =
                                    Number.isFinite(priceDifference) &&
                                    Number.isFinite(changePercent);
                                  const isChangePositive = hasChangeData
                                    ? priceDifference >= 0
                                    : isPositive;
                                  if (!hasChangeData) {
                                    console.log("netchangeeee table2 missing change data", {
                                      symbol: holding?.symbol || holding?.name,
                                      cacheKey,
                                      currentPrice,
                                      previousClose,
                                      currentPriceNum,
                                      previousCloseNum,
                                      apiDayChangeRaw: holding?.stocks_data?.day_change,
                                      apiDayChangePercRaw: holding?.stocks_data?.day_change_perc,
                                      fallbackPriceDifference,
                                      fallbackChangePercent,
                                      hasApiChangeData,
                                      holding,
                                    });
                                  }

                                  content = (
                                    <div
                                      className={`trade__price__cell ${isValidPrice && isPositive
                                        ? "text_success_color"
                                        : isValidPrice && !isPositive
                                          ? "text_danger_color"
                                          : ""
                                        }`}
                                    >
                                      {/* Current Price (Top) */}
                                      <div>
                                        {currentPrice !== "-"
                                          ? `₹${formatNumber(currentPrice)}`
                                          : "-"}
                                        {isValidPrice && (
                                          <i
                                            className={`icon-arrow-${isPositive ? "up" : "down"}`}
                                            style={{ paddingLeft: "2px" }}
                                          ></i>
                                        )}
                                      </div>

                                      {/* Net Change (Bottom) */}
                                      <div style={{ marginTop: "2px" }}>
                                        {hasChangeData ? (
                                          <>
                                            {isChangePositive ? "+" : "-"}₹
                                            {Math.abs(priceDifference).toFixed(2)}
                                            <span style={{ paddingLeft: "4px" }}>
                                              ({isChangePositive ? "+" : "-"}
                                              {Math.abs(changePercent).toFixed(2)}%)
                                            </span>
                                          </>
                                        ) : (
                                          <span style={{ color: "gray" }}>-</span>
                                        )}
                                      </div>
                                    </div>
                                  );
                                } else if (col === "Net Change") {
                                  content = <></>;
                                }

                                // TodaysHigh Column (merged with TodaysLow)
                                else if (col === "TodaysHigh") {
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const liveDayHigh =
                                    liveHighCache.current[cacheKey];
                                  const liveDayLow =
                                    liveLowCache.current[cacheKey];
                                  const currentDayHigh =
                                    liveDayHigh || holding.TodaysHigh || 0;
                                  const currentDayLow =
                                    liveDayLow || holding.TodaysLow || 0;

                                  // Get live price to check if near high/low
                                  const livePrice =
                                    livePriceCache.current[cacheKey] ||
                                    holding.LTP;

                                  // Check if price is within 0.5% of day's high or low
                                  const isNearHigh =
                                    currentDayHigh > 0 &&
                                    Math.abs(
                                      ((livePrice - currentDayHigh) /
                                        currentDayHigh) *
                                      100,
                                    ) < 0.5;
                                  const isNearLow =
                                    currentDayLow > 0 &&
                                    Math.abs(
                                      ((livePrice - currentDayLow) /
                                        currentDayLow) *
                                      100,
                                    ) < 0.5;

                                  content = (
                                    <div
                                      className="trade__price__cell"
                                      style={{
                                        textAlign: "center",
                                        width: "115px",
                                        margin: "auto",
                                      }}
                                    >
                                      {/* Today's High (Top) */}
                                      <div
                                        className={
                                          isNearHigh ? "text_warning_color" : ""
                                        }
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "20px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          width: "120px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#16A34A",
                                            fontWeight: "600",
                                          }}
                                        >
                                          H
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          ₹{formatNumber(currentDayHigh)}
                                          {isNearHigh && (
                                            <i
                                              className="icon-arrow-up"
                                              style={{
                                                color: "#FFA726",
                                                marginLeft: "4px",
                                              }}
                                            ></i>
                                          )}
                                        </div>
                                      </div>

                                      {/* Separator Line */}
                                      <div
                                        style={{
                                          width: "30px",
                                          height: "1px",
                                          background:
                                            "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                          margin: "4px auto",
                                          opacity: "0.5",
                                        }}
                                      ></div>

                                      {/* Today's Low (Bottom) */}
                                      <div
                                        className={
                                          isNearLow ? "text_danger_color" : ""
                                        }
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "20px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                          width: "120px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#DC2626",
                                            fontWeight: "600",
                                          }}
                                        >
                                          L
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          ₹{formatNumber(currentDayLow)}
                                          {isNearLow && (
                                            <i
                                              className="icon-arrow-down"
                                              style={{
                                                color: "#EF5350",
                                                marginLeft: "4px",
                                              }}
                                            ></i>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }

                                // TodaysLow Column
                                else if (col === "TodaysLow") {
                                  content = <></>;
                                } else if (
                                  col === "Initial Price" ||
                                  col === "initialPrice"
                                ) {
                                  const initialPrice = holding["initialPrice"];
                                  const targetPrice = holding["targetPrice"];

                                  content = (
                                    <div
                                      className="trade__price__cell"
                                      style={{
                                        textAlign: "center",
                                        width: "110px",
                                        margin: "auto",
                                      }}
                                    >
                                      {/* Initial Price (Top) */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "20px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#2457BF",
                                            fontWeight: "600",
                                          }}
                                        >
                                          I
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          ₹{formatNumber(initialPrice) || "-"}
                                        </div>
                                      </div>

                                      {/* Separator Line */}
                                      <div
                                        style={{
                                          width: "30px",
                                          height: "1px",
                                          background:
                                            "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                          margin: "4px auto",
                                          opacity: "0.5",
                                        }}
                                      ></div>

                                      {/* Target Price (Bottom) */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "20px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#D67A1F",
                                            fontWeight: "600",
                                          }}
                                        >
                                          T
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          ₹{formatNumber(targetPrice) || "-"}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                } else if (
                                  col === "Target Price" ||
                                  col === "targetPrice"
                                ) {
                                  content = <></>;
                                } else if (
                                  col === "Watchlist" ||
                                  col === "watchlist"
                                ) {
                                  // Define color palette for dynamic watchlist colors (up to 5)
                                  const colorPalette = [
                                    "#D67A1F", // Orange (your accent)
                                    "#2457BF", // Blue (your accent)
                                    "#059669", // Emerald Green
                                    "#DC2626", // Red
                                    "#7C3AED", // Violet
                                  ];

                                  // Lighter shades for background
                                  const bgPalette = [
                                    "rgba(214, 122, 31, 0.12)", // Light orange
                                    "rgba(36, 87, 191, 0.12)", // Light blue
                                    "rgba(5, 150, 105, 0.12)", // Light emerald
                                    "rgba(220, 38, 38, 0.12)", // Light red
                                    "rgba(124, 58, 237, 0.12)", // Light violet
                                  ];

                                  const watchlistName =
                                    holding["source_watchlist"] || "Unassigned";

                                  let colorIndex = 0;
                                  if (
                                    userWatchlists &&
                                    Array.isArray(userWatchlists)
                                  ) {
                                    colorIndex =
                                      userWatchlists.indexOf(watchlistName);
                                    if (colorIndex === -1) colorIndex = 0;
                                  }

                                  const bgColor =
                                    colorPalette[
                                    colorIndex % colorPalette.length
                                    ];
                                  const lightBg =
                                    bgPalette[colorIndex % bgPalette.length];

                                  const firstLetter = (watchlistName || "?")
                                    .charAt(0)
                                    .toUpperCase();

                                  content = (
                                    <span className="notification-tooltip-wrapper">
                                      <span
                                        style={{
                                          position: "relative",
                                          cursor: "pointer",
                                          zIndex: 120,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          padding: "6px",
                                          width: "26px",
                                          height: "26px",
                                          borderRadius: "999px",
                                          backgroundColor: lightBg,
                                          border: `1.5px solid ${bgColor}`,
                                          color: bgColor,
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          letterSpacing: "0.3px",
                                          boxShadow: `0 2px 8px ${bgColor}20`,
                                        }}
                                      >
                                        {firstLetter}
                                      </span>

                                      <span
                                        className="notification-tooltip-bubble"
                                        style={{ zIndex: 130000 }}
                                      >
                                        {watchlistName}
                                      </span>
                                    </span>
                                  );
                                } else if (
                                  col === "Target %" ||
                                  col === "TargetPercent"
                                ) {
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice = parseFloat(
                                    livePriceCache.current?.[cacheKey],
                                  );
                                  const fallbackCurrentPrice = parseFloat(
                                    holding.CurrentPrice ?? holding.initialPrice,
                                  );
                                  const targetPrice = parseFloat(
                                    holding.targetPrice,
                                  );
                                  const targetLogic = holding.target_logic;
                                  const reasonText =
                                    holding.targetReason ||
                                    holding.target_reason ||
                                    holding.reason ||
                                    "";
                                  const reasonDetailsText =
                                    holding.targetReasonDetails ||
                                    holding.target_reason_details ||
                                    holding.reason_details ||
                                    "";
                                  const hasReason = !!String(reasonText).trim();
                                  const currentPrice = Number.isFinite(livePrice)
                                    ? livePrice
                                    : fallbackCurrentPrice;
                                  const percentage = calculateTargetPercentage(
                                    currentPrice,
                                    targetPrice,
                                    targetLogic,
                                  );

                                  if (isNaN(targetPrice)) {
                                    content = (
                                      <span className="medium_font dark_grey_color">
                                        -
                                      </span>
                                    );
                                  } else if (percentage !== null) {

                                    // Darker gradient with better contrast on white
                                    const getTargetColor = (percentage) => {
                                      const clampedPercent = Math.max(
                                        0,
                                        Math.min(100, percentage),
                                      );

                                      const colors = [
                                        { max: 10, color: "#C62828" }, // Dark Red
                                        { max: 20, color: "#D84315" }, // Dark Orange-Red
                                        { max: 30, color: "#E65100" }, // Dark Orange
                                        { max: 40, color: "#EF6C00" }, // Orange
                                        { max: 50, color: "#F57C00" }, // Amber
                                        { max: 60, color: "#F9A825" }, // Dark Yellow
                                        { max: 70, color: "#AFB42B" }, // Olive/Lime
                                        { max: 80, color: "#7CB342" }, // Light Green
                                        { max: 90, color: "#43A047" }, // Green
                                        { max: 100, color: "#2E7D32" }, // Dark Green
                                      ];

                                      const range = colors.find(
                                        (c) => clampedPercent <= c.max,
                                      );
                                      return range ? range.color : "#C62828";
                                    };

                                    const textColor = getTargetColor(percentage);

                                    content = (
                                      <div
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 6,
                                        }}
                                      >
                                        <span
                                          className="medium_font"
                                          style={{
                                            color: textColor,
                                            fontWeight: "600",
                                          }}
                                        >
                                          {percentage.toFixed(2)}%
                                        </span>

                                        {hasReason ? (
                                          <Whisper
                                            placement="top"
                                            trigger="hover"
                                            speaker={
                                              <Tooltip
                                                className="common__tooltip"
                                                style={{ maxWidth: "320px" }}
                                              >
                                                <div>
                                                  <b>Reason:</b>{" "}
                                                  {String(reasonText).trim()}
                                                </div>
                                                <div style={{ marginTop: "4px" }}>
                                                  <b>Details:</b>{" "}
                                                  {String(
                                                    reasonDetailsText,
                                                  ).trim() ||
                                                    "No additional details provided."}
                                                </div>
                                              </Tooltip>
                                            }
                                          >
                                            <button
                                              type="button"
                                              data-bs-toggle="modal"
                                              data-bs-target="#TargetReasonDetailsModal"
                                              aria-label="View target reason details"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setTargetReasonModalData({
                                                  stockName:
                                                    holding.fullName ||
                                                    holding.name ||
                                                    holding.symbol ||
                                                    "-",
                                                  reason:
                                                    String(reasonText).trim(),
                                                  details:
                                                    String(
                                                      reasonDetailsText,
                                                    ).trim(),
                                                });
                                              }}
                                              style={{
                                                width: "16px",
                                                height: "16px",
                                                minWidth: "16px",
                                                borderRadius: "50%",
                                                border: "1px solid #CBD5E1",
                                                background: "#FFFFFF",
                                                color: "#475569",
                                                fontSize: "11px",
                                                fontWeight: 700,
                                                lineHeight: 1,
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                padding: 0,
                                              }}
                                            >
                                              !
                                            </button>
                                          </Whisper>
                                        ) : null}
                                      </div>
                                    );
                                  } else {
                                    content = (
                                      <span className="medium_font dark_grey_color">
                                        --
                                      </span>
                                    );
                                  }
                                } else if (col === "Notification") {
                                  const target = parseFloat(holding.targetPrice);
                                  const cacheKey = getLivePriceCacheKey(holding);
                                  const livePrice = parseFloat(
                                    livePriceCache.current?.[cacheKey],
                                  );
                                  const fallbackCurrentPrice = parseFloat(
                                    holding.CurrentPrice ?? holding.initialPrice,
                                  );
                                  const currentPrice = Number.isFinite(livePrice)
                                    ? livePrice
                                    : fallbackCurrentPrice;
                                  const percentage = calculateTargetPercentage(
                                    currentPrice,
                                    target,
                                    holding.target_logic,
                                  );

                                  if (percentage === null) {
                                    content = (
                                      <span className="medium_font dark_grey_color">
                                        -
                                      </span>
                                    );
                                  } else {

                                    const { Icon, color, label, message, variant } =
                                      getNotificationMeta(percentage);

                                    content = (
                                      <Whisper
                                        placement="top"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip
                                            className="common__tooltip"
                                            style={{ maxWidth: "320px" }}
                                          >
                                            <div>
                                              <b>{label}</b>
                                            </div>
                                            <div style={{ marginTop: "4px" }}>
                                              {message}
                                            </div>
                                          </Tooltip>
                                        }
                                      >
                                        <span
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            cursor: "default",
                                            width: "100%",
                                          }}
                                        >
                                          <span
                                            className={`table-notification-chip table-notification-chip--${variant}`}
                                            style={{ "--chip-accent": color }}
                                          >
                                            <span className="table-notification-chip__icon">
                                              <Icon size={13} strokeWidth={2.25} />
                                            </span>
                                            <span className="table-notification-chip__label">
                                              {label}
                                            </span>
                                          </span>
                                        </span>
                                      </Whisper>
                                    );
                                  }
                                } else if (
                                  col === "Days" ||
                                  col === "targetDays"
                                ) {
                                  const created = new Date(holding.createdDate);
                                  const today = new Date();
                                  const diffTime = today - created;
                                  const daysPassed = Math.floor(
                                    diffTime / (1000 * 60 * 60 * 24),
                                  );
                                  const daysLeft =
                                    holding.targetDays - daysPassed;
                                  const daysRemaining =
                                    daysLeft >= 0 ? daysLeft : 0;

                                  content = (
                                    <div
                                      className="trade__price__cell"
                                      style={{
                                        textAlign: "center",
                                        width: "50px",
                                        margin: "auto",
                                      }}
                                    >
                                      {/* Target Days (Top) */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "16px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#64748B",
                                            fontWeight: "600",
                                          }}
                                        >
                                          D
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          {holding.targetDays}
                                        </div>
                                      </div>

                                      {/* Separator Line */}
                                      <div
                                        style={{
                                          width: "25px",
                                          height: "1px",
                                          background:
                                            "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                          margin: "4px auto",
                                          opacity: "0.5",
                                        }}
                                      ></div>

                                      {/* Days Left (Bottom) */}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "16px 1fr",
                                          alignItems: "center",
                                          justifyItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "0.7em",
                                            opacity: "0.6",
                                            color: "#64748B",
                                            fontWeight: "600",
                                          }}
                                        >
                                          R
                                        </span>
                                        <div style={{ textAlign: "center" }}>
                                          {daysRemaining}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                } else if (
                                  col === "DaysLeft" ||
                                  col === "days_remaining"
                                ) {
                                  content = <></>;
                                } else if (col === "Actions") {
                                  content = (
                                    <ul
                                      className="table__action_hover"
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        top: "0",
                                        gap: "8px",
                                        paddingRight: "6px",
                                        minWidth: "max-content",
                                        border: "none",
                                        height: "98%",
                                        background:
                                          "linear-gradient(270deg, #FFFFFF 20%, rgba(255,255,255,0.9) 55%, rgba(255,255,255,0) 100%)",
                                      }}
                                    >
                                      <li>
                                        <div className="buy-sell-segmented">
                                          <button
                                            className="btn_buy wl-premium-action-btn wl-premium-buy"
                                            type="button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#BuySellModal"
                                            onClick={() => {
                                              const modifiedHolding = {
                                                ...holding,
                                              };
                                              if (holding.exch?.charAt(0) === "B")
                                                modifiedHolding.Exch = "B";
                                              else if (
                                                holding.exch?.charAt(0) === "N"
                                              )
                                                modifiedHolding.Exch = "N";
                                              else if (
                                                holding.exch?.charAt(0) === "M"
                                              )
                                                modifiedHolding.Exch = "M";
                                              if (
                                                holding.exchType?.charAt(0) === "C"
                                              )
                                                modifiedHolding.ExchType = "C";
                                              else if (
                                                holding.exchType?.charAt(0) === "D"
                                              )
                                                modifiedHolding.ExchType = "D";
                                              if (holding.name)
                                                modifiedHolding.Symbol =
                                                  holding.name;
                                              SettingBuyModalDetails(
                                                modifiedHolding,
                                                "Buy",
                                              );
                                            }}
                                          >
                                            Buy
                                          </button>

                                          <button
                                            className="btn_sell wl-premium-action-btn wl-premium-sell"
                                            type="button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#BuySellModal"
                                            onClick={() =>
                                              SettingBuyModalDetails(
                                                holding,
                                                "Sell",
                                              )
                                            }
                                          >
                                            Sell
                                          </button>
                                        </div>
                                      </li>
                                      {/* <Whisper placement="top" trigger="hover" speaker={<Tooltip className="common__tooltip">Market Depth</Tooltip>}>
                  <li>
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#MarketDepthModal"
                      onClick={() => {
                        setcurrentMDModal(holding);
                        subscribeToMarketDepth(holding);
                      }}
                      className="btn_trading"
                    >
                      <MarketDepthIcon />
                    </button>
                  </li>
                </Whisper> */}
                                      {!isGrowBroker && (
                                        <Whisper
                                          placement="top"
                                          trigger="hover"
                                          speaker={
                                            <Tooltip className="common__tooltip">
                                              {tr("marketDepth")}
                                            </Tooltip>
                                          }
                                        >
                                          <li>
                                            <button
                                              ref={marketDepthButtonRef}
                                              onClick={(e) =>
                                                handleMarketDepthClick(holding, e)
                                              }
                                              className="wl-premium-action-btn wl-premium-depth"
                                              style={{
                                                width: "38px",
                                                height: "34px",
                                                borderRadius: "8px",
                                                border: "none",
                                                background: "transparent",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                transition: "all 0.2s ease",
                                              }}
                                              onMouseEnter={(e) => {
                                                const el = e.currentTarget;
                                                el.style.background = "#F3F7FF";
                                                el.style.boxShadow =
                                                  "0 5px 14px rgba(20,38,71,0.20)";
                                                el.style.transform = "translateY(-1px)";
                                              }}
                                              onMouseLeave={(e) => {
                                                const el = e.currentTarget;
                                                el.style.background = "transparent";
                                                el.style.boxShadow = "none";
                                                el.style.transform = "none";
                                              }}
                                            >
                                              <MarketDepthIcon />
                                            </button>
                                          </li>
                                        </Whisper>
                                      )}
                                    </ul>
                                  );
                                } else {
                                  content =
                                    holding[col] !== undefined &&
                                      holding[col] !== null
                                      ? holding[col]
                                      : "-";
                                  content = (
                                    <div
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {content}
                                    </div>
                                  );
                                }

                                return (
                                  <td
                                    key={col}
                                    className={
                                      col === "Actions"
                                        ? "action-cell"
                                        : col === "Current Price"
                                          ? "width165"
                                          : undefined
                                    }
                                    style={{
                                      textAlign: getTableColumnAlignment(col),
                                      maxWidth: col === "Name" ? 200 : undefined,
                                      minWidth: col === "Name" ? 200 : undefined,
                                      width: col === "Name" ? 200 : undefined,
                                      paddingLeft:
                                        col === "Actions" ? 0 : col === "Notification" ? "10px" : undefined,
                                      paddingRight:
                                        col === "Actions" ? 0 : undefined,
                                      display: [
                                        "TodaysLow",
                                        "Profit %",
                                        "52WeekLow",
                                        "Target Price",
                                        "DaysLeft",
                                        "Net Change",
                                        "TodaysLow",
                                        "Target Price",
                                        "targetPrice",
                                      ].includes(col)
                                        ? "none"
                                        : undefined,
                                    }}
                                  >
                                    {content}
                                  </td>
                                );
                              })}
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </>
                )}
              </div>

              {/* {!isLoading && ( */}
              {!isLoading && filteredHoldings2.length > 0 && (
                <div className="table__footer_row">
                  <div
                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <h6>
                      {getItemsRangeText(
                        indexOfFirstItem2 + 1,
                        Math.min(indexOfLastItem2, filteredHoldings2.length),
                        filteredHoldings2.length,
                      )}
                    </h6>
                    <TablePageSizeSelect
                      value={pageSize2}
                      onChange={handlePageSizeChange2}
                    />
                  </div>

                  <nav aria-label="Page navigation example">
                    <ul className="pagination justify-content-center">
                      {/* First Page Button */}
                      <li
                        className={`page-item ${currentPage2 === 1 ? "disabled" : ""}`}
                      >
                        <a
                          className="page-link"
                          onClick={() => currentPage2 > 1 && handlePageChange2(1)}
                          style={{
                            cursor:
                              currentPage2 === 1 ? "not-allowed" : "pointer",
                          }}
                          title="First Page"
                        >
                          <MdKeyboardDoubleArrowLeft
                            style={{ fontSize: "18px" }}
                          />
                        </a>
                      </li>

                      {/* Previous Page Button */}
                      <li
                        className={`page-item ${currentPage2 === 1 ? "disabled" : ""}`}
                      >
                        <a
                          className="page-link"
                          onClick={() =>
                            currentPage2 > 1 &&
                            handlePageChange2(currentPage2 - 1)
                          }
                          style={{
                            cursor:
                              currentPage2 === 1 ? "not-allowed" : "pointer",
                          }}
                          title="Previous Page"
                        >
                          <IoIosArrowBack />
                        </a>
                      </li>

                      {/* Page Numbers */}
                      {getPageNumbers2().map((pageNum) => (
                        <li
                          key={pageNum}
                          className={`page-item ${currentPage2 === pageNum ? "active" : ""}`}
                        >
                          <a
                            className="page-link"
                            onClick={() => handlePageChange2(pageNum)}
                            style={{ cursor: "pointer" }}
                          >
                            {pageNum}
                          </a>
                        </li>
                      ))}

                      {/* Next Page Button */}
                      <li
                        className={`page-item ${currentPage2 === totalPages2 ? "disabled" : ""}`}
                      >
                        <a
                          className="page-link"
                          onClick={() =>
                            currentPage2 < totalPages2 &&
                            handlePageChange2(currentPage2 + 1)
                          }
                          style={{
                            cursor:
                              currentPage2 === totalPages2
                                ? "not-allowed"
                                : "pointer",
                          }}
                          title="Next Page"
                        >
                          <IoIosArrowForward />
                        </a>
                      </li>

                      {/* Last Page Button */}
                      <li
                        className={`page-item ${currentPage2 === totalPages2 ? "disabled" : ""}`}
                      >
                        <a
                          className="page-link"
                          onClick={() =>
                            currentPage2 < totalPages2 &&
                            handlePageChange2(totalPages2)
                          }
                          style={{
                            cursor:
                              currentPage2 === totalPages2
                                ? "not-allowed"
                                : "pointer",
                          }}
                          title="Last Page"
                        >
                          <MdKeyboardDoubleArrowRight
                            style={{ fontSize: "18px" }}
                          />
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>
          </>
        </div>
      </div >

      {/* Buy Sell Modal */}
      <div
        className="modal fade modal_md modern-trading-modal"
        id="BuySellModal"
        aria-labelledby="BuySellModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-modern">
          <div className="modal-content modal-content-modern">
            {/* Modal Header */}
            <div className="modal-header modal-header-modern">
              <div className="modal-header-content">
                <div className="modal-title-wrapper">
                  <div className={`trading-type-badge ${buySellModalDetails.Type.toLowerCase()}`}>
                    <img
                      src={
                        buySellModalDetails.Type === "Buy"
                          ? ArrowTrendUp
                          : ArrowTrendDown
                      }
                      className="trading-icon"
                      alt="icon"
                    />
                    <span className="trading-type-text">{buySellModalDetails.Type}</span>
                  </div>
                  <h3 className="modal-title-modern">
                    {buySellModalDetails.Symbol}
                  </h3>
                </div>
                <button
                  type="button"
                  className="btn-close-modern"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>

            <div className="modal-body modal-body-modern">
              <AnimatePresence mode="wait">
                {/* Screen 1 */}
                {!isPreview && (
                  <motion.div
                    key="screen1"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <div
                      className="sell__content"
                      style={{
                        backgroundColor:
                          buySellModalDetails.Type === "Buy"
                            ? "#F6FCF9"
                            : "#fff7f7",
                        border: `1px solid ${buySellModalDetails.Type === "Buy" ? "#B5E8CF" : "#F5B5B5"}`,
                      }}
                    >
                      <div className="sell__content_inner d-flex justify-content-between align-items-center">
                        <div>
                          <h5 className="mb-0">{buySellModalDetails.Symbol}</h5>
                          <h6 className="mb-0">
                            {buySellModalDetails.FullName}
                          </h6>
                        </div>
                        {/* LivePrice/ Current Price */}
                        <p className="mb-0">
                          {(() => {
                            const cacheKey = getLivePriceCacheKey(
                              buySellModalDetails.order,
                            );
                            const livePrice = livePriceCache.current[cacheKey];
                            const pClose = livePCloseCache.current[cacheKey];
                            const changePercent =
                              liveChangePercentageCache.current[cacheKey];

                            const currentPrice =
                              livePrice ||
                              buySellModalDetails.order?.CurrentPrice ||
                              0;
                            const previousClose =
                              pClose ||
                              buySellModalDetails.order?.CurrentPrice ||
                              0;
                            const actualChangePercent = changePercent || 0;

                            const isPositive =
                              parseFloat(currentPrice) >=
                              parseFloat(previousClose);

                            return (
                              <>
                                ₹ {formatNumber(currentPrice)} <br />
                                <span
                                  className={
                                    isPositive ? "text-success" : "text-danger"
                                  }
                                >
                                  ({isPositive ? "+" : ""}
                                  {actualChangePercent
                                    ? actualChangePercent.toFixed(2)
                                    : "0.00"}
                                  %)
                                  <i
                                    className={`icon-arrow-${isPositive ? "up" : "down"} ms-1`}
                                    style={{ fontSize: "0.8em" }}
                                  ></i>
                                </span>
                              </>
                            );
                          })()}
                        </p>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', color: '#64748b', marginBottom: '6px' }}>{tr("orderType")}</label>
                        <SelectPicker
                          data={OrderType}
                          searchable={false}
                          container={document.body}
                          className="custom-select-picker"
                          value={orderType}
                          onChange={setOrderType}
                        />
                      </div>

                      {/* <div className="col-md-6">
                        <label className="form-label">Qty</label>
                        <input
                          type="number"
                          className="form-control"
                          value={qty}
                          onChange={(e) => setQty(Number(e.target.value))}
                        />
                      </div> */}
                      <div className="col-md-6">
                        <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', color: '#64748b', marginBottom: '6px' }}>{tr("qty")}</label>
                        <input
                          type="number"
                          className="form-control"
                          value={buySellModalDetails.OrderQty}
                          onChange={(e) =>
                            setBuySellModalDetails((prev) => ({
                              ...prev,
                              OrderQty: Number(e.target.value),
                            }))
                          }
                          style={{
                            width: "100%",
                            height: "44px",
                            borderRadius: "10px",
                            border: "1px solid #d5dfed",
                            padding: "10px 12px",
                            fontSize: "14px",
                            color: "#0f172a",
                            outline: "none",
                            boxShadow: "none"
                          }}
                        />
                      </div>
                    </div>

                    {/* {orderType === "Limit Order" && (
                      <div className="mt-3">
                        <label className="form-label">Limit Price</label>
                        <input type="number" className="form-control" />
                      </div>
                    )} */}
                    {orderType === "Limit Order" && (
                      <div className="mt-3">
                        <label className="form-label">Limit Price</label>
                        <input
                          type="number"
                          className="form-control"
                          value={buySellModalDetails.LimitPrice}
                          onChange={(e) =>
                            setBuySellModalDetails((prev) => ({
                              ...prev,
                              LimitPrice: Number(e.target.value),
                            }))
                          }
                        />
                      </div>
                    )}

                    {buySellModalDetails.OrderQty > 0 && (
                      <motion.div
                        className="order-summary mt-4 p-3 border roundedX"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.4 }}
                        style={{
                          backgroundColor:
                            buySellModalDetails.Type === "Buy"
                              ? "#F6FCF9"
                              : "#fff7f7",
                          border: `1px solid ${buySellModalDetails.Type === "Buy" ? "#B5E8CF" : "#F5B5B5"}`,
                        }}
                      >
                        <h6 className="fw-bold mb-3">Order Summary</h6>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">Order Type</span>
                          <span className="value">{orderType}</span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">Quantity</span>
                          <span className="value">
                            {buySellModalDetails.OrderQty} shares
                          </span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">Price per share</span>
                          <span className="value">
                            ₹{formatNumber(getPriceForCalculation())}
                          </span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">Subtotal</span>
                          <span className="value">
                            ₹
                            {formatNumber(
                              buySellModalDetails.OrderQty *
                              getPriceForCalculation(),
                            )}
                          </span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">Est. Fees</span>
                          <span className="value">₹0.00</span>
                        </div>
                        <hr />
                        <div className="order-total d-flex justify-content-between fw-bold">
                          <span>Total Amount</span>
                          <span>
                            {/* ₹{(buySellModalDetails.OrderQty * getPriceForCalculation() + 0.00).toFixed(2)} */}
                            ₹
                            {formatNumber(
                              Number(buySellModalDetails?.OrderQty || 0) *
                              Number(getPriceForCalculation() || 0),
                            )}
                          </span>
                        </div>
                      </motion.div>
                    )}
                  </motion.div>
                )}

                {/* Screen 2 */}
                {/* {isPreview && (
                  <motion.div
                    key="screen2"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <div className="text-center mb-3">
                      <div className="preview_order_icon preview_buy_order_icon">
                        <img src={ArrowTrendDown} alt="icon" />
                      </div>
                      <h5>Confirm Order</h5>
                      <p>Please review your order details</p>
                    </div>

                    <div className="order-summary-content">
                      <div className="order-row">
                        <span className="label">Quantity</span>
                        <span className="value">{buySellModalDetails.OrderQty} shares</span>
                      </div>

                      <div className="order-row">
                        <span className="label">Price per share</span>
                        <span className="value">
                          {(() => {
                            const scripCode = buySellModalDetails.order?.Exch === "N" 
                              ? buySellModalDetails.order?.NseCode 
                              : buySellModalDetails.order?.BseCode;
                            const livePrice = livePriceCache.current[scripCode];
                            const currentPrice = livePrice || buySellModalDetails.order?.CurrentPrice || 0;
                            
                            return `₹${formatNumber(currentPrice)}`;
                          })()}
                        </span>
                      </div>

                      <div className="order-row">
                        <span className="label">Subtotal</span>
                        <span className="value capitalize">
                          {(() => {
                            const scripCode = buySellModalDetails.order?.Exch === "N" 
                              ? buySellModalDetails.order?.NseCode 
                              : buySellModalDetails.order?.BseCode;
                            const livePrice = livePriceCache.current[scripCode];
                            const currentPrice = livePrice || buySellModalDetails.order?.CurrentPrice || 0;
                            const subtotal = buySellModalDetails.OrderQty * parseFloat(currentPrice);
                            
                            return `₹${subtotal.toFixed(2)}`;
                          })()}
                        </span>
                      </div>



                     <div className="order-row">
                      <span className="label">Est. fees</span>
                      <span className="value capitalize">₹0.00</span>
                    </div>
                    <div className="divider"></div>
                    <div className="order-total">
                      <span className="total-label">Total Amount</span>
                      <span className="total-value">
                        {(() => {
                          const scripCode = buySellModalDetails.order?.Exch === "N" 
                            ? buySellModalDetails.order?.NseCode 
                            : buySellModalDetails.order?.BseCode;
                          const livePrice = livePriceCache.current[scripCode];
                          const currentPrice = livePrice || buySellModalDetails.order?.CurrentPrice || 0;
                          const subtotal = buySellModalDetails.OrderQty * parseFloat(currentPrice);
                          const total = subtotal + 0.00;
                          
                          return `₹${total.toFixed(2)}`;
                        })()}
                      </span>
                    </div>

                    </div>
                  </motion.div>
                )} */}
                {/* Screen 2 */}
                {isPreview && (
                  <motion.div
                    key="screen2"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <div className="text-center mb-3">
                      <div
                        className="preview_order_icon preview_buy_order_icon"
                        style={{
                          backgroundColor:
                            buySellModalDetails.Type === "Buy"
                              ? "#E1FBE9"
                              : "#FBE1E2",
                        }}
                      >
                        {/* <img src={ArrowTrendDown} alt="icon" /> */}
                        <img
                          src={
                            buySellModalDetails.Type === "Buy"
                              ? ArrowTrendUp
                              : ArrowTrendDown
                          }
                          alt="icon"
                        />
                      </div>
                      <h5>Confirm Order</h5>
                      <p>Please review your order details</p>
                    </div>

                    <div className="order-summary-content">
                      <div className="order-row">
                        <span className="label">Order Type</span>
                        <span className="value">{orderType}</span>
                      </div>

                      <div className="order-row">
                        <span className="label">Quantity</span>
                        <span className="value">
                          {buySellModalDetails.OrderQty} shares
                        </span>
                      </div>

                      <div className="order-row">
                        <span className="label">Price per share</span>
                        <span className="value">
                          ₹{formatNumber(getPriceForCalculation())}
                        </span>
                      </div>

                      <div className="order-row">
                        <span className="label">Subtotal</span>
                        <span className="value capitalize">
                          ₹
                          {formatNumber(
                            buySellModalDetails.OrderQty *
                            getPriceForCalculation(),
                          )}
                        </span>
                      </div>

                      <div className="order-row">
                        <span className="label">Est. fees</span>
                        <span className="value capitalize">₹0.00</span>
                      </div>

                      <div className="divider"></div>

                      <div className="order-total">
                        <span className="total-label">Total Amount</span>
                        <span className="total-value">
                          ₹
                          {formatNumber(
                            Number(buySellModalDetails?.OrderQty) *
                            Number(getPriceForCalculation()),
                          )}
                        </span>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div
              className="modal-footer modal__footer_btn"
              style={{ width: "100%" }}
            >
              {!isPreview ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    gap: "0.75rem",
                  }}
                >
                  <button
                    type="button"
                    className="btn-modern btn-secondary-modern"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn-modern"
                    onClick={handlePreview}
                  >
                    Preview Order
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    gap: "0.75rem",
                  }}
                >
                  <button
                    type="button"
                    className="btn-modern btn-secondary-modern"
                    onClick={handleGoBack}
                  >
                    Go Back
                  </button>

                  <button
                    type="button"
                    className={`btn-modern ${buySellModalDetails.Type === 'Buy' ? 'btn-success-modern buy' : 'btn-success-modern sell'}`}
                    onClick={(e) => {
                      fetchDataPortfolio(
                        buySellModalDetails.order,
                        buySellModalDetails.Type,
                        "DashboardPortfolio",
                      );
                      e.target.disabled = true;
                      e.target.textContent = "Processing...";

                      setTimeout(() => {
                        setIsPreview(false); // or handleGoBack()
                        e.target.disabled = false;
                        e.target.textContent = "Confirm Order";
                      }, 1000);
                    }}
                    data-bs-dismiss="modal"
                  >
                    Confirm Order
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* MarketDepth Modal */}
      {/* Market Depth Popover */}
      {showMarketDepth && (
        <MarketDepthPopover
          popoverRef={marketDepthPopoverRef}
          position={marketDepthPosition}
          depthRows={Array.isArray(marketDepth) ? marketDepth : []}
          onClose={handleModalClose}
          tr={tr}
          formatNumber={formatNumber}
        />
      )}

      <SetTargetModal
        modalId="SetTargetModalPortfolio"
        stock={targetDetails}
        tr={tr}
        formatNumber={formatNumber}
        apiBaseUrl={pmsApiBaseUrl}
        source={targetDetails?.source === "watchlist" ? "watchlist" : "portfolio"}
        sourceWatchlist={targetDetails?.source_watchlist || ""}
        userId={sharedData?.ID}
        brokerType={
          sharedData?.broker_type || localStorage.getItem("broker_type") || ""
        }
        onSuccess={() => {
          if (targetDetails?.source === "watchlist") {
            setUpdateWatchlistTrigger((prev) => prev + 1);
          } else {
            setUpdatePortfolioTrigger((prev) => prev + 1);
          }
        }}
        showSuccessToast={showSuccessToast}
        showErrorToast={showErrorToast}
        showWarningToast={showWarningToast}
      />

      {/* Target Reason Details Modal */}
      <div
        className="modal fade"
        id="TargetReasonDetailsModal"
        aria-labelledby="TargetReasonDetailsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div
            className="modal-content border-0"
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "14px",
              boxShadow: "0 18px 40px rgba(0, 0, 0, 0.16)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                background: "#f5f6ff",
                padding: "1.2rem 1.3rem",
                position: "relative",
              }}
            >
              <button
                type="button"
                className="btn-close position-absolute"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ top: "0.9rem", right: "0.9rem", opacity: 0.6 }}
              ></button>
              <h5
                className="mb-1"
                id="TargetReasonDetailsModalLabel"
                style={{
                  color: "#000",
                  fontSize: "1rem",
                  fontWeight: 600,
                  marginRight: "2rem",
                }}
              >
                Target Reason
              </h5>
              <p
                className="mb-0"
                style={{ color: "#757575", fontSize: "0.88rem" }}
              >
                {targetReasonModalData.stockName || "-"}
              </p>
            </div>

            <div style={{ padding: "1.2rem 1.3rem 1.3rem 1.3rem" }}>
              <div style={{ marginBottom: "0.9rem" }}>
                <div
                  style={{
                    fontSize: "0.78rem",
                    fontWeight: 700,
                    color: "#475569",
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                  }}
                >
                  Reason
                </div>
                <div
                  style={{
                    marginTop: "0.35rem",
                    fontSize: "0.95rem",
                    color: "#1F2937",
                    fontWeight: 600,
                  }}
                >
                  {targetReasonModalData.reason || "-"}
                </div>
              </div>

              <div>
                <div
                  style={{
                    fontSize: "0.78rem",
                    fontWeight: 700,
                    color: "#475569",
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                  }}
                >
                  Details
                </div>
                <div
                  style={{
                    marginTop: "0.4rem",
                    fontSize: "0.92rem",
                    color: "#334155",
                    lineHeight: 1.5,
                    background: "#F8FAFC",
                    border: "1px solid #E2E8F0",
                    borderRadius: "10px",
                    padding: "0.75rem 0.85rem",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {targetReasonModalData.details ||
                    "No additional details provided."}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CDSL Authorization Modal */}

      <button
        id="openCDSLModalBtn"
        type="button"
        class="d-none"
        data-bs-toggle="modal"
        data-bs-target="#CDSLAuthorizationModal"
      ></button>

      <div
        className="modal fade"
        id="CDSLAuthorizationModal"
        aria-labelledby="CDSLAuthorizationModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div
            className="modal-content shadow-lg rounded-4"
            style={{
              backgroundColor: "#ffffffff",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              border: "2px solid #ff6b35",
            }}
          >
            <div
              className="modal-header pb-0"
              style={{ borderBottom: "2px solid #ff6b35" }}
            >
              <h5
                className="modal-title"
                id="CDSLAuthorizationModalLabel"
                style={{
                  color: "#212529",
                  fontWeight: "700",
                  fontSize: "1.5rem",
                  paddingBottom: "12px",
                }}
              >
                Authorize CDSL Access
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ filter: "brightness(0.5)" }}
              />
            </div>

            <div
              className="modal-body py-4 text-center"
              style={{ color: "#2e3031ff" }}
            >
              <div className="mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="64"
                  fill="#ff6b35"
                  className="bi bi-shield-lock"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                  <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z" />
                </svg>
              </div>

              <h3
                style={{
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#212529",
                }}
              >
                CDSL Sell Authorization Required
              </h3>

              <p
                style={{
                  fontSize: "1.05rem",
                  marginBottom: "2rem",
                  lineHeight: "1.6",
                }}
              >
                Authorize CDSL access to enable stock selling functionality.
                Without permission this feature will not be available.
              </p>

              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary px-4 py-2 fw-semibold"
                  data-bs-dismiss="modal"
                  style={{
                    borderRadius: "30px",
                    fontSize: "1rem",
                    letterSpacing: "0.03em",
                  }}
                >
                  Cancel
                </button>

                <form
                  name="CDSLAuthForm"
                  method="post"
                  action="https://dev-openapi.5paisa.com/WebVendorLogin/EDISAuthorization/Authorization"
                  target="_blank"
                  style={{ margin: 0 }}
                >
                  <input
                    type="hidden"
                    name="AccessToken"
                    value={sharedData.accessToken}
                  />
                  <input
                    type="hidden"
                    name="ClientCode"
                    value={sharedData.ClientCode}
                  />
                  <input
                    type="hidden"
                    name="VendorKey"
                    value={sharedData.api_key}
                  />
                  <input
                    type="hidden"
                    name="ResponseURL"
                    value={`https://beta.infomanav.in/zerodhaReact/authorization/${sharedData.ID}`}
                  />

                  <button
                    type="submit"
                    className="btn px-4 py-2 fw-semibold"
                    style={{
                      borderRadius: "30px",
                      fontSize: "1rem",
                      letterSpacing: "0.03em",
                      backgroundColor: "#ff6b35",
                      color: "white",
                      border: "none",
                    }}
                    data-bs-dismiss="modal"
                  >
                    Authorize
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <StockCandleModal
        isOpen={!!selectedStock}
        onClose={() => setSelectedStock(null)}
        Exch={selectedStock?.Exch}
        ExchType={selectedStock?.ExchType}
        ExchSeg={selectedStock?.ExchSeg}
        ScripCode={selectedStock?.ScripCode}
        symbolToken={
          selectedStock?.token ||
          selectedStock?.Token ||
          selectedStock?.scripcode ||
          selectedStock?.ScripCode
        }
        Name={selectedStock?.full_name || selectedStock?.name}
        Symbol={selectedStock?.name || selectedStock?.symbol}
      />

    </>
  );
}

export default Dashboard;
